var _style, _defs, _defs2, _defs3, _defs4, _rect, _defs5, _defs6, _defs7, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#FABE37;}\r\n\t.st1{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#FABD38;}\r\n\t.st2{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#FABC39;}\r\n\t.st3{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#FABB39;}\r\n\t.st4{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#FABB3A;}\r\n\t.st5{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#FABA3B;}\r\n\t.st6{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F9B93B;}\r\n\t.st7{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F9B93C;}\r\n\t.st8{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F9B83D;}\r\n\t.st9{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F9B73D;}\r\n\t.st10{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F9B63E;}\r\n\t.st11{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F9B63F;}\r\n\t.st12{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F9B53F;}\r\n\t.st13{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F9B440;}\r\n\t.st14{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F9B441;}\r\n\t.st15{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F9B341;}\r\n\t.st16{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F9B242;}\r\n\t.st17{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F9B142;}\r\n\t.st18{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F8B143;}\r\n\t.st19{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F8B044;}\r\n\t.st20{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F8AF44;}\r\n\t.st21{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F8AF45;}\r\n\t.st22{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F8AE45;}\r\n\t.st23{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F8AD46;}\r\n\t.st24{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F8AC46;}\r\n\t.st25{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F8AC47;}\r\n\t.st26{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F8AB47;}\r\n\t.st27{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F8AA48;}\r\n\t.st28{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F8A949;}\r\n\t.st29{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F8A849;}\r\n\t.st30{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F8A84A;}\r\n\t.st31{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F8A74A;}\r\n\t.st32{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F8A64B;}\r\n\t.st33{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F7A64B;}\r\n\t.st34{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F7A54C;}\r\n\t.st35{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F7A44C;}\r\n\t.st36{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F7A34D;}\r\n\t.st37{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F7A24E;}\r\n\t.st38{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F7A14E;}\r\n\t.st39{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F7A04F;}\r\n\t.st40{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F79F4F;}\r\n\t.st41{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F79F50;}\r\n\t.st42{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F79E50;}\r\n\t.st43{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F79D50;}\r\n\t.st44{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F79C51;}\r\n\t.st45{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F79B52;}\r\n\t.st46{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F69A52;}\r\n\t.st47{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F69953;}\r\n\t.st48{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F69853;}\r\n\t.st49{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F69854;}\r\n\t.st50{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F69754;}\r\n\t.st51{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F69654;}\r\n\t.st52{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F69655;}\r\n\t.st53{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F69555;}\r\n\t.st54{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F69455;}\r\n\t.st55{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F69456;}\r\n\t.st56{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F69356;}\r\n\t.st57{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F69256;}\r\n\t.st58{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F69257;}\r\n\t.st59{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F69157;}\r\n\t.st60{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F69057;}\r\n\t.st61{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F69058;}\r\n\t.st62{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F68F58;}\r\n\t.st63{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F68E58;}\r\n\t.st64{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F68D59;}\r\n\t.st65{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F68C59;}\r\n\t.st66{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F68B5A;}\r\n\t.st67{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F68A5A;}\r\n\t.st68{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F5895A;}\r\n\t.st69{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F5885B;}\r\n\t.st70{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F5875B;}\r\n\t.st71{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F5865B;}\r\n\t.st72{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F5855B;}\r\n\t.st73{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F5845B;}\r\n\t.st74{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F5835C;}\r\n\t.st75{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F5825C;}\r\n\t.st76{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F4815C;}\r\n\t.st77{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F4805C;}\r\n\t.st78{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F47F5C;}\r\n\t.st79{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F47E5C;}\r\n\t.st80{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F47D5C;}\r\n\t.st81{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F47C5C;}\r\n\t.st82{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F47B5C;}\r\n\t.st83{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F47A5D;}\r\n\t.st84{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F4795D;}\r\n\t.st85{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F3785D;}\r\n\t.st86{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F3775D;}\r\n\t.st87{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F3765D;}\r\n\t.st88{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F3755D;}\r\n\t.st89{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F3745D;}\r\n\t.st90{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F3735D;}\r\n\t.st91{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F3725D;}\r\n\t.st92{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F3715D;}\r\n\t.st93{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F3705D;}\r\n\t.st94{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F36F5D;}\r\n\t.st95{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F26E5D;}\r\n\t.st96{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F26D5D;}\r\n\t.st97{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F26C5D;}\r\n\t.st98{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F26B5D;}\r\n\t.st99{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F26A5D;}\r\n\t.st100{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F2695D;}\r\n\t.st101{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F2685D;}\r\n\t.st102{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F2675D;}\r\n\t.st103{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#F2665D;}\r\n\t.st104{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#EF665E;}\r\n\t.st105{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#ED655E;}\r\n\t.st106{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#EC655E;}\r\n\t.st107{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#EA645E;}\r\n\t.st108{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#E8645F;}\r\n\t.st109{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#E7645F;}\r\n\t.st110{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#E5635F;}\r\n\t.st111{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#E4635F;}\r\n\t.st112{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#E36360;}\r\n\t.st113{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#E26360;}\r\n\t.st114{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#E06260;}\r\n\t.st115{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#DF6261;}\r\n\t.st116{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#DE6261;}\r\n\t.st117{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#DD6261;}\r\n\t.st118{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#DC6161;}\r\n\t.st119{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#DB6162;}\r\n\t.st120{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#DA6162;}\r\n\t.st121{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#D86162;}\r\n\t.st122{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#D76163;}\r\n\t.st123{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#D66063;}\r\n\t.st124{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#D56063;}\r\n\t.st125{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#D46063;}\r\n\t.st126{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#D36064;}\r\n\t.st127{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#D26064;}\r\n\t.st128{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#D15F64;}\r\n\t.st129{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#D05F65;}\r\n\t.st130{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#CF5F65;}\r\n\t.st131{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#CE5F65;}\r\n\t.st132{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#CC5E65;}\r\n\t.st133{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#CB5E66;}\r\n\t.st134{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#CA5E66;}\r\n\t.st135{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#C95E66;}\r\n\t.st136{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#C85E67;}\r\n\t.st137{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#C75D67;}\r\n\t.st138{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#C65D67;}\r\n\t.st139{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#C55D67;}\r\n\t.st140{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#C45D68;}\r\n\t.st141{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#C35D68;}\r\n\t.st142{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#C25C68;}\r\n\t.st143{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#C15C69;}\r\n\t.st144{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#C05C69;}\r\n\t.st145{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#BF5C69;}\r\n\t.st146{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#BE5C69;}\r\n\t.st147{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#BD5B6A;}\r\n\t.st148{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#BC5B6A;}\r\n\t.st149{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#BB5B6A;}\r\n\t.st150{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#BA5B6A;}\r\n\t.st151{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#B95A6B;}\r\n\t.st152{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#B85A6B;}\r\n\t.st153{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#B75A6B;}\r\n\t.st154{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#B65A6B;}\r\n\t.st155{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#B55A6C;}\r\n\t.st156{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#B4596C;}\r\n\t.st157{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#B3596C;}\r\n\t.st158{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#B2596C;}\r\n\t.st159{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#B1596C;}\r\n\t.st160{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#B0596D;}\r\n\t.st161{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#AF586D;}\r\n\t.st162{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#AE586D;}\r\n\t.st163{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#AD586D;}\r\n\t.st164{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#AC586E;}\r\n\t.st165{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#AC576E;}\r\n\t.st166{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#AB576E;}\r\n\t.st167{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#AB566F;}\r\n\t.st168{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#AA556F;}\r\n\t.st169{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#AA5570;}\r\n\t.st170{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#AA5471;}\r\n\t.st171{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A95471;}\r\n\t.st172{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A95371;}\r\n\t.st173{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A95372;}\r\n\t.st174{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A85272;}\r\n\t.st175{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A85173;}\r\n\t.st176{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A75173;}\r\n\t.st177{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A75073;}\r\n\t.st178{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A75074;}\r\n\t.st179{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A74F74;}\r\n\t.st180{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A64F74;}\r\n\t.st181{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A64E75;}\r\n\t.st182{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A54D75;}\r\n\t.st183{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A54D76;}\r\n\t.st184{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A54C76;}\r\n\t.st185{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A44C77;}\r\n\t.st186{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A44B77;}\r\n\t.st187{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A44A77;}\r\n\t.st188{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A34A78;}\r\n\t.st189{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A34978;}\r\n\t.st190{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A24879;}\r\n\t.st191{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A24779;}\r\n\t.st192{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A1477A;}\r\n\t.st193{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A1467A;}\r\n\t.st194{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A1457A;}\r\n\t.st195{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A0457B;}\r\n\t.st196{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#A0447B;}\r\n\t.st197{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#9F437B;}\r\n\t.st198{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#9F437C;}\r\n\t.st199{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#9F427C;}\r\n\t.st200{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#9E427C;}\r\n\t.st201{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#9E417D;}\r\n\t.st202{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#9E407D;}\r\n\t.st203{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#9D407D;}\r\n\t.st204{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#9D3F7E;}\r\n\t.st205{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#9C3E7E;}\r\n\t.st206{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#9C3D7F;}\r\n\t.st207{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#9B3C7F;}\r\n\t.st208{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#9B3B80;}\r\n\t.st209{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#9A3B80;}\r\n\t.st210{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#9A3A80;}\r\n\t.st211{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#9A3A81;}\r\n\t.st212{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#993981;}\r\n\t.st213{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#993881;}\r\n\t.st214{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#983782;}\r\n\t.st215{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#983682;}\r\n\t.st216{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#973583;}\r\n\t.st217{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#973483;}\r\n\t.st218{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#963383;}\r\n\t.st219{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#963384;}\r\n\t.st220{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#963284;}\r\n\t.st221{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#953184;}\r\n\t.st222{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#953185;}\r\n\t.st223{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#953085;}\r\n\t.st224{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#942F85;}\r\n\t.st225{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#942F86;}\r\n\t.st226{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#942E86;}\r\n\t.st227{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#932E86;}\r\n\t.st228{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#932D87;}\r\n\t.st229{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#932C87;}\r\n\t.st230{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#922C87;}\r\n\t.st231{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#922B88;}\r\n\t.st232{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#922A88;}\r\n\t.st233{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#922A89;}\r\n\t.st234{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#912989;}\r\n\t.st235{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#91288A;}\r\n\t.st236{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#90288A;}\r\n\t.st237{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#90278B;}\r\n\t.st238{clip-path:url(#SVGID_00000139980422015603593340000013120391757768503427_);fill:#90268B;}\r\n\t.st239{opacity:0.28;}\r\n\t.st240{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#FABE37;}\r\n\t.st241{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#FABD38;}\r\n\t.st242{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#FABC39;}\r\n\t.st243{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#FABB39;}\r\n\t.st244{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#FABB3A;}\r\n\t.st245{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#FABA3B;}\r\n\t.st246{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F9B93B;}\r\n\t.st247{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F9B93C;}\r\n\t.st248{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F9B83D;}\r\n\t.st249{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F9B73D;}\r\n\t.st250{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F9B63E;}\r\n\t.st251{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F9B63F;}\r\n\t.st252{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F9B53F;}\r\n\t.st253{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F9B440;}\r\n\t.st254{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F9B441;}\r\n\t.st255{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F9B341;}\r\n\t.st256{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F9B242;}\r\n\t.st257{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F9B142;}\r\n\t.st258{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F8B143;}\r\n\t.st259{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F8B044;}\r\n\t.st260{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F8AF44;}\r\n\t.st261{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F8AF45;}\r\n\t.st262{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F8AE45;}\r\n\t.st263{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F8AD46;}\r\n\t.st264{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F8AC46;}\r\n\t.st265{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F8AC47;}\r\n\t.st266{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F8AB47;}\r\n\t.st267{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F8AA48;}\r\n\t.st268{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F8A949;}\r\n\t.st269{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F8A849;}\r\n\t.st270{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F8A84A;}\r\n\t.st271{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F8A74A;}\r\n\t.st272{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F8A64B;}\r\n\t.st273{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F7A64B;}\r\n\t.st274{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F7A54C;}\r\n\t.st275{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F7A44C;}\r\n\t.st276{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F7A34D;}\r\n\t.st277{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F7A24E;}\r\n\t.st278{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F7A14E;}\r\n\t.st279{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F7A04F;}\r\n\t.st280{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F79F4F;}\r\n\t.st281{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F79F50;}\r\n\t.st282{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F79E50;}\r\n\t.st283{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F79D50;}\r\n\t.st284{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F79C51;}\r\n\t.st285{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F79B52;}\r\n\t.st286{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F69A52;}\r\n\t.st287{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F69953;}\r\n\t.st288{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F69853;}\r\n\t.st289{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F69854;}\r\n\t.st290{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F69754;}\r\n\t.st291{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F69654;}\r\n\t.st292{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F69655;}\r\n\t.st293{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F69555;}\r\n\t.st294{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F69455;}\r\n\t.st295{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F69456;}\r\n\t.st296{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F69356;}\r\n\t.st297{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F69256;}\r\n\t.st298{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F69257;}\r\n\t.st299{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F69157;}\r\n\t.st300{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F69057;}\r\n\t.st301{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F69058;}\r\n\t.st302{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F68F58;}\r\n\t.st303{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F68E58;}\r\n\t.st304{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F68D59;}\r\n\t.st305{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F68C59;}\r\n\t.st306{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F68B5A;}\r\n\t.st307{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F68A5A;}\r\n\t.st308{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F5895A;}\r\n\t.st309{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F5885B;}\r\n\t.st310{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F5875B;}\r\n\t.st311{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F5865B;}\r\n\t.st312{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F5855B;}\r\n\t.st313{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F5845B;}\r\n\t.st314{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F5835C;}\r\n\t.st315{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F5825C;}\r\n\t.st316{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F4815C;}\r\n\t.st317{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F4805C;}\r\n\t.st318{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F47F5C;}\r\n\t.st319{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F47E5C;}\r\n\t.st320{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F47D5C;}\r\n\t.st321{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F47C5C;}\r\n\t.st322{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F47B5C;}\r\n\t.st323{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F47A5D;}\r\n\t.st324{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F4795D;}\r\n\t.st325{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F3785D;}\r\n\t.st326{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F3775D;}\r\n\t.st327{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F3765D;}\r\n\t.st328{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F3755D;}\r\n\t.st329{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F3745D;}\r\n\t.st330{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F3735D;}\r\n\t.st331{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F3725D;}\r\n\t.st332{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F3715D;}\r\n\t.st333{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F3705D;}\r\n\t.st334{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F36F5D;}\r\n\t.st335{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F26E5D;}\r\n\t.st336{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F26D5D;}\r\n\t.st337{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F26C5D;}\r\n\t.st338{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F26B5D;}\r\n\t.st339{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F26A5D;}\r\n\t.st340{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F2695D;}\r\n\t.st341{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F2685D;}\r\n\t.st342{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F2675D;}\r\n\t.st343{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#F2665D;}\r\n\t.st344{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#EF665E;}\r\n\t.st345{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#ED655E;}\r\n\t.st346{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#EC655E;}\r\n\t.st347{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#EA645E;}\r\n\t.st348{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#E8645F;}\r\n\t.st349{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#E7645F;}\r\n\t.st350{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#E5635F;}\r\n\t.st351{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#E4635F;}\r\n\t.st352{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#E36360;}\r\n\t.st353{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#E26360;}\r\n\t.st354{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#E06260;}\r\n\t.st355{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#DF6261;}\r\n\t.st356{clip-path:url(#SVGID_00000013153022219675465700000000414821279400657592_);fill:#DE6261;}\r\n\t.st357{clip-path:url(#SVGID_00000018216860263772319250000007141456704079700639_);}\r\n\t.st358{fill:#271007;}\r\n\t.st359{clip-path:url(#SVGID_00000044861779387958751860000018173130845723319474_);}\r\n\t.st360{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#AC586E;}\r\n\t.st361{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#AD586D;}\r\n\t.st362{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#AE586D;}\r\n\t.st363{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#AF586D;}\r\n\t.st364{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#B0596D;}\r\n\t.st365{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#B1596C;}\r\n\t.st366{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#B2596C;}\r\n\t.st367{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#B3596C;}\r\n\t.st368{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#B4596C;}\r\n\t.st369{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#B55A6C;}\r\n\t.st370{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#B65A6B;}\r\n\t.st371{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#B75A6B;}\r\n\t.st372{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#B85A6B;}\r\n\t.st373{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#B95A6B;}\r\n\t.st374{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#BA5B6A;}\r\n\t.st375{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#BB5B6A;}\r\n\t.st376{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#BC5B6A;}\r\n\t.st377{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#BD5B6A;}\r\n\t.st378{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#BE5C69;}\r\n\t.st379{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#BF5C69;}\r\n\t.st380{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#C05C69;}\r\n\t.st381{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#C15C69;}\r\n\t.st382{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#C25C68;}\r\n\t.st383{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#C35D68;}\r\n\t.st384{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#C45D68;}\r\n\t.st385{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#C55D67;}\r\n\t.st386{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#C65D67;}\r\n\t.st387{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#C75D67;}\r\n\t.st388{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#C85E67;}\r\n\t.st389{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#C95E66;}\r\n\t.st390{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#CA5E66;}\r\n\t.st391{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#CB5E66;}\r\n\t.st392{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#CC5E65;}\r\n\t.st393{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#CE5F65;}\r\n\t.st394{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#CF5F65;}\r\n\t.st395{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#D05F65;}\r\n\t.st396{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#D15F64;}\r\n\t.st397{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#D26064;}\r\n\t.st398{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#D36064;}\r\n\t.st399{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#D46063;}\r\n\t.st400{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#D56063;}\r\n\t.st401{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#D66063;}\r\n\t.st402{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#D76163;}\r\n\t.st403{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#D86162;}\r\n\t.st404{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#DA6162;}\r\n\t.st405{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#DB6162;}\r\n\t.st406{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#DC6161;}\r\n\t.st407{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#DD6261;}\r\n\t.st408{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#DE6261;}\r\n\t.st409{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#DF6261;}\r\n\t.st410{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#E06260;}\r\n\t.st411{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#E26360;}\r\n\t.st412{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#E36360;}\r\n\t.st413{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#E4635F;}\r\n\t.st414{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#E5635F;}\r\n\t.st415{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#E7645F;}\r\n\t.st416{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#E8645F;}\r\n\t.st417{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#EA645E;}\r\n\t.st418{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#EC655E;}\r\n\t.st419{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#ED655E;}\r\n\t.st420{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#EF665E;}\r\n\t.st421{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F2665D;}\r\n\t.st422{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F2675D;}\r\n\t.st423{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F2685D;}\r\n\t.st424{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F2695D;}\r\n\t.st425{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F26A5D;}\r\n\t.st426{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F26B5D;}\r\n\t.st427{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F26C5D;}\r\n\t.st428{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F26D5D;}\r\n\t.st429{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F26E5D;}\r\n\t.st430{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F36F5D;}\r\n\t.st431{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F3705D;}\r\n\t.st432{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F3715D;}\r\n\t.st433{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F3725D;}\r\n\t.st434{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F3735D;}\r\n\t.st435{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F3745D;}\r\n\t.st436{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F3755D;}\r\n\t.st437{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F3765D;}\r\n\t.st438{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F3775D;}\r\n\t.st439{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F3785D;}\r\n\t.st440{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F4795D;}\r\n\t.st441{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F47A5D;}\r\n\t.st442{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F47B5C;}\r\n\t.st443{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F47C5C;}\r\n\t.st444{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F47D5C;}\r\n\t.st445{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F47E5C;}\r\n\t.st446{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F47F5C;}\r\n\t.st447{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F4805C;}\r\n\t.st448{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F4815C;}\r\n\t.st449{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F5825C;}\r\n\t.st450{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F5835C;}\r\n\t.st451{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F5845B;}\r\n\t.st452{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F5855B;}\r\n\t.st453{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F5865B;}\r\n\t.st454{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F5875B;}\r\n\t.st455{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F5885B;}\r\n\t.st456{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F5895A;}\r\n\t.st457{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F68A5A;}\r\n\t.st458{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F68B5A;}\r\n\t.st459{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F68C59;}\r\n\t.st460{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F68D59;}\r\n\t.st461{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F68E58;}\r\n\t.st462{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F68F58;}\r\n\t.st463{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F69058;}\r\n\t.st464{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F69057;}\r\n\t.st465{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F69157;}\r\n\t.st466{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F69257;}\r\n\t.st467{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F69256;}\r\n\t.st468{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F69356;}\r\n\t.st469{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F69456;}\r\n\t.st470{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F69455;}\r\n\t.st471{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F69555;}\r\n\t.st472{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F69655;}\r\n\t.st473{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F69654;}\r\n\t.st474{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F69754;}\r\n\t.st475{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F69854;}\r\n\t.st476{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F69853;}\r\n\t.st477{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F69953;}\r\n\t.st478{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F69A52;}\r\n\t.st479{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F79B52;}\r\n\t.st480{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F79C51;}\r\n\t.st481{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F79D50;}\r\n\t.st482{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F79E50;}\r\n\t.st483{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F79F50;}\r\n\t.st484{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F79F4F;}\r\n\t.st485{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F7A04F;}\r\n\t.st486{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F7A14E;}\r\n\t.st487{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F7A24E;}\r\n\t.st488{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F7A34D;}\r\n\t.st489{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F7A44C;}\r\n\t.st490{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F7A54C;}\r\n\t.st491{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F7A64B;}\r\n\t.st492{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F8A64B;}\r\n\t.st493{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F8A74A;}\r\n\t.st494{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F8A84A;}\r\n\t.st495{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F8A849;}\r\n\t.st496{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F8A949;}\r\n\t.st497{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F8AA48;}\r\n\t.st498{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F8AB47;}\r\n\t.st499{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F8AC47;}\r\n\t.st500{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F8AC46;}\r\n\t.st501{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F8AD46;}\r\n\t.st502{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F8AE45;}\r\n\t.st503{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F8AF45;}\r\n\t.st504{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F8AF44;}\r\n\t.st505{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F8B044;}\r\n\t.st506{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F8B143;}\r\n\t.st507{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F9B142;}\r\n\t.st508{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F9B242;}\r\n\t.st509{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F9B341;}\r\n\t.st510{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F9B441;}\r\n\t.st511{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F9B440;}\r\n\t.st512{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F9B53F;}\r\n\t.st513{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F9B63F;}\r\n\t.st514{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F9B63E;}\r\n\t.st515{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F9B73D;}\r\n\t.st516{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F9B83D;}\r\n\t.st517{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F9B93C;}\r\n\t.st518{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#F9B93B;}\r\n\t.st519{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#FABA3B;}\r\n\t.st520{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#FABB3A;}\r\n\t.st521{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#FABB39;}\r\n\t.st522{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#FABC39;}\r\n\t.st523{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#FABD38;}\r\n\t.st524{clip-path:url(#SVGID_00000155841828851614791240000008464664205236981181_);fill:#FABE37;}\r\n\t.st525{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#D28146;}\r\n\t.st526{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#D18145;}\r\n\t.st527{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#D08045;}\r\n\t.st528{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#CF7F45;}\r\n\t.st529{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#CE7F45;}\r\n\t.st530{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#CD7E44;}\r\n\t.st531{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#CC7E44;}\r\n\t.st532{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#CB7D44;}\r\n\t.st533{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#CA7C43;}\r\n\t.st534{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#C97C43;}\r\n\t.st535{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#C87B43;}\r\n\t.st536{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#C77A43;}\r\n\t.st537{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#C67A42;}\r\n\t.st538{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#C57942;}\r\n\t.st539{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#C47942;}\r\n\t.st540{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#C37841;}\r\n\t.st541{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#C17741;}\r\n\t.st542{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#C07741;}\r\n\t.st543{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#BF7641;}\r\n\t.st544{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#BE7540;}\r\n\t.st545{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#BD7540;}\r\n\t.st546{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#BC7440;}\r\n\t.st547{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#BB743F;}\r\n\t.st548{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#BA733F;}\r\n\t.st549{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#B9723F;}\r\n\t.st550{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#B8723F;}\r\n\t.st551{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#B7713E;}\r\n\t.st552{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#B6713E;}\r\n\t.st553{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#B5703E;}\r\n\t.st554{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#B46F3D;}\r\n\t.st555{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#B36F3D;}\r\n\t.st556{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#B26E3D;}\r\n\t.st557{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#B16E3C;}\r\n\t.st558{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#B06D3C;}\r\n\t.st559{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#AF6C3C;}\r\n\t.st560{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#AE6C3C;}\r\n\t.st561{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#AE6B3B;}\r\n\t.st562{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#AD6B3B;}\r\n\t.st563{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#AC6A3B;}\r\n\t.st564{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#AB693A;}\r\n\t.st565{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#AA693A;}\r\n\t.st566{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#A9683A;}\r\n\t.st567{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#A86839;}\r\n\t.st568{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#A76739;}\r\n\t.st569{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#A66639;}\r\n\t.st570{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#A56639;}\r\n\t.st571{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#A46538;}\r\n\t.st572{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#A36538;}\r\n\t.st573{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#A26438;}\r\n\t.st574{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#A16337;}\r\n\t.st575{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#A06337;}\r\n\t.st576{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#9F6237;}\r\n\t.st577{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#9E6236;}\r\n\t.st578{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#9D6136;}\r\n\t.st579{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#9C6136;}\r\n\t.st580{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#9B6036;}\r\n\t.st581{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#9A5F35;}\r\n\t.st582{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#995F35;}\r\n\t.st583{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#985E35;}\r\n\t.st584{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#975E34;}\r\n\t.st585{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#965D34;}\r\n\t.st586{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#955C34;}\r\n\t.st587{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#955C33;}\r\n\t.st588{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#945B33;}\r\n\t.st589{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#935B33;}\r\n\t.st590{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#925A32;}\r\n\t.st591{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#915A32;}\r\n\t.st592{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#905932;}\r\n\t.st593{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#8F5831;}\r\n\t.st594{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#8E5831;}\r\n\t.st595{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#8D5731;}\r\n\t.st596{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#8C5731;}\r\n\t.st597{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#8B5630;}\r\n\t.st598{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#8A5630;}\r\n\t.st599{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#895530;}\r\n\t.st600{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#89542F;}\r\n\t.st601{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#88542F;}\r\n\t.st602{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#87532F;}\r\n\t.st603{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#86532E;}\r\n\t.st604{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#85522E;}\r\n\t.st605{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#84522E;}\r\n\t.st606{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#83512D;}\r\n\t.st607{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#82502D;}\r\n\t.st608{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#81502D;}\r\n\t.st609{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#804F2C;}\r\n\t.st610{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#7F4E2C;}\r\n\t.st611{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#7E4E2B;}\r\n\t.st612{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#7D4D2B;}\r\n\t.st613{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#7C4D2B;}\r\n\t.st614{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#7B4C2A;}\r\n\t.st615{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#7A4B2A;}\r\n\t.st616{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#794A29;}\r\n\t.st617{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#784A29;}\r\n\t.st618{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#774929;}\r\n\t.st619{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#764928;}\r\n\t.st620{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#754828;}\r\n\t.st621{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#744727;}\r\n\t.st622{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#734727;}\r\n\t.st623{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#724627;}\r\n\t.st624{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#714626;}\r\n\t.st625{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#704526;}\r\n\t.st626{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#704426;}\r\n\t.st627{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#6F4425;}\r\n\t.st628{clip-path:url(#SVGID_00000138558681468323830600000005781260095017894078_);fill:#6E4325;}\r\n\t.st629{fill:#DDA440;}\r\n\t.st630{fill:#261008;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 40.38,
    cy: 43.91,
    r: 10.97
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000024724012074461587710000010111341056395929753_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 46.9,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#FABE37"
    },
    width: 21.94,
    height: 7.98
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 46.83,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#FABE37"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 46.77,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#FABE37"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 46.7,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#FABD38"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 46.63,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#FABC39"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 46.56,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#FABB39"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 46.5,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#FABB3A"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 46.43,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#FABA3B"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 46.36,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F9B93B"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 46.29,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F9B93C"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 46.23,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F9B83D"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 46.16,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F9B73D"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 46.09,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F9B63E"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 46.02,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F9B63F"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 45.96,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F9B53F"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 45.89,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F9B440"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 45.82,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F9B441"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 45.75,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F9B341"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 45.69,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F9B242"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 45.62,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F9B142"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 45.55,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F8B143"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 45.49,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F8B044"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 45.42,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F8AF44"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 45.35,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F8AF45"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 45.28,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F8AE45"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 45.22,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F8AD46"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 45.15,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F8AC46"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 45.08,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F8AC47"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 45.01,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F8AB47"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 44.95,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F8AA48"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 44.88,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F8AA48"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 44.81,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F8A949"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 44.74,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F8A849"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 44.68,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F8A84A"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 44.61,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F8A74A"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 44.54,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F8A64B"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 44.47,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F7A64B"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 44.41,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F7A54C"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 44.34,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F7A44C"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 44.27,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F7A34D"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 44.2,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F7A34D"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 44.14,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F7A24E"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 44.07,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F7A14E"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 44,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F7A14E"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 43.93,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F7A04F"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 43.87,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F79F4F"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 43.8,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F79F50"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 43.73,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F79E50"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 43.66,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F79D50"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 43.6,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F79C51"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 43.53,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F79C51"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 43.46,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F79B52"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 43.39,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F69A52"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 43.33,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F69A52"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 43.26,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F69953"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 43.19,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F69853"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 43.12,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F69854"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 43.06,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F69754"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 42.99,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F69654"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 42.92,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F69655"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 42.85,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F69555"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 42.79,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F69455"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 42.72,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F69456"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 42.65,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F69356"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 42.58,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F69256"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 42.52,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F69257"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 42.45,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F69157"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 42.38,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F69057"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 42.31,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F69058"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 42.25,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F68F58"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 42.18,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F68E58"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 42.11,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F68E58"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 42.04,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F68D59"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 41.98,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F68C59"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 41.91,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F68C59"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 41.84,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F68B5A"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 41.77,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F68A5A"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 41.71,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F5895A"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 41.64,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F5895A"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 41.57,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F5885B"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 41.5,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F5875B"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 41.45,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F5875B"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 41.4,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F5875B"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 41.35,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F5865B"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 41.3,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F5855B"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 41.25,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F5855B"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 41.19,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F5845B"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 41.14,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F5835C"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 41.09,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F5825C"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 41.04,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F5825C"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 40.99,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F4815C"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 40.93,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F4805C"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 40.88,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F47F5C"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 40.83,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F47F5C"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 40.78,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F47E5C"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 40.73,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F47D5C"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 40.68,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F47D5C"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 40.62,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F47C5C"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 40.57,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F47B5C"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 40.52,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F47A5D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 40.47,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F47A5D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 40.42,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F4795D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 40.36,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F3785D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 40.31,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F3775D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 40.26,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F3775D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 40.21,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F3765D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 40.16,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F3755D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 40.11,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F3745D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 40.05,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F3735D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 40,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F3735D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.95,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F3725D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.9,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F3715D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.85,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F3705D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.8,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F36F5D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.74,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F36F5D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.69,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F26E5D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.64,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F26D5D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.59,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F26C5D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.54,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F26B5D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.48,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F26A5D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.43,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F2695D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.38,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F2695D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.33,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F2685D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.28,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F2675D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.23,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F2665D"
    },
    width: 21.94,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.18,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#F2665D"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.14,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#EF665E"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.1,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#ED655E"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.06,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#EC655E"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.02,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#EA645E"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.98,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#E8645F"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.94,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#E7645F"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.9,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#E5635F"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.86,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#E4635F"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.82,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#E36360"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.78,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#E26360"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.74,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#E06260"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.7,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#DF6261"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.66,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#DE6261"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.62,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#DD6261"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.58,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#DC6161"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.53,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#DB6162"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.49,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#DA6162"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.45,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#D86162"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.41,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#D76163"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.37,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#D66063"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.33,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#D56063"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.29,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#D46063"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.25,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#D36064"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.21,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#D26064"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.17,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#D15F64"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.13,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#D05F65"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.09,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#CF5F65"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.05,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#CE5F65"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.01,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#CC5E65"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.97,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#CB5E66"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.93,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#CA5E66"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.88,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#C95E66"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.84,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#C85E67"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.8,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#C75D67"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.76,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#C65D67"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.72,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#C55D67"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.68,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#C45D68"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.64,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#C35D68"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.6,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#C25C68"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.56,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#C15C69"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.52,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#C05C69"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.48,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#BF5C69"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.44,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#BE5C69"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.4,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#BD5B6A"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.36,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#BC5B6A"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.32,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#BB5B6A"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.28,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#BA5B6A"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.23,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#B95A6B"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.19,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#B85A6B"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.15,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#B75A6B"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.11,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#B65A6B"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.07,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#B55A6C"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.03,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#B4596C"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.99,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#B3596C"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.95,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#B2596C"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.91,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#B1596C"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.87,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#B0596D"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.83,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#AF586D"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.79,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#AE586D"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.75,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#AD586D"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.71,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#AC586E"
    },
    width: 21.94,
    height: 0.04
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.68,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#AC586E"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.65,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#AC576E"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.61,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#AB576E"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.58,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#AB566F"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.55,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#AB566F"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.52,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#AA556F"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.49,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#AA5570"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.46,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#AA5570"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.43,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#AA5471"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.4,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A95471"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.37,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A95371"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.34,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A95372"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.31,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A85272"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.28,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A85272"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.25,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A85173"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.22,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A75173"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.19,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A75073"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.15,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A75074"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.12,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A74F74"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.09,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A64F74"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.06,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A64E75"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.03,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A64E75"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A54D75"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.97,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A54D76"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.94,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A54C76"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.91,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A44C77"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.88,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A44B77"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.85,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A44B77"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.82,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A44A77"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.79,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A34A78"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.76,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A34978"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.73,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A34978"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.7,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A24879"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.66,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A24879"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.63,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A24779"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.6,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A1477A"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.57,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A1467A"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.54,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A1457A"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.51,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A0457B"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.48,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A0447B"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.45,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#A0447B"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.42,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#9F437B"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.39,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#9F437C"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.36,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#9F427C"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.33,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#9E427C"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.3,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#9E417D"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.27,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#9E407D"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.24,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#9D407D"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.2,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#9D3F7E"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.17,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#9D3F7E"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.14,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#9C3E7E"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.11,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#9C3E7E"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.08,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#9C3D7F"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.05,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#9B3C7F"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.02,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#9B3C7F"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.99,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#9B3B80"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.96,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#9A3B80"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.93,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#9A3A80"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.9,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#9A3A81"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.87,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#993981"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.84,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#993881"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.81,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#993881"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.78,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#983782"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.74,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#983682"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.71,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#983682"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.68,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#973583"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.65,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#973483"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.62,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#973483"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.59,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#963383"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.56,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#963384"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.53,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#963284"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.5,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#953184"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.47,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#953185"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.44,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#953085"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.41,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#942F85"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.38,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#942F86"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.35,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#942E86"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.32,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#932E86"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.28,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#932D87"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.25,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#932C87"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.22,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#922C87"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.19,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#922B88"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.16,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#922A88"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.13,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#922A89"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.1,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#912989"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.07,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#912989"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.04,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#91288A"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.01,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#90288A"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 33.98,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#90278B"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 33.95,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#90268B"
    },
    width: 21.94,
    height: 0.03
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 32.94,
    style: {
      clipPath: "url(#SVGID_00000024724012074461587710000010111341056395929753_)",
      fill: "#90268B"
    },
    width: 21.94,
    height: 1.01
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st239"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000052816401325795552750000002877590192762827945_",
    d: "M51.35,36.2c0-6.06-4.91-10.97-10.97-10.97 c-6.06,0-10.97,4.91-10.97,10.97c0,1.36,0.25,2.67,0.7,3.87l20.54,0C51.1,38.87,51.35,37.56,51.35,36.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000157997535362012274430000014582160413649235871_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052816401325795552750000002877590192762827945_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 25.23,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#FABE37"
    },
    width: 21.94,
    height: 3.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 28.53,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#FABE37"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 28.61,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#FABE37"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 28.69,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#FABD38"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 28.77,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#FABC39"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 28.85,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#FABB39"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 28.93,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#FABB3A"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 29.01,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#FABA3B"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 29.09,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F9B93B"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 29.17,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F9B93C"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 29.24,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F9B83D"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 29.32,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F9B73D"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 29.4,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F9B63E"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 29.48,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F9B63F"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 29.56,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F9B53F"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 29.64,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F9B440"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 29.72,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F9B441"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 29.8,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F9B341"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 29.88,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F9B242"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 29.96,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F9B142"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 30.04,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F8B143"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 30.12,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F8B044"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 30.2,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F8AF44"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 30.28,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F8AF45"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 30.36,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F8AE45"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 30.44,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F8AD46"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 30.52,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F8AC46"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 30.6,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F8AC47"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 30.67,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F8AB47"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 30.75,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F8AA48"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 30.83,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F8AA48"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 30.91,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F8A949"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 30.99,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F8A849"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 31.07,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F8A84A"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 31.15,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F8A74A"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 31.23,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F8A64B"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 31.31,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F7A64B"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 31.39,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F7A54C"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 31.47,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F7A44C"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 31.55,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F7A34D"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 31.63,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F7A34D"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 31.71,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F7A24E"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 31.79,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F7A14E"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 31.87,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F7A14E"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 31.95,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F7A04F"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 32.03,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F79F4F"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 32.11,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F79F50"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 32.18,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F79E50"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 32.26,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F79D50"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 32.34,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F79C51"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 32.42,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F79C51"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 32.5,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F79B52"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 32.58,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F69A52"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 32.66,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F69A52"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 32.74,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F69953"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 32.82,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F69853"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 32.9,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F69854"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 32.98,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F69754"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 33.06,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F69654"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 33.14,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F69655"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 33.22,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F69555"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 33.3,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F69455"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 33.38,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F69456"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 33.46,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F69356"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 33.54,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F69256"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 33.62,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F69257"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 33.69,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F69157"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 33.77,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F69057"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 33.85,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F69058"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 33.93,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F68F58"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.01,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F68E58"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.09,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F68E58"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.17,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F68D59"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.25,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F68C59"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.33,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F68C59"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.41,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F68B5A"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.49,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F68A5A"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.57,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F5895A"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.65,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F5895A"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.73,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F5885B"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.81,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F5875B"
    },
    width: 21.94,
    height: 0.08
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.89,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F5875B"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 34.98,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F5875B"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.08,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F5865B"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.17,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F5855B"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.27,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F5855B"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.36,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F5845B"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.46,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F5835C"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.55,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F5825C"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.65,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F5825C"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.75,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F4815C"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.84,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F4805C"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 35.94,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F47F5C"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.03,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F47F5C"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.13,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F47E5C"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.22,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F47D5C"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.32,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F47D5C"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.41,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F47C5C"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.51,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F47B5C"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.6,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F47A5D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.7,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F47A5D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.79,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F4795D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.89,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F3785D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 36.99,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F3775D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.08,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F3775D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.18,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F3765D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.27,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F3755D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.37,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F3745D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.46,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F3735D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.56,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F3735D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.65,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F3725D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.75,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F3715D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.84,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F3705D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 37.94,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F36F5D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.04,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F36F5D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.13,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F26E5D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.23,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F26D5D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.32,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F26C5D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.42,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F26B5D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.51,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F26A5D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.61,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F2695D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.7,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F2695D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.8,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F2685D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.89,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F2675D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 38.99,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F2665D"
    },
    width: 21.94,
    height: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.08,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#F2665D"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.16,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#EF665E"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.23,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#ED655E"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.3,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#EC655E"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.37,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#EA645E"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.44,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#E8645F"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.51,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#E7645F"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.59,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#E5635F"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.66,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#E4635F"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.73,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#E36360"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.8,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#E26360"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.87,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#E06260"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 39.94,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#DF6261"
    },
    width: 21.94,
    height: 0.07
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.41,
    y: 40.02,
    style: {
      clipPath: "url(#SVGID_00000157997535362012274430000014582160413649235871_)",
      fill: "#DE6261"
    },
    width: 21.94,
    height: 0.05
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000035531705745578637780000003020848582605071280_",
    x: -5.15,
    y: -6.38,
    width: 91.43,
    height: 91.43
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000044861933460973498130000014022540497622409658_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000035531705745578637780000003020848582605071280_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000051376888612521810340000010336966730260237721_",
    cx: 40.56,
    cy: 40.07,
    r: 35.51
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000144304908447255020410000009191373551234232726_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000051376888612521810340000010336966730260237721_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000144304908447255020410000009191373551234232726_)"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -5.15,
    y: 57.1,
    className: "st358",
    width: 91.43,
    height: 47.17
  })))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000066495905656900068760000005135054793687992983_",
    cx: 40.56,
    cy: 40.07,
    r: 35.51
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000159456177885776892150000004734495711588265362_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000066495905656900068760000005135054793687992983_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000159456177885776892150000004734495711588265362_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000101077048161115040720000002670733778875753917_",
    x: -31.86,
    y: -4.16,
    width: 144.85,
    height: 79.74
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000161626967890281336800000009925297775754565254_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000101077048161115040720000002670733778875753917_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: -31.86,
    y: -4.16,
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#AC586E"
    },
    width: 144.85,
    height: 79.74
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#AC586E"
    },
    d: "M41.87-4.6h37.2 v-2.01c11.4,4.64,21.63,11.27,30.18,19.4c2.14,2.03,4.17,4.16,6.09,6.37h-1.92v56.86H-32.3V16.98h-0.26 c1.99-2.16,4.08-4.22,6.28-6.19c4.39-3.94,9.2-7.49,14.34-10.59c2.57-1.55,5.23-2.99,7.97-4.31c1.37-0.66,2.76-1.29,4.16-1.89 v1.4H41.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#AC586E"
    },
    d: "M41.76-6.58 c24.21,0.36,46,9.74,61.65,24.61c3.91,3.72,7.44,7.78,10.53,12.13h-0.5v45.86H-32.3V31.26h-1.5c0.75-1.1,1.53-2.18,2.33-3.25 c3.21-4.26,6.86-8.21,10.88-11.82C-4.51,1.79,17.55-6.94,41.76-6.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#AC586E"
    },
    d: "M41.65,0.95 C63.6,1.27,83.36,9.78,97.55,23.27c7.1,6.75,12.8,14.74,16.7,23.57h-0.82v29.18H-32.3V51.38h-2.75c0.81-2.29,1.74-4.52,2.77-6.7 c4.15-8.72,10.09-16.54,17.38-23.07C-0.31,8.54,19.69,0.62,41.65,0.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#AD586D"
    },
    d: "M41.64,1.24 c21.87,0.32,41.55,8.8,55.69,22.23c7.07,6.72,12.75,14.68,16.63,23.48h-0.53v29.07H-32.3V51.47h-2.45 c0.81-2.28,1.73-4.5,2.76-6.68c4.14-8.68,10.05-16.47,17.32-22.98C-0.15,8.8,19.77,0.92,41.64,1.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#AE586D"
    },
    d: "M41.64,1.53 c21.78,0.32,41.38,8.76,55.47,22.14c7.04,6.69,12.7,14.62,16.56,23.39h-0.24v28.96H-32.3V51.56h-2.15 c0.8-2.27,1.72-4.49,2.75-6.65c4.12-8.65,10.01-16.41,17.25-22.89C0.01,9.06,19.85,1.21,41.64,1.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#AF586D"
    },
    d: "M41.63,1.82 c21.7,0.32,41.22,8.73,55.24,22.06c7.01,6.67,12.65,14.56,16.5,23.29c0.96,2.18,1.81,4.42,2.54,6.7h-2.49v22.15H-32.3V51.65 h-1.85c0.8-2.26,1.71-4.47,2.74-6.62c4.1-8.62,9.97-16.34,17.18-22.8C0.17,9.32,19.94,1.5,41.63,1.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#B0596D"
    },
    d: "M41.63,2.11 c21.61,0.32,41.05,8.69,55.02,21.97c6.98,6.64,12.6,14.5,16.43,23.2c0.96,2.17,1.8,4.4,2.53,6.67h-2.19v22.07H-32.3V51.74h-1.55 c0.8-2.25,1.71-4.45,2.73-6.6c4.09-8.58,9.93-16.28,17.11-22.71C0.34,9.58,20.02,1.79,41.63,2.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#B1596C"
    },
    d: "M41.63,2.4 c21.52,0.32,40.89,8.66,54.8,21.88c6.96,6.61,12.55,14.45,16.37,23.11c0.95,2.17,1.8,4.38,2.52,6.65h-1.89v21.99H-32.3V51.83 h-1.26c0.79-2.24,1.7-4.43,2.72-6.57c4.07-8.55,9.89-16.21,17.04-22.62C0.5,9.84,20.1,2.08,41.63,2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#B2596C"
    },
    d: "M41.62,2.69 C63.06,3,82.35,11.31,96.2,24.48c6.93,6.59,12.5,14.39,16.3,23.02c0.95,2.16,1.79,4.37,2.51,6.62h-1.59v21.91H-32.3V58.76h-2.97 c1.1-4.65,2.69-9.12,4.72-13.38c4.05-8.51,9.85-16.15,16.97-22.52C0.66,10.1,20.18,2.37,41.62,2.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#B3596C"
    },
    d: "M41.62,2.98 c21.35,0.32,40.56,8.59,54.36,21.7c6.9,6.56,12.45,14.33,16.23,22.92c1.89,4.3,3.35,8.8,4.31,13.46h-3.09v14.96H-32.3v-17.2 h-2.66c1.1-4.63,2.68-9.09,4.7-13.33c4.04-8.48,9.81-16.08,16.9-22.43C0.82,10.36,20.27,2.66,41.62,2.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#B4596C"
    },
    d: "M41.61,3.27 c21.26,0.31,40.4,8.55,54.14,21.62c6.87,6.53,12.4,14.27,16.17,22.83c1.89,4.28,3.33,8.76,4.29,13.4h-2.78v14.91H-32.3V58.89 h-2.36c1.09-4.61,2.67-9.05,4.68-13.27c4.02-8.44,9.77-16.02,16.83-22.34C0.98,10.62,20.35,2.95,41.61,3.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#B55A6C"
    },
    d: "M41.61,3.56 c21.18,0.31,40.23,8.52,53.92,21.53c6.84,6.51,12.35,14.21,16.1,22.74c1.88,4.26,3.32,8.73,4.27,13.35h-2.47v14.85H-32.3V58.95 h-2.05c1.09-4.59,2.66-9.01,4.66-13.22c4.01-8.41,9.73-15.95,16.77-22.25C1.14,10.88,20.43,3.25,41.61,3.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#B65A6B"
    },
    d: "M41.6,3.85 c21.09,0.31,40.07,8.48,53.7,21.44c6.82,6.48,12.3,14.15,16.04,22.64c1.87,4.24,3.31,8.69,4.25,13.29h-2.16v14.8H-32.3V59.01 h-1.74c1.09-4.57,2.65-8.98,4.65-13.16c3.99-8.37,9.69-15.88,16.7-22.16C1.31,11.14,20.51,3.54,41.6,3.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#B75A6B"
    },
    d: "M41.6,4.14 c21,0.31,39.9,8.45,53.48,21.35c6.79,6.45,12.25,14.1,15.97,22.55c1.86,4.23,3.29,8.66,4.24,13.24h-1.85v14.74H-32.3V59.08 h-1.44c1.08-4.55,2.64-8.94,4.63-13.11c3.97-8.34,9.65-15.82,16.63-22.07C1.47,11.4,20.6,3.83,41.6,4.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#B85A6B"
    },
    d: "M41.6,4.43 c20.92,0.31,39.74,8.41,53.26,21.26c6.76,6.43,12.19,14.04,15.9,22.46s5.69,17.64,5.55,27.29h-2.88v0.58H-32.3V73.2h-2.88 C-34.61,34.6-0.24,3.81,41.6,4.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#B95A6B"
    },
    d: "M41.59,4.72 c20.83,0.31,39.57,8.38,53.03,21.17s21.65,30.32,21.37,49.54h-2.56v0.59H-32.3v-2.81h-2.56C-34.3,34.77-0.07,4.1,41.59,4.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#BA5B6A"
    },
    d: "M41.59,5.01 c41.48,0.61,74.66,32.14,74.09,70.42h-2.25v0.59H-32.3v-2.81h-2.25C-33.99,34.93,0.1,4.4,41.59,5.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#BB5B6A"
    },
    d: "M41.58,5.3 c41.31,0.61,74.34,32.01,73.78,70.13h-1.93v0.6H-32.3v-2.8h-1.93C-33.67,35.1,0.27,4.69,41.58,5.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#BC5B6A"
    },
    d: "M41.58,5.59 c41.14,0.61,74.03,31.87,73.47,69.83h-1.62v0.6H-32.3v-2.8h-1.62C-33.36,35.26,0.44,4.98,41.58,5.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#BD5B6A"
    },
    d: "M41.57,5.88 c40.96,0.6,73.72,31.74,73.16,69.54h-1.3v0.6H-32.3v-2.79h-1.3C-33.05,35.43,0.61,5.27,41.57,5.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#BE5C69"
    },
    d: "M41.57,6.17 c40.79,0.6,73.41,31.6,72.85,69.24h-0.99v0.61H-32.3v-2.79h-0.99C-32.74,35.59,0.78,5.57,41.57,6.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#BF5C69"
    },
    d: "M41.57,6.46 c40.62,0.6,73.09,31.47,72.54,68.95h-0.68v0.61H-32.3v-2.79h-0.68C-32.43,35.76,0.95,5.86,41.57,6.46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#C05C69"
    },
    d: "M41.56,6.75 C82,7.34,114.34,38.08,113.79,75.4h-0.36v0.62H-32.3v-2.78h-0.36C-32.11,35.92,1.12,6.15,41.56,6.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#C15C69"
    },
    d: "M41.56,7.04 c40.27,0.59,72.47,31.2,71.92,68.36c-0.02,1.16-0.07,2.32-0.15,3.46v-2.84H-32.3v-2.78h-0.05C-31.8,36.09,1.29,6.44,41.56,7.04z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#C25C68"
    },
    d: "M41.55,7.33 c40.1,0.59,72.16,31.07,71.61,68.07c-0.02,1.16-0.07,2.31-0.15,3.45v-2.82H-31.99v0.68c-0.05-1.14-0.06-2.29-0.04-3.45 C-31.49,36.25,1.46,6.74,41.55,7.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#C35D68"
    },
    d: "M41.55,7.62 c39.92,0.59,71.84,30.93,71.3,67.77c-0.02,1.15-0.07,2.3-0.14,3.43v-2.8H-31.68v0.67c-0.05-1.14-0.06-2.28-0.04-3.43 C-31.18,36.41,1.63,7.03,41.55,7.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#C45D68"
    },
    d: "M41.54,7.91 c39.75,0.59,71.53,30.8,70.99,67.48c-0.02,1.15-0.07,2.29-0.14,3.42v-2.78H-31.36v0.66c-0.05-1.13-0.06-2.27-0.04-3.42 C-30.87,36.58,1.8,7.32,41.54,7.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#C55D67"
    },
    d: "M41.54,8.2 c39.58,0.58,71.22,30.66,70.68,67.18c-0.02,1.14-0.06,2.28-0.14,3.4v-2.76H-31.05v0.65c-0.05-1.13-0.06-2.26-0.04-3.4 C-30.55,36.74,1.96,7.61,41.54,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#C65D67"
    },
    d: "M41.54,8.49 c39.4,0.58,70.91,30.53,70.37,66.89c-0.02,1.14-0.06,2.27-0.14,3.39v-2.74h-142.5v0.64c-0.05-1.12-0.06-2.25-0.04-3.39 C-30.24,36.91,2.13,7.91,41.54,8.49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#C75D67"
    },
    d: "M41.53,8.78 c39.23,0.58,70.6,30.39,70.06,66.59c-0.02,1.13-0.06,2.26-0.14,3.37v-2.72H-30.42v0.63c-0.04-1.12-0.06-2.24-0.04-3.37 C-29.93,37.07,2.3,8.2,41.53,8.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#C85E67"
    },
    d: "M41.53,9.07 c39.05,0.58,70.28,30.26,69.75,66.3c-0.02,1.13-0.06,2.25-0.14,3.36v-2.7H-30.11v0.62c-0.04-1.11-0.06-2.23-0.04-3.36 C-29.62,37.24,2.47,8.49,41.53,9.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#C95E66"
    },
    d: "M41.52,9.36 c38.88,0.57,69.97,30.12,69.44,66c-0.02,1.12-0.06,2.24-0.14,3.34v-2.68H-29.79v0.61c-0.04-1.11-0.06-2.22-0.04-3.34 C-29.31,37.4,2.64,8.78,41.52,9.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#CA5E66"
    },
    d: "M41.52,9.65 c38.71,0.57,69.66,29.99,69.13,65.71c-0.02,1.12-0.06,2.23-0.14,3.33v-2.66H-29.48v0.6c-0.04-1.1-0.06-2.21-0.04-3.33 C-29,37.57,2.81,9.08,41.52,9.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#CB5E66"
    },
    d: "M41.51,9.94 c38.53,0.57,69.35,29.86,68.82,65.41c-0.02,1.11-0.06,2.22-0.14,3.31v-2.64H-29.17v0.58c-0.04-1.1-0.06-2.2-0.04-3.31 C-28.68,37.73,2.98,9.37,41.51,9.94z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#CC5E65"
    },
    d: "M41.51,10.23 c38.36,0.57,69.03,29.72,68.51,65.12c-0.02,1.11-0.06,2.21-0.14,3.3v-2.62H-28.85v0.57c-0.04-1.09-0.06-2.19-0.04-3.3 C-28.37,37.9,3.15,9.66,41.51,10.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#CE5F65"
    },
    d: "M41.51,10.52 c38.19,0.56,68.72,29.59,68.2,64.83c-0.02,1.1-0.06,2.2-0.14,3.28v-2.6H-28.54v0.56c-0.04-1.09-0.06-2.18-0.04-3.28 C-28.06,38.06,3.32,9.95,41.51,10.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#CF5F65"
    },
    d: "M41.5,10.81 c38.01,0.56,68.41,29.45,67.89,64.53c-0.02,1.1-0.06,2.19-0.14,3.27v-2.58H-28.22v0.55c-0.04-1.08-0.06-2.17-0.04-3.27 C-27.75,38.23,3.49,10.25,41.5,10.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#D05F65"
    },
    d: "M41.5,11.1 c37.84,0.56,68.1,29.32,67.58,64.24c-0.02,1.09-0.06,2.18-0.14,3.25v-2.56H-27.91v0.54c-0.04-1.08-0.06-2.16-0.04-3.25 C-27.44,38.39,3.66,10.54,41.5,11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#D15F64"
    },
    d: "M41.49,11.39 c37.67,0.56,67.78,29.18,67.27,63.94c-0.02,1.09-0.06,2.17-0.14,3.24v-2.54H-27.6v0.53c-0.04-1.07-0.06-2.15-0.04-3.24 C-27.12,38.56,3.83,10.83,41.49,11.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#D26064"
    },
    d: "M41.49,11.68 c37.49,0.55,67.47,29.05,66.96,63.65c-0.02,1.08-0.06,2.16-0.14,3.22v-2.53h-135.6v0.52c-0.04-1.07-0.06-2.14-0.04-3.22 C-26.81,38.72,4,11.12,41.49,11.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#D36064"
    },
    d: "M41.48,11.97 c37.32,0.55,67.16,28.91,66.65,63.35c-0.02,1.08-0.06,2.15-0.14,3.21v-2.51H-26.97v0.51c-0.04-1.06-0.06-2.13-0.04-3.21 C-26.5,38.89,4.16,11.42,41.48,11.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#D46063"
    },
    d: "M41.48,12.26 c37.15,0.55,66.85,28.78,66.34,63.06c-0.02,1.07-0.06,2.14-0.13,3.19v-2.49H-26.65v0.5c-0.04-1.06-0.06-2.12-0.04-3.2 C-26.19,39.05,4.33,11.71,41.48,12.26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#D56063"
    },
    d: "M41.48,12.55 c36.97,0.55,66.53,28.65,66.03,62.76c-0.02,1.07-0.06,2.13-0.13,3.18v-2.47H-26.34v0.49c-0.04-1.05-0.06-2.11-0.04-3.18 C-25.88,39.22,4.5,12,41.48,12.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#D66063"
    },
    d: "M41.47,12.84 c36.8,0.54,66.22,28.51,65.72,62.47c-0.02,1.06-0.06,2.12-0.13,3.16v-2.45H-26.03v0.48c-0.04-1.05-0.06-2.1-0.04-3.17 C-25.56,39.38,4.67,12.29,41.47,12.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#D76163"
    },
    d: "M41.47,13.13 c36.62,0.54,65.91,28.38,65.41,62.17c-0.02,1.06-0.06,2.11-0.13,3.15v-2.43H-25.71v0.47c-0.04-1.04-0.06-2.09-0.04-3.15 C-25.25,39.55,4.84,12.59,41.47,13.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#D86162"
    },
    d: "M41.46,13.42 c36.45,0.54,65.6,28.24,65.1,61.88c-0.02,1.05-0.06,2.1-0.13,3.13v-2.41H-25.4v0.46c-0.04-1.04-0.06-2.08-0.04-3.14 C-24.94,39.71,5.01,12.88,41.46,13.42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#DA6162"
    },
    d: "M41.46,13.71 c36.28,0.54,65.29,28.11,64.79,61.58c-0.02,1.05-0.06,2.09-0.13,3.12v-2.39h-131.2v0.45c-0.04-1.03-0.05-2.07-0.04-3.12 C-24.63,39.88,5.18,13.17,41.46,13.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#DB6162"
    },
    d: "M41.45,14 c36.1,0.53,64.97,27.97,64.48,61.29c-0.02,1.04-0.06,2.08-0.13,3.1v-2.37H-24.77v0.44c-0.04-1.03-0.05-2.06-0.04-3.11 C-24.32,40.04,5.35,13.46,41.45,14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#DC6161"
    },
    d: "M41.45,14.29 c35.93,0.53,64.66,27.84,64.17,60.99c-0.02,1.04-0.06,2.07-0.13,3.09v-2.35H-24.46v0.43c-0.04-1.02-0.05-2.05-0.04-3.09 C-24,40.21,5.52,13.76,41.45,14.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#DD6261"
    },
    d: "M41.45,14.58 c35.76,0.53,64.35,27.7,63.86,60.7c-0.02,1.03-0.06,2.06-0.13,3.07v-2.33H-24.14v0.42c-0.04-1.02-0.05-2.04-0.04-3.08 C-23.69,40.37,5.69,14.05,41.45,14.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#DE6261"
    },
    d: "M41.44,14.87 c35.58,0.53,64.04,27.57,63.55,60.41c-0.02,1.03-0.06,2.05-0.13,3.06v-2.31H-23.83v0.41c-0.04-1.01-0.05-2.03-0.04-3.06 C-23.38,40.53,5.86,14.34,41.44,14.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#DF6261"
    },
    d: "M41.44,15.16 c35.41,0.52,63.72,27.44,63.24,60.11c-0.02,1.02-0.06,2.04-0.13,3.04v-2.29H-23.51v0.4c-0.04-1.01-0.05-2.02-0.04-3.05 C-23.07,40.7,6.03,14.63,41.44,15.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#E06260"
    },
    d: "M41.43,15.45 c35.24,0.52,63.41,27.3,62.93,59.82c-0.01,1.02-0.06,2.03-0.13,3.03v-2.27H-23.2v0.39c-0.04-1-0.05-2.01-0.04-3.03 C-22.76,40.86,6.2,14.93,41.43,15.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#E26360"
    },
    d: "M41.43,15.74 c35.06,0.52,63.1,27.17,62.62,59.52c-0.01,1.01-0.06,2.02-0.13,3.01v-2.25H-22.89v0.38c-0.04-1-0.05-2-0.04-3.02 C-22.45,41.03,6.37,15.22,41.43,15.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#E36360"
    },
    d: "M41.42,16.03 c34.89,0.52,62.79,27.03,62.31,59.23c-0.01,1.01-0.06,2.01-0.13,3v-2.23H-22.57v0.37c-0.04-0.99-0.05-1.99-0.04-3 C-22.13,41.19,6.53,15.51,41.42,16.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#E4635F"
    },
    d: "M41.42,16.32 c34.72,0.51,62.47,26.9,62,58.93c-0.01,1-0.06,2-0.13,2.98v-2.21H-22.26v0.36c-0.04-0.99-0.05-1.99-0.04-2.99 C-21.82,41.36,6.7,15.8,41.42,16.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#E5635F"
    },
    d: "M41.42,16.61 c34.54,0.51,62.16,26.76,61.69,58.64c-0.01,1-0.06,1.99-0.13,2.97v-2.19H-21.94v0.35c-0.04-0.98-0.05-1.98-0.04-2.97 C-21.51,41.52,6.87,16.1,41.42,16.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#E7645F"
    },
    d: "M41.41,16.9 c34.37,0.51,61.85,26.63,61.38,58.34c-0.01,0.99-0.06,1.98-0.12,2.95v-2.17h-124.3v0.34c-0.04-0.98-0.05-1.97-0.04-2.96 C-21.2,41.69,7.04,16.39,41.41,16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#E8645F"
    },
    d: "M41.41,17.19 c34.19,0.5,61.54,26.49,61.07,58.05c-0.01,0.99-0.06,1.97-0.12,2.94v-2.15H-21.31v0.33c-0.04-0.97-0.05-1.96-0.04-2.94 C-20.89,41.85,7.21,16.68,41.41,17.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#EA645E"
    },
    d: "M41.4,17.48 c34.02,0.5,61.23,26.36,60.76,57.75c-0.01,0.98-0.06,1.96-0.12,2.92v-2.13H-21v0.32c-0.04-0.97-0.05-1.95-0.04-2.93 C-20.57,42.02,7.38,16.97,41.4,17.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#EC655E"
    },
    d: "M41.4,17.77 c33.85,0.5,60.91,26.23,60.45,57.46c-0.01,0.98-0.06,1.95-0.12,2.91v-2.11H-20.69v0.31c-0.04-0.96-0.05-1.94-0.04-2.91 C-20.26,42.18,7.55,17.27,41.4,17.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#ED655E"
    },
    d: "M41.39,18.06 c33.67,0.5,60.6,26.09,60.14,57.16c-0.01,0.97-0.06,1.94-0.12,2.89v-2.09H-20.37v0.3c-0.04-0.96-0.05-1.93-0.04-2.9 C-19.95,42.35,7.72,17.56,41.39,18.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#EF665E"
    },
    d: "M41.39,18.35 c33.5,0.49,60.29,25.96,59.83,56.87c-0.01,0.97-0.05,1.93-0.12,2.88v-2.08H-20.06v0.29c-0.04-0.95-0.05-1.92-0.04-2.88 C-19.64,42.51,7.89,17.85,41.39,18.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F2665D"
    },
    d: "M41.39,18.64 c33.33,0.49,59.98,25.82,59.52,56.58c-0.01,0.96-0.05,1.92-0.12,2.86v-2.06H-19.74v0.28c-0.04-0.95-0.05-1.91-0.04-2.87 C-19.33,42.68,8.06,18.15,41.39,18.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F2665D"
    },
    d: "M41.38,18.93 c33.15,0.49,59.66,25.69,59.21,56.28c-0.01,0.96-0.05,1.91-0.12,2.85v-2.04H-19.24v3.08c-0.18-1.87-0.25-3.76-0.23-5.67 C-19.01,42.84,8.23,18.44,41.38,18.93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F2675D"
    },
    d: "M41.38,19.31 c32.92,0.49,59.25,25.51,58.8,55.89c-0.01,0.95-0.05,1.89-0.12,2.83v-2.01H-18.82v3.05c-0.18-1.85-0.25-3.73-0.22-5.63 C-18.6,43.06,8.45,18.83,41.38,19.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F2685D"
    },
    d: "M41.37,19.7 c32.69,0.48,58.83,25.33,58.39,55.5c-0.01,0.94-0.05,1.88-0.12,2.81v-1.98H-18.41v3.02c-0.17-1.84-0.25-3.7-0.22-5.59 C-18.18,43.28,8.68,19.22,41.37,19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F2695D"
    },
    d: "M41.36,20.09 c32.46,0.48,58.41,25.15,57.97,55.1c-0.01,0.94-0.05,1.87-0.12,2.79v-1.96H-17.99V79c-0.17-1.83-0.25-3.68-0.22-5.55 C-17.77,43.5,8.9,19.61,41.36,20.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F2695D"
    },
    d: "M41.36,20.47 c32.23,0.48,58,24.97,57.56,54.71c-0.01,0.93-0.05,1.85-0.12,2.77v-1.93H-17.57v2.95c-0.17-1.81-0.25-3.65-0.22-5.51 C-17.35,43.72,9.13,20,41.36,20.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F26A5D"
    },
    d: "M41.35,20.86 c32,0.47,57.58,24.79,57.15,54.32c-0.01,0.92-0.05,1.84-0.12,2.75v-1.91H-17.15v2.92c-0.17-1.8-0.25-3.63-0.22-5.47 C-16.94,43.94,9.36,20.39,41.35,20.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F26B5D"
    },
    d: "M41.35,21.25 c31.77,0.47,57.17,24.61,56.73,53.92c-0.01,0.92-0.05,1.83-0.12,2.73v-1.88h-114.7v2.88c-0.17-1.79-0.24-3.6-0.22-5.43 C-16.52,44.16,9.58,20.78,41.35,21.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F26C5D"
    },
    d: "M41.34,21.63 c31.53,0.47,56.75,24.43,56.32,53.53c-0.01,0.91-0.05,1.81-0.11,2.71v-1.85H-16.32v2.85c-0.17-1.77-0.24-3.57-0.22-5.39 C-16.1,44.38,9.81,21.17,41.34,21.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F26D5D"
    },
    d: "M41.34,22.02 c31.3,0.46,56.33,24.25,55.91,53.14c-0.01,0.9-0.05,1.8-0.11,2.69v-1.83H-15.9v2.82c-0.17-1.76-0.24-3.55-0.21-5.35 C-15.69,44.6,10.03,21.56,41.34,22.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F26E5D"
    },
    d: "M41.33,22.41 c31.07,0.46,55.92,24.07,55.49,52.75c-0.01,0.9-0.05,1.79-0.11,2.67v-1.8h-112.2v2.78c-0.17-1.75-0.24-3.52-0.21-5.31 C-15.27,44.82,10.26,21.95,41.33,22.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F36F5D"
    },
    d: "M41.32,22.79 c30.84,0.46,55.5,23.89,55.08,52.35c-0.01,0.89-0.05,1.77-0.11,2.65v-1.78H-15.07v2.75c-0.17-1.74-0.24-3.49-0.21-5.27 C-14.86,45.04,10.48,22.34,41.32,22.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F36F5D"
    },
    d: "M41.32,23.18 c30.61,0.45,55.08,23.72,54.67,51.96c-0.01,0.88-0.05,1.76-0.11,2.63v-1.75H-14.65v2.72c-0.16-1.72-0.24-3.47-0.21-5.23 C-14.44,45.26,10.71,22.73,41.32,23.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F3705D"
    },
    d: "M41.31,23.57 c30.38,0.45,54.67,23.54,54.25,51.57c-0.01,0.88-0.05,1.75-0.11,2.61v-1.72H-14.23v2.68c-0.16-1.71-0.23-3.44-0.21-5.19 C-14.03,45.48,10.94,23.12,41.31,23.57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F3715D"
    },
    d: "M41.31,23.95 c30.15,0.45,54.25,23.36,53.84,51.18c-0.01,0.87-0.05,1.73-0.11,2.59v-1.7H-13.82v2.65c-0.16-1.7-0.23-3.42-0.21-5.15 C-13.61,45.7,11.16,23.51,41.31,23.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F3725D"
    },
    d: "M41.3,24.34 c29.91,0.44,53.84,23.18,53.43,50.78c-0.01,0.86-0.05,1.72-0.11,2.57v-1.67H-13.4v2.62c-0.16-1.68-0.23-3.39-0.2-5.11 C-13.19,45.92,11.39,23.9,41.3,24.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F3735D"
    },
    d: "M41.3,24.72 c29.68,0.44,53.42,23,53.01,50.39c-0.01,0.86-0.05,1.71-0.11,2.55v-1.65H-12.98v2.58c-0.16-1.67-0.23-3.36-0.2-5.08 C-12.78,46.14,11.61,24.29,41.3,24.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F3735D"
    },
    d: "M41.29,25.11 c29.45,0.43,53,22.82,52.6,50c-0.01,0.85-0.05,1.69-0.11,2.53v-1.62H-12.56v2.55c-0.16-1.66-0.23-3.34-0.2-5.04 C-12.36,46.36,11.84,24.68,41.29,25.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F3745D"
    },
    d: "M41.28,25.5 c29.22,0.43,52.59,22.64,52.19,49.6c-0.01,0.84-0.05,1.68-0.11,2.51v-1.59H-12.15v2.52c-0.16-1.64-0.22-3.31-0.2-5 C-11.95,46.58,12.06,25.07,41.28,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F3755D"
    },
    d: "M41.28,25.88 c28.99,0.43,52.17,22.46,51.77,49.21c-0.01,0.84-0.05,1.67-0.11,2.49v-1.57H-11.73v2.48c-0.16-1.63-0.22-3.28-0.2-4.96 C-11.53,46.8,12.29,25.46,41.28,25.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F3765D"
    },
    d: "M41.27,26.27 c28.76,0.42,51.75,22.28,51.36,48.82c-0.01,0.83-0.05,1.65-0.1,2.47v-1.54H-11.31v2.45c-0.15-1.62-0.22-3.26-0.2-4.92 C-11.12,47.02,12.51,25.85,41.27,26.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F3775D"
    },
    d: "M41.27,26.66 c28.53,0.42,51.34,22.1,50.95,48.43c-0.01,0.82-0.05,1.64-0.1,2.45v-1.51H-10.89v2.42c-0.15-1.6-0.22-3.23-0.19-4.88 C-10.7,47.23,12.74,26.24,41.27,26.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F3775D"
    },
    d: "M41.26,27.04 c28.3,0.42,50.92,21.92,50.54,48.03c-0.01,0.82-0.05,1.63-0.1,2.43v-1.49H-10.48v2.38c-0.15-1.59-0.22-3.21-0.19-4.84 C-10.28,47.45,12.97,26.63,41.26,27.04z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F3785D"
    },
    d: "M41.26,27.43 c28.06,0.41,50.5,21.74,50.12,47.64c-0.01,0.81-0.05,1.61-0.1,2.41v-1.46H-10.06v2.35c-0.15-1.58-0.22-3.18-0.19-4.8 C-9.87,47.67,13.19,27.02,41.26,27.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F4795D"
    },
    d: "M41.25,27.82 c27.83,0.41,50.09,21.56,49.71,47.25c-0.01,0.8-0.05,1.6-0.1,2.39v-1.44H-9.64v2.32c-0.15-1.57-0.21-3.15-0.19-4.76 C-9.45,47.89,13.42,27.41,41.25,27.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F47A5D"
    },
    d: "M41.24,28.2 c27.6,0.41,49.67,21.39,49.3,46.86c-0.01,0.8-0.05,1.59-0.1,2.37v-1.41H-9.23v2.28c-0.15-1.55-0.21-3.13-0.19-4.72 C-9.04,48.11,13.64,27.8,41.24,28.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F47A5D"
    },
    d: "M41.24,28.59 c27.37,0.4,49.26,21.21,48.88,46.46c-0.01,0.79-0.04,1.57-0.1,2.35v-1.38H-8.81v2.25c-0.15-1.54-0.21-3.1-0.19-4.68 C-8.62,48.33,13.87,28.19,41.24,28.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F47B5C"
    },
    d: "M41.23,28.98 C68.37,29.38,90.07,50,89.7,75.05c-0.01,0.78-0.04,1.56-0.1,2.33v-1.36H-8.39v2.21c-0.15-1.53-0.21-3.07-0.19-4.64 C-8.21,48.55,14.09,28.58,41.23,28.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F47C5C"
    },
    d: "M41.23,29.36 c26.91,0.4,48.42,20.85,48.06,45.68c-0.01,0.78-0.04,1.55-0.1,2.31v-1.33H-7.97v2.18c-0.14-1.51-0.21-3.05-0.18-4.6 C-7.79,48.77,14.32,28.97,41.23,29.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F47D5C"
    },
    d: "M41.22,29.75 c26.68,0.39,48.01,20.67,47.64,45.29c-0.01,0.77-0.04,1.53-0.1,2.29v-1.31H-7.56v2.15c-0.14-1.5-0.2-3.02-0.18-4.56 C-7.37,48.99,14.55,29.36,41.22,29.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F47D5C"
    },
    d: "M41.22,30.14 c26.44,0.39,47.59,20.49,47.23,44.89c-0.01,0.76-0.04,1.52-0.1,2.27v-1.28H-7.14v2.11c-0.14-1.49-0.2-3-0.18-4.52 C-6.96,49.21,14.77,29.75,41.22,30.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F47E5C"
    },
    d: "M41.21,30.52 c26.21,0.39,47.17,20.31,46.82,44.5c-0.01,0.76-0.04,1.51-0.1,2.25v-1.25H-6.72v2.08c-0.14-1.47-0.2-2.97-0.18-4.48 C-6.54,49.43,15,30.14,41.21,30.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F47F5C"
    },
    d: "M41.2,30.91 c25.98,0.38,46.76,20.13,46.4,44.11c-0.01,0.75-0.04,1.49-0.09,2.23v-1.23H-6.3v2.05c-0.14-1.46-0.2-2.94-0.18-4.44 C-6.13,49.65,15.22,30.53,41.2,30.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F47F5C"
    },
    d: "M41.2,31.3 c25.75,0.38,46.34,19.95,45.99,43.71c-0.01,0.74-0.04,1.48-0.09,2.21v-1.2H-5.89v2.01c-0.14-1.45-0.2-2.92-0.18-4.4 C-5.71,49.87,15.45,30.92,41.2,31.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F4805C"
    },
    d: "M41.19,31.68 C66.71,32.06,87.12,51.45,86.77,75c-0.01,0.74-0.04,1.47-0.09,2.19v-1.18H-5.47V78c-0.14-1.44-0.2-2.89-0.17-4.36 C-5.3,50.09,15.67,31.31,41.19,31.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F4815C"
    },
    d: "M41.19,32.07 C66.48,32.44,86.7,51.66,86.35,75c-0.01,0.73-0.04,1.45-0.09,2.17v-1.15H-5.05v1.95c-0.14-1.42-0.19-2.87-0.17-4.32 C-4.88,50.31,15.9,31.7,41.19,32.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F5825C"
    },
    d: "M41.18,32.46 c25.06,0.37,45.09,19.41,44.75,42.54c-0.01,0.72-0.04,1.44-0.09,2.15v-1.12H-4.64v1.91c-0.13-1.41-0.19-2.84-0.17-4.28 C-4.46,50.53,16.12,32.09,41.18,32.46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F5825C"
    },
    d: "M41.18,32.84 C66,33.21,85.85,52.08,85.51,74.99c-0.01,0.72-0.04,1.43-0.09,2.13v-1.1H-4.22v1.88c-0.13-1.4-0.19-2.81-0.17-4.24 C-4.05,50.75,16.35,32.48,41.18,32.84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F5835C"
    },
    d: "M41.17,33.23 c24.59,0.36,44.26,19.06,43.92,41.75c-0.01,0.71-0.04,1.41-0.09,2.11v-1.07H-3.8v1.85c-0.13-1.38-0.19-2.79-0.17-4.2 C-3.63,50.97,16.58,32.87,41.17,33.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F5845B"
    },
    d: "M41.16,33.62 c24.36,0.36,43.84,18.88,43.51,41.36c-0.01,0.7-0.04,1.4-0.09,2.09v-1.05H-3.38v1.81c-0.13-1.37-0.19-2.76-0.17-4.17 C-3.22,51.19,16.8,33.26,41.16,33.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F5855B"
    },
    d: "M41.16,34 c24.13,0.36,43.43,18.7,43.1,40.97c-0.02,1.39-0.12,2.77-0.29,4.12v-3.06H-2.97v1.78c-0.13-1.36-0.19-2.73-0.16-4.13 C-2.8,51.41,17.03,33.65,41.16,34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F5855B"
    },
    d: "M41.15,34.39 c23.9,0.35,43.01,18.52,42.69,40.57c-0.02,1.38-0.12,2.74-0.28,4.08v-3.02h-86.1v1.75c-0.13-1.34-0.18-2.71-0.16-4.09 C-2.39,51.63,17.25,34.04,41.15,34.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F5865B"
    },
    d: "M41.15,34.77 c23.67,0.35,42.59,18.34,42.27,40.18c-0.02,1.37-0.12,2.71-0.28,4.04v-2.97H-2.13v1.71c-0.13-1.33-0.18-2.68-0.16-4.05 C-1.97,51.85,17.48,34.43,41.15,34.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F5875B"
    },
    d: "M41.14,35.16 C64.58,35.51,83.32,53.32,83,74.95c-0.02,1.35-0.11,2.69-0.28,4v-2.93H-1.71v1.68c-0.13-1.32-0.18-2.66-0.16-4.01 C-1.55,52.07,17.7,34.82,41.14,35.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F5875B"
    },
    d: "M41.14,35.55 c23.21,0.34,41.76,17.98,41.45,39.39c-0.02,1.34-0.11,2.66-0.28,3.96v-2.88H-1.3v1.65c-0.12-1.31-0.18-2.63-0.16-3.97 C-1.14,52.29,17.93,35.21,41.14,35.55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F5875B"
    },
    d: "M41.13,35.93 c22.97,0.34,41.35,17.8,41.03,39c-0.02,1.33-0.11,2.63-0.27,3.92v-2.84H-0.88v1.61c-0.12-1.29-0.18-2.6-0.16-3.93 C-0.72,52.51,18.16,35.6,41.13,35.93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F5885B"
    },
    d: "M41.13,36.26 c22.78,0.34,41,17.65,40.69,38.67c-0.02,1.31-0.11,2.61-0.27,3.89v-2.8H-0.53v1.59c-0.12-1.28-0.17-2.58-0.16-3.9 C-0.38,52.69,18.34,35.92,41.13,36.26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F5895A"
    },
    d: "M41.12,36.58 c22.59,0.33,40.65,17.5,40.34,38.35c-0.02,1.3-0.11,2.59-0.27,3.86v-2.76H-0.18v1.56c-0.12-1.27-0.17-2.56-0.15-3.86 C-0.03,52.87,18.53,36.24,41.12,36.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F5895A"
    },
    d: "M41.12,36.9 c22.4,0.33,40.31,17.35,40,38.02c-0.02,1.29-0.11,2.57-0.27,3.82v-2.72H0.16v1.53c-0.12-1.26-0.17-2.54-0.15-3.83 C0.32,53.06,18.72,36.57,41.12,36.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F68A5A"
    },
    d: "M41.11,37.22 c22.2,0.33,39.96,17.2,39.66,37.69c-0.02,1.28-0.11,2.55-0.26,3.79v-2.68H0.51v1.5c-0.12-1.25-0.17-2.52-0.15-3.8 C0.66,53.24,18.91,36.89,41.11,37.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F68B5A"
    },
    d: "M41.11,37.54 c22.01,0.32,39.61,17.05,39.31,37.37c-0.02,1.27-0.11,2.52-0.26,3.76v-2.65H0.86v1.48C0.74,76.26,0.69,75,0.71,73.73 C1.01,53.42,19.09,37.22,41.11,37.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F68C59"
    },
    d: "M41.1,37.87 c21.82,0.32,39.27,16.91,38.97,37.04c-0.02,1.26-0.11,2.5-0.26,3.72v-2.61H1.21v1.45C1.09,76.24,1.04,75,1.06,73.74 C1.35,53.6,19.28,37.54,41.1,37.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F68C59"
    },
    d: "M41.1,38.19 c21.63,0.32,38.92,16.76,38.62,36.71c-0.02,1.25-0.11,2.48-0.26,3.69v-2.57H1.55v1.42c-0.12-1.22-0.17-2.45-0.15-3.7 C1.7,53.79,19.47,37.87,41.1,38.19z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F68D59"
    },
    d: "M41.09,38.51 c21.43,0.32,38.57,16.61,38.28,36.39c-0.02,1.24-0.1,2.46-0.25,3.66v-2.53H1.9v1.39c-0.11-1.21-0.16-2.43-0.15-3.66 C2.05,53.97,19.66,38.19,41.09,38.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F68E58"
    },
    d: "M41.09,38.83 c21.24,0.31,38.23,16.46,37.94,36.06c-0.02,1.23-0.1,2.43-0.25,3.63v-2.49H2.25v1.36c-0.11-1.2-0.16-2.41-0.14-3.63 C2.39,54.15,19.85,38.52,41.09,38.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F68E58"
    },
    d: "M41.08,39.15 c21.05,0.31,37.88,16.31,37.59,35.73c-0.02,1.21-0.1,2.41-0.25,3.59v-2.46H2.6v1.34c-0.11-1.18-0.16-2.38-0.14-3.6 C2.74,54.34,20.03,38.84,41.08,39.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F68F58"
    },
    d: "M41.08,39.48 c20.86,0.31,37.53,16.16,37.25,35.4c-0.02,1.2-0.1,2.39-0.25,3.56v-2.42H2.94v1.31c-0.11-1.17-0.16-2.36-0.14-3.57 C3.09,54.52,20.22,39.17,41.08,39.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F69058"
    },
    d: "M41.07,39.8 c20.66,0.31,37.19,16.01,36.9,35.08c-0.02,1.19-0.1,2.37-0.25,3.53v-2.38H3.29v1.28c-0.11-1.16-0.16-2.34-0.14-3.53 C3.43,54.7,20.41,39.49,41.07,39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F69057"
    },
    d: "M41.07,40.12 c20.47,0.3,36.84,15.86,36.56,34.75c-0.02,1.18-0.1,2.35-0.24,3.49v-2.34H3.64v1.25c-0.11-1.15-0.16-2.32-0.14-3.5 C3.78,54.88,20.6,39.82,41.07,40.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F69157"
    },
    d: "M41.06,40.44 c20.28,0.3,36.49,15.71,36.22,34.42c-0.02,1.17-0.1,2.32-0.24,3.46v-2.3H3.99v1.23c-0.11-1.14-0.16-2.3-0.14-3.47 C4.12,55.07,20.79,40.14,41.06,40.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F69257"
    },
    d: "M41.06,40.76 c20.08,0.3,36.14,15.56,35.87,34.1c-0.02,1.16-0.1,2.3-0.24,3.43v-2.27H4.33v1.2c-0.11-1.13-0.15-2.28-0.14-3.43 C4.47,55.25,20.97,40.47,41.06,40.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F69256"
    },
    d: "M41.05,41.08 c19.89,0.29,35.8,15.41,35.53,33.77c-0.02,1.15-0.1,2.28-0.24,3.4v-2.23H4.68v1.17c-0.11-1.12-0.15-2.25-0.14-3.4 C4.82,55.43,21.16,40.79,41.05,41.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F69356"
    },
    d: "M41.05,41.41 c19.7,0.29,35.45,15.26,35.18,33.44c-0.02,1.14-0.1,2.26-0.23,3.36v-2.19H5.03v1.14c-0.11-1.11-0.15-2.23-0.13-3.37 C5.16,55.62,21.35,41.12,41.05,41.41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F69456"
    },
    d: "M41.04,41.73 c19.51,0.29,35.1,15.11,34.84,33.11c-0.02,1.13-0.09,2.24-0.23,3.33v-2.15H5.38v1.11c-0.1-1.1-0.15-2.21-0.13-3.34 C5.51,55.8,21.54,41.44,41.04,41.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F69455"
    },
    d: "M41.04,42.05 c19.31,0.29,34.76,14.96,34.49,32.79c-0.02,1.11-0.09,2.21-0.23,3.3v-2.11H5.72v1.09c-0.1-1.09-0.15-2.19-0.13-3.3 C5.86,55.98,21.73,41.77,41.04,42.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F69555"
    },
    d: "M41.03,42.37 c19.12,0.28,34.41,14.82,34.15,32.46c-0.02,1.1-0.09,2.19-0.23,3.26v-2.08H6.07v1.06c-0.1-1.08-0.15-2.17-0.13-3.27 C6.2,56.17,21.91,42.09,41.03,42.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F69655"
    },
    d: "M41.03,42.69 c18.93,0.28,34.06,14.67,33.81,32.13c-0.02,1.09-0.09,2.17-0.22,3.23v-2.04H6.42v1.03c-0.1-1.06-0.15-2.14-0.13-3.24 C6.55,56.35,22.1,42.42,41.03,42.69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F69654"
    },
    d: "M41.03,43.02 c18.74,0.28,33.72,14.52,33.46,31.81c-0.02,1.08-0.09,2.15-0.22,3.2v-2H6.77v1c-0.1-1.05-0.14-2.12-0.13-3.2 C6.89,56.53,22.29,42.74,41.03,43.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F69754"
    },
    d: "M41.02,43.34 c18.54,0.27,33.37,14.37,33.12,31.48c-0.02,1.07-0.09,2.13-0.22,3.17v-1.96H7.11V77c-0.1-1.04-0.14-2.1-0.13-3.17 C7.24,56.71,22.48,43.06,41.02,43.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F69854"
    },
    d: "M41.02,43.66 c18.35,0.27,33.02,14.22,32.77,31.15c-0.02,1.06-0.09,2.1-0.22,3.13v-1.92H7.46v0.95c-0.1-1.03-0.14-2.08-0.13-3.14 C7.59,56.9,22.67,43.39,41.02,43.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F69853"
    },
    d: "M41.01,43.98 c18.16,0.27,32.68,14.07,32.43,30.82c-0.02,1.05-0.09,2.08-0.22,3.1v-1.89H7.81v0.92c-0.1-1.02-0.14-2.06-0.12-3.1 C7.93,57.08,22.85,43.71,41.01,43.98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F69953"
    },
    d: "M41.01,44.3 c17.97,0.27,32.33,13.92,32.09,30.5c-0.02,1.04-0.09,2.06-0.21,3.07v-1.85H8.16v0.89c-0.1-1.01-0.14-2.04-0.12-3.07 C8.28,57.26,23.04,44.04,41.01,44.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F69A52"
    },
    d: "M41,44.63 C58.77,44.89,72.99,58.4,72.74,74.8c-0.02,1.03-0.09,2.04-0.21,3.03v-1.81H8.5v0.86c-0.1-1-0.14-2.01-0.12-3.04 C8.62,57.45,23.23,44.36,41,44.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F69A52"
    },
    d: "M41,44.95 c17.58,0.26,31.64,13.62,31.4,29.84c-0.01,1.01-0.09,2.02-0.21,3v-1.77H8.85v0.84c-0.09-0.99-0.13-1.99-0.12-3.01 C8.97,57.63,23.42,44.69,41,44.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F79B52"
    },
    d: "M40.99,45.27 c17.39,0.26,31.29,13.47,31.05,29.52c-0.01,1-0.08,1.99-0.21,2.97v-1.73H9.2v0.81c-0.09-0.98-0.13-1.97-0.12-2.97 C9.32,57.81,23.6,45.01,40.99,45.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F79C51"
    },
    d: "M40.99,45.59 c17.19,0.25,30.94,13.32,30.71,29.19c-0.01,0.99-0.08,1.97-0.2,2.94v-1.7H9.55v0.78c-0.09-0.97-0.13-1.95-0.12-2.94 C9.66,58,23.79,45.34,40.99,45.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F79C51"
    },
    d: "M40.98,45.91 c17,0.25,30.6,13.17,30.37,28.86c-0.01,0.98-0.08,1.95-0.2,2.9v-1.66H9.89v0.75c-0.09-0.96-0.13-1.93-0.12-2.91 C10.01,58.18,23.98,45.66,40.98,45.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F79D50"
    },
    d: "M40.98,46.24 C57.79,46.48,71.23,59.26,71,74.77c-0.01,0.97-0.08,1.93-0.2,2.87v-1.62H10.24v0.73c-0.09-0.95-0.13-1.9-0.11-2.87 C10.36,58.36,24.17,45.99,40.98,46.24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F79E50"
    },
    d: "M40.97,46.56 c16.62,0.25,29.9,12.87,29.68,28.21c-0.01,0.96-0.08,1.9-0.2,2.84v-1.58H10.59v0.7c-0.09-0.93-0.13-1.88-0.11-2.84 C10.7,58.54,24.36,46.31,40.97,46.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F79F50"
    },
    d: "M40.97,46.88 C57.39,47.12,70.53,59.6,70.3,74.76c-0.01,0.95-0.08,1.88-0.19,2.8v-1.54H10.94v0.67c-0.09-0.92-0.13-1.86-0.11-2.81 C11.05,58.73,24.54,46.64,40.97,46.88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F79F4F"
    },
    d: "M40.96,47.2 c16.23,0.24,29.21,12.58,28.99,27.55c-0.01,0.94-0.08,1.86-0.19,2.77v-1.5H11.28v0.64c-0.09-0.91-0.12-1.84-0.11-2.78 C11.39,58.91,24.73,46.96,40.96,47.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F7A04F"
    },
    d: "M40.96,47.52 C57,47.76,69.82,59.95,69.6,74.75c-0.01,0.93-0.08,1.84-0.19,2.74v-1.47H11.63v0.61c-0.09-0.9-0.12-1.82-0.11-2.74 C11.74,59.09,24.92,47.29,40.96,47.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F7A14E"
    },
    d: "M40.95,47.85 c15.85,0.23,28.52,12.28,28.3,26.9c-0.01,0.91-0.08,1.82-0.19,2.7v-1.43H11.98v0.59c-0.08-0.89-0.12-1.8-0.11-2.71 C12.09,59.28,25.11,47.61,40.95,47.85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F7A14E"
    },
    d: "M40.95,48.17 C56.6,48.4,69.12,60.3,68.91,74.74c-0.01,0.9-0.08,1.79-0.19,2.67v-1.39H12.33v0.56c-0.08-0.88-0.12-1.77-0.11-2.68 C12.43,59.46,25.3,47.94,40.95,48.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F7A24E"
    },
    d: "M40.94,48.49 c15.46,0.23,27.82,11.98,27.61,26.25c-0.01,0.89-0.08,1.77-0.18,2.64v-1.35H13.06v3.1c-0.35-1.69-0.52-3.43-0.49-5.21 C12.78,59.64,25.48,48.26,40.94,48.49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F7A34D"
    },
    d: "M40.94,48.81 c15.27,0.23,27.48,11.83,27.27,25.92c-0.01,0.88-0.07,1.75-0.18,2.61v-1.31H13.4v3.04c-0.34-1.67-0.51-3.39-0.49-5.15 C13.13,59.82,25.67,48.59,40.94,48.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F7A34D"
    },
    d: "M40.94,49.13 c15.08,0.22,27.13,11.68,26.92,25.59c-0.01,0.87-0.07,1.73-0.18,2.57v-1.28H13.75V79c-0.34-1.65-0.51-3.35-0.48-5.08 C13.47,60.01,25.86,48.91,40.94,49.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F7A44C"
    },
    d: "M40.93,49.45 c14.88,0.22,26.78,11.53,26.58,25.26c-0.01,0.86-0.07,1.71-0.18,2.54v-1.24H14.09v2.92c-0.34-1.62-0.5-3.3-0.47-5.02 C13.82,60.19,26.05,49.24,40.93,49.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F7A54C"
    },
    d: "M40.93,49.78 c14.69,0.22,26.44,11.38,26.24,24.94c-0.01,0.85-0.07,1.68-0.17,2.51v-1.2H14.43v2.86c-0.33-1.6-0.49-3.26-0.47-4.95 C14.16,60.37,26.24,49.56,40.93,49.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F7A64B"
    },
    d: "M40.92,50.1 c14.5,0.21,26.09,11.23,25.89,24.61c-0.01,0.84-0.07,1.66-0.17,2.47v-1.16H14.77v2.8c-0.33-1.58-0.49-3.22-0.46-4.89 C14.51,60.56,26.42,49.88,40.92,50.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F8A64B"
    },
    d: "M40.92,50.42 c14.3,0.21,25.74,11.08,25.55,24.28c-0.01,0.83-0.07,1.64-0.17,2.44v-1.12H15.12v2.74c-0.32-1.56-0.48-3.17-0.46-4.82 C14.86,60.74,26.61,50.21,40.92,50.42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F8A74A"
    },
    d: "M40.91,50.74 c14.11,0.21,25.4,10.93,25.2,23.96c-0.01,0.81-0.07,1.62-0.17,2.41v-1.09H15.46v2.68c-0.32-1.54-0.47-3.13-0.45-4.76 C15.2,60.92,26.8,50.53,40.91,50.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F8A84A"
    },
    d: "M40.91,51.06 c13.92,0.21,25.05,10.78,24.86,23.63c-0.01,0.8-0.07,1.6-0.17,2.38v-1.05H15.8v2.62c-0.31-1.52-0.47-3.09-0.44-4.69 C15.55,61.11,26.99,50.86,40.91,51.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F8A849"
    },
    d: "M40.9,51.39 c13.73,0.2,24.7,10.64,24.52,23.3c-0.01,0.79-0.07,1.57-0.16,2.34v-1.01H16.15v2.56c-0.31-1.5-0.46-3.05-0.44-4.63 C15.9,61.29,27.18,51.18,40.9,51.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F8A949"
    },
    d: "M40.9,51.71 c13.53,0.2,24.36,10.49,24.17,22.98c-0.01,0.78-0.07,1.55-0.16,2.31v-0.97H16.49v2.5c-0.3-1.48-0.45-3-0.43-4.56 C16.24,61.47,27.36,51.51,40.9,51.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F8AA48"
    },
    d: "M40.89,52.03 c13.34,0.2,24.01,10.34,23.83,22.65c-0.01,0.77-0.06,1.53-0.16,2.28v-0.93H16.83v2.44c-0.3-1.46-0.45-2.96-0.42-4.5 C16.59,61.65,27.55,51.83,40.89,52.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F8AA48"
    },
    d: "M40.89,52.35 c13.15,0.19,23.66,10.19,23.48,22.32c-0.02,1.52-0.21,3-0.55,4.42v-3.07H17.17v2.38c-0.3-1.43-0.44-2.92-0.42-4.43 C16.93,61.84,27.74,52.16,40.89,52.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F8AB47"
    },
    d: "M40.88,52.67 c12.96,0.19,23.32,10.04,23.14,21.99c-0.02,1.49-0.21,2.95-0.54,4.36v-3H17.52v2.32c-0.29-1.41-0.43-2.88-0.41-4.37 C17.28,62.02,27.93,52.48,40.88,52.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F8AC47"
    },
    d: "M40.88,53 c12.76,0.19,22.97,9.89,22.8,21.67c-0.02,1.47-0.2,2.91-0.53,4.29v-2.93H17.86v2.26c-0.29-1.39-0.43-2.83-0.41-4.3 C17.63,62.2,28.11,52.81,40.88,53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F8AC46"
    },
    d: "M40.87,53.32 c12.57,0.19,22.62,9.74,22.45,21.34c-0.02,1.45-0.2,2.86-0.52,4.23v-2.86H18.2v2.2c-0.28-1.37-0.42-2.79-0.4-4.24 C17.97,62.39,28.3,53.13,40.87,53.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F8AD46"
    },
    d: "M40.87,53.64 c12.38,0.18,22.28,9.59,22.11,21.01c-0.02,1.43-0.2,2.82-0.52,4.16v-2.79H18.54v2.14c-0.28-1.35-0.41-2.75-0.39-4.17 C18.32,62.57,28.49,53.46,40.87,53.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F8AE45"
    },
    d: "M40.86,53.96 c12.19,0.18,21.93,9.44,21.76,20.69c-0.02,1.41-0.2,2.78-0.51,4.1v-2.72H18.89v2.08c-0.27-1.33-0.41-2.7-0.39-4.11 C18.67,62.75,28.68,53.78,40.86,53.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F8AF45"
    },
    d: "M40.86,54.28 c11.99,0.18,21.58,9.29,21.42,20.36c-0.02,1.38-0.19,2.73-0.5,4.03v-2.65H19.23v2.02c-0.27-1.31-0.4-2.66-0.38-4.04 C19.01,62.93,28.87,54.11,40.86,54.28z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F8AF44"
    },
    d: "M40.85,54.61 c11.8,0.17,21.24,9.14,21.07,20.03c-0.02,1.36-0.19,2.69-0.49,3.97v-2.58H19.57v1.96c-0.27-1.29-0.4-2.62-0.38-3.98 C19.36,63.12,29.05,54.43,40.85,54.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F8B044"
    },
    d: "M40.85,54.93 c11.61,0.17,20.89,8.99,20.73,19.7c-0.02,1.34-0.19,2.64-0.48,3.9v-2.51H19.92v1.91c-0.26-1.27-0.39-2.58-0.37-3.91 C19.7,63.3,29.24,54.76,40.85,54.93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F8B143"
    },
    d: "M40.84,55.25 c11.41,0.17,20.54,8.84,20.39,19.38c-0.02,1.32-0.18,2.6-0.48,3.84v-2.44h-40.5v1.85c-0.26-1.25-0.38-2.53-0.36-3.85 C20.05,63.48,29.43,55.08,40.84,55.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F9B142"
    },
    d: "M40.84,55.57 c11.22,0.17,20.2,8.69,20.04,19.05c-0.02,1.29-0.18,2.56-0.47,3.77v-2.37H20.6v1.79c-0.25-1.22-0.38-2.49-0.36-3.78 C20.4,63.67,29.62,55.41,40.84,55.57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F9B242"
    },
    d: "M40.84,55.89 c11.03,0.16,19.85,8.55,19.7,18.72c-0.02,1.27-0.18,2.51-0.46,3.71v-2.3H20.94v1.73c-0.25-1.2-0.37-2.45-0.35-3.72 C20.74,63.85,29.81,55.73,40.84,55.89z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F9B341"
    },
    d: "M40.83,56.22 c10.84,0.16,19.5,8.4,19.35,18.4c-0.02,1.25-0.17,2.47-0.45,3.64v-2.23H21.29v1.67c-0.24-1.18-0.36-2.4-0.34-3.65 C21.09,64.03,29.99,56.06,40.83,56.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F9B441"
    },
    d: "M40.83,56.54 c10.64,0.16,19.16,8.25,19.01,18.07c-0.02,1.23-0.17,2.42-0.44,3.58v-2.16H21.63v1.61c-0.24-1.16-0.36-2.36-0.34-3.59 C21.44,64.22,30.18,56.38,40.83,56.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F9B440"
    },
    d: "M40.82,56.86 c10.45,0.15,18.81,8.1,18.67,17.74c-0.02,1.21-0.17,2.38-0.44,3.51v-2.09H21.97v1.55c-0.24-1.14-0.35-2.32-0.33-3.53 C21.78,64.4,30.37,56.7,40.82,56.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F9B53F"
    },
    d: "M40.82,57.18 c10.26,0.15,18.46,7.95,18.32,17.42c-0.02,1.18-0.16,2.34-0.43,3.45v-2.02h-36.4v1.49c-0.23-1.12-0.34-2.28-0.33-3.46 C22.13,64.58,30.56,57.03,40.82,57.18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F9B63F"
    },
    d: "M40.81,57.5 c10.07,0.15,18.11,7.8,17.98,17.09c-0.02,1.16-0.16,2.29-0.42,3.38v-1.95H22.66v1.43c-0.23-1.1-0.34-2.23-0.32-3.4 C22.47,64.76,30.75,57.35,40.81,57.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F9B63E"
    },
    d: "M40.81,57.82 c9.87,0.15,17.77,7.65,17.63,16.76c-0.02,1.14-0.16,2.25-0.41,3.32v-1.88H23v1.37c-0.22-1.08-0.33-2.19-0.31-3.33 C22.82,64.95,30.93,57.68,40.81,57.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F9B73D"
    },
    d: "M40.8,58.15 c9.68,0.14,17.42,7.5,17.29,16.43c-0.02,1.12-0.16,2.21-0.4,3.25v-1.81H23.34v1.31c-0.22-1.06-0.32-2.15-0.31-3.27 C23.17,65.13,31.12,58,40.8,58.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F9B83D"
    },
    d: "M40.8,58.47 c9.49,0.14,17.07,7.35,16.95,16.11c-0.02,1.09-0.15,2.16-0.4,3.19v-1.74H23.69v1.25c-0.21-1.04-0.32-2.11-0.3-3.2 C23.51,65.31,31.31,58.33,40.8,58.47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F9B93C"
    },
    d: "M40.79,58.79 c9.3,0.14,16.73,7.2,16.6,15.78c-0.02,1.07-0.15,2.12-0.39,3.13v-1.67H24.03v1.19c-0.21-1.01-0.31-2.06-0.3-3.14 C23.86,65.5,31.5,58.65,40.79,58.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#F9B93B"
    },
    d: "M40.79,59.11 c9.1,0.13,16.38,7.05,16.26,15.45c-0.02,1.05-0.15,2.07-0.38,3.06v-1.6H24.37v1.13c-0.2-0.99-0.31-2.02-0.29-3.07 C24.21,65.68,31.69,58.98,40.79,59.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#FABA3B"
    },
    d: "M40.78,59.43 c8.91,0.13,16.03,6.9,15.91,15.13c-0.02,1.03-0.14,2.03-0.37,3v-1.53H24.71v1.07c-0.2-0.97-0.3-1.98-0.28-3.01 C24.55,65.86,31.87,59.3,40.78,59.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#FABB3A"
    },
    d: "M40.78,59.76 c8.72,0.13,15.69,6.75,15.57,14.8c-0.01,1.01-0.14,1.99-0.36,2.93v-1.46H25.06v1.01c-0.2-0.95-0.29-1.93-0.28-2.94 C24.9,66.04,32.06,59.63,40.78,59.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#FABB39"
    },
    d: "M40.77,60.08 C49.3,60.2,56.11,66.68,56,74.55c-0.01,0.98-0.14,1.94-0.36,2.87v-1.39H25.4v0.95c-0.19-0.93-0.29-1.89-0.27-2.88 C25.24,66.23,32.25,59.95,40.77,60.08z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#FABC39"
    },
    d: "M40.77,60.4 c8.33,0.12,14.99,6.46,14.88,14.14c-0.01,0.96-0.13,1.9-0.35,2.8v-1.32H25.74v0.89c-0.19-0.91-0.28-1.85-0.27-2.81 C25.59,66.41,32.44,60.28,40.77,60.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#FABD38"
    },
    d: "M40.76,60.72 c8.14,0.12,14.65,6.31,14.54,13.82c-0.01,0.94-0.13,1.85-0.34,2.74v-1.25H26.08v0.83c-0.18-0.89-0.27-1.81-0.26-2.75 C25.94,66.59,32.62,60.6,40.76,60.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#FABE37"
    },
    d: "M40.76,61.04 c7.95,0.12,14.3,6.16,14.19,13.49c-0.01,0.92-0.13,1.81-0.33,2.67v-1.18H26.43v0.77c-0.18-0.87-0.27-1.76-0.25-2.68 C26.28,66.78,32.81,60.93,40.76,61.04z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000161626967890281336800000009925297775754565254_)",
      fill: "#FABE37"
    },
    d: "M40.75,61.37 c7.75,0.11,13.95,6.01,13.85,13.16c-0.01,0.89-0.12,1.77-0.32,2.61v-1.11H26.77v0.71c-0.17-0.85-0.26-1.72-0.25-2.62 C26.63,66.96,33,61.25,40.75,61.37z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000026872533018381096680000004590459808162860166_",
    d: "M73.26,54.2c-0.04-0.39,1.51-3.27,1.19-3.5 c-1.14-0.83-2.36,0.36-2.98-0.49c-0.03-0.03-0.05-0.07-0.08-0.11c-0.01-0.01-0.01-0.02-0.02-0.03 c-0.02-0.03-0.04-0.06-0.06-0.09c0-0.01-0.01-0.01-0.01-0.02c-0.02-0.03-0.04-0.06-0.06-0.09c-0.53-0.77-1.07-1.61-1.81-1.83 c-0.76-0.22-1.59,0.4-2.28,0.82c-0.43,0.26-0.86,0.52-1.29,0.76c-0.43,0.23-0.86,0.35-1.3,0.52c-0.54,0.21-1.07,0.55-1.55,1 c0,0-0.01,0.01-0.01,0.01c-0.04,0.04-0.08,0.07-0.11,0.11c-0.02,0.02-0.03,0.03-0.05,0.05c-0.03,0.03-0.05,0.05-0.07,0.08 c-0.03,0.03-0.06,0.06-0.09,0.1c-0.01,0.01-0.02,0.03-0.04,0.04c0,0,0,0,0,0c-0.77-0.8-1.47-1.48-1.95-1.76 c-0.05-0.03-0.1-0.06-0.15-0.09c-0.01-0.01-0.03-0.01-0.04-0.02c-0.04-0.02-0.08-0.04-0.12-0.06c-0.01-0.01-0.02-0.01-0.04-0.02 c-0.11-0.05-0.21-0.1-0.32-0.13c0,0-0.01,0-0.01,0c-0.05-0.02-0.1-0.03-0.15-0.05c0,0-0.01,0-0.01,0 c-0.17-0.05-0.33-0.08-0.5-0.09c0,0,0,0,0,0l0,0c-0.24-0.02-0.47,0.01-0.72,0.07c-0.43,0.12-0.86,0.33-1.28,0.5 c-0.42,0.16-0.85,0.24-1.28,0.28c-0.8,0.08-1.6,0.05-2.41,0.13c-0.04,0-0.08,0.01-0.12,0.01c0,0-0.01,0-0.01,0 c-0.5,0.04-1.09,0.03-1.57,0.31c0,0,0,0,0,0c-0.03,0.02-0.06,0.04-0.09,0.06c-0.03,0.02-0.06,0.04-0.08,0.06 c-0.01,0-0.01,0.01-0.02,0.01c-0.03,0.03-0.06,0.06-0.1,0.09c-0.42,0.41-0.69,1.11-0.95,1.78c-0.31-0.36-0.68-0.64-1.06-0.79 c-0.04-0.01-0.07-0.03-0.11-0.04c-0.05-0.02-0.1-0.04-0.15-0.06c0,0,0,0,0,0c-0.15-0.06-0.3-0.11-0.45-0.2 c-0.24-0.13-0.47-0.28-0.7-0.42c-0.38-0.23-0.83-0.58-1.25-0.47c-0.47,0.12-0.81,0.67-1.17,1.11c-0.18,0.23-0.39,0.43-0.57,0.66 c-0.02-0.03-0.03-0.06-0.05-0.08c-0.47-0.97-0.89-2.2-1.65-2.86c-0.03-0.02-0.05-0.04-0.08-0.06c0,0,0,0,0,0 c-0.68-0.53-1.6-0.53-2.39-0.58c-0.05,0-0.09-0.01-0.14-0.01c0,0-0.01,0-0.01,0c-0.05,0-0.1-0.01-0.15-0.01 c-1.12-0.11-2.25-0.07-3.37-0.16c-0.61-0.05-1.2-0.14-1.79-0.34c-0.6-0.2-1.19-0.46-1.8-0.61c-0.59-0.14-1.16-0.12-1.72,0.02 c-0.01,0-0.01,0-0.02,0c-0.07,0.02-0.14,0.04-0.21,0.06c-0.01,0-0.01,0-0.02,0.01c-0.15,0.05-0.3,0.1-0.44,0.16 c-0.02,0.01-0.04,0.02-0.05,0.02c-0.05,0.02-0.11,0.05-0.16,0.07c-0.02,0.01-0.04,0.02-0.06,0.03 c-0.07,0.03-0.14,0.07-0.21,0.11c-0.66,0.35-1.65,1.17-2.73,2.16c0,0,0,0,0,0c-0.03-0.03-0.05-0.05-0.08-0.08 c-0.03-0.03-0.06-0.06-0.09-0.09c-0.04-0.04-0.08-0.07-0.12-0.11c-0.02-0.02-0.04-0.03-0.06-0.05c-0.05-0.05-0.1-0.09-0.16-0.13 c-0.01-0.01-0.02-0.01-0.02-0.02c-0.68-0.55-1.41-0.97-2.17-1.23c-0.61-0.2-1.22-0.35-1.81-0.63c-0.61-0.29-1.21-0.61-1.81-0.93 c-0.97-0.51-2.13-1.28-3.19-1.01c-1.1,0.28-1.88,1.41-2.67,2.4c-0.02,0.02-0.04,0.05-0.06,0.07c-0.01,0.01-0.02,0.03-0.04,0.04 c-0.03,0.04-0.07,0.08-0.1,0.12c-0.16,0.19-0.33,0.38-0.49,0.56c-0.06-0.02-0.12-0.04-0.18-0.06c-0.59-0.13-1.22,0.29-1.75,0.58 c-0.33,0.18-0.66,0.36-0.99,0.52c-0.21,0.1-0.42,0.17-0.63,0.24c0,0,0,0,0,0c-0.07,0.02-0.15,0.05-0.22,0.07 c-0.05,0.02-0.1,0.03-0.14,0.05c-0.6,0.21-1.17,0.61-1.65,1.14c-0.18,0.2-2,0.92-2.18,1.12c-0.17,0.52,0.92,0.68,0.56,1.29 H73.26z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000085957643342128000150000002650701844297335695_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000026872533018381096680000004590459808162860166_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 45.78,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#D28146"
    },
    width: 67.37,
    height: 1.68
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 47.46,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#D28146"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 47.51,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#D18145"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 47.56,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#D08045"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 47.62,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#CF7F45"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 47.67,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#CE7F45"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 47.72,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#CD7E44"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 47.78,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#CC7E44"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 47.83,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#CB7D44"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 47.88,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#CA7C43"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 47.93,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#C97C43"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 47.99,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#C87B43"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 48.04,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#C77A43"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 48.09,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#C67A42"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 48.15,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#C57942"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 48.2,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#C47942"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 48.25,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#C37841"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 48.3,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#C17741"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 48.36,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#C07741"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 48.41,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#BF7641"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 48.46,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#BE7540"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 48.52,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#BD7540"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 48.57,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#BC7440"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 48.62,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#BB743F"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 48.68,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#BA733F"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 48.73,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#B9723F"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 48.78,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#B8723F"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 48.83,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#B7713E"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 48.89,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#B6713E"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 48.94,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#B5703E"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 48.99,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#B46F3D"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 49.05,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#B36F3D"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 49.1,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#B26E3D"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 49.15,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#B16E3C"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 49.2,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#B06D3C"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 49.26,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#AF6C3C"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 49.31,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#AE6C3C"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 49.36,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#AE6B3B"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 49.42,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#AD6B3B"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 49.47,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#AC6A3B"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 49.52,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#AB693A"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 49.58,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#AA693A"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 49.63,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#A9683A"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 49.68,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#A86839"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 49.73,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#A76739"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 49.79,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#A66639"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 49.84,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#A56639"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 49.89,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#A46538"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 49.95,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#A36538"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 50,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#A26438"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 50.05,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#A16337"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 50.1,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#A06337"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 50.16,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#9F6237"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 50.21,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#9E6236"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 50.26,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#9D6136"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 50.32,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#9C6136"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 50.37,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#9B6036"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 50.42,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#9A5F35"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 50.47,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#995F35"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 50.53,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#985E35"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 50.58,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#975E34"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 50.63,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#965D34"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 50.69,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#955C34"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 50.74,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#955C33"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 50.79,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#945B33"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 50.85,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#935B33"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 50.9,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#925A32"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 50.95,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#915A32"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 51,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#905932"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 51.06,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#8F5831"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 51.11,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#8E5831"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 51.16,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#8D5731"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 51.22,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#8C5731"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 51.27,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#8B5630"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 51.32,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#8A5630"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 51.37,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#895530"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 51.43,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#89542F"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 51.48,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#88542F"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 51.53,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#87532F"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 51.59,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#86532E"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 51.64,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#85522E"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 51.69,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#84522E"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 51.75,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#83512D"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 51.8,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#82502D"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 51.85,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#81502D"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 51.9,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#804F2C"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 51.96,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#804F2C"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 52.01,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#7F4E2C"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 52.06,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#7E4E2B"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 52.12,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#7D4D2B"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 52.17,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#7C4D2B"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 52.22,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#7B4C2A"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 52.27,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#7A4B2A"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 52.33,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#7A4B2A"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 52.38,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#794A29"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 52.43,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#784A29"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 52.49,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#774929"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 52.54,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#764928"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 52.59,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#754828"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 52.64,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#754828"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 52.7,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#744727"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 52.75,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#734727"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 52.8,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#724627"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 52.86,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#714626"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 52.91,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#704526"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 52.96,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#704426"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 53.02,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#6F4425"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 53.07,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#6E4325"
    },
    width: 67.37,
    height: 0.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.39,
    y: 53.12,
    style: {
      clipPath: "url(#SVGID_00000085957643342128000150000002650701844297335695_)",
      fill: "#6E4325"
    },
    width: 67.37,
    height: 1.08
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st358",
    d: "M62.51,52.58c-2.31,0.26-4.72-0.28-7.05,0.18c-2.08,0.4-4.02,1.15-6.25,1.21 c-1.95,0.05-3.77-0.48-5.59-0.84c-1.94-0.39-3.29-0.3-5.23-0.18c-3.15,0.21-6.32,0.32-9.49,0.34c-2.87,0.01-5.8-0.06-8.47-0.71 c-1.54-0.38-3.05-0.95-4.71-0.91c-1.95,0.04-3.53,0.87-5.3,1.27c-0.58,0.13-2.45,0.14-2.81,0.44c-0.27,0.22,0.4,0.71,0.4,0.98 l3.06,5.54l3.21,4.08l3.05,3.16l3.52,2.49l4.76,2.67l3.85,1.52l5.79,1.37l5.29,0.39l5.41-0.41l4.41-0.96l4.36-1.57l4-2.06l4.28-3 l3.54-3.32l2.08-2.44l1.9-2.7l1.76-3.09l1.46-3.31l0.27-0.73c-0.01-0.66,0.18,0.04,0.21-0.62c0.01-0.1,0.3-0.18,0.18-0.25 c-0.12-0.07-0.31-0.07-0.48-0.06c-1.22,0.07-2.43,0.15-3.65,0.22c-1.31,0.08-2.63,0.16-3.88,0.41c-1.02,0.21-1.98,0.52-2.99,0.75 C63.12,52.49,62.82,52.54,62.51,52.58z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st358",
    d: "M69.9,30.4c-0.14,0.07-0.47,0.04-0.62,0.02c-0.01,0-0.02,0-0.03,0c0.25-0.11,0.47-0.35,0.43-0.64 c-0.01-0.04-0.05,0.01-0.05,0.03c0,0.37-0.33,0.49-0.67,0.52c0.13-0.06,0.25-0.15,0.34-0.26c0.02-0.03,0.01-0.07-0.03-0.04 c-0.05,0.05-0.2,0.12-0.36,0.16c0.05-0.03,0.1-0.06,0.13-0.11c0.02-0.03-0.01-0.05-0.03-0.03c-0.09,0.09-0.4,0.03-0.5,0 c-0.03-0.01-0.05-0.01-0.08-0.02c0.17-0.05,0.34-0.15,0.44-0.29c0.03-0.04-0.02-0.05-0.04-0.02c-0.17,0.2-0.45,0.2-0.71,0.14 c0.16,0.01,0.33-0.03,0.48-0.1c0.02-0.01,0.04-0.04,0.03-0.06c-0.01-0.01-0.01-0.02-0.03-0.02c-0.01,0-0.02,0-0.03,0.01 c-0.2,0.01-0.38-0.01-0.57-0.07c0.11-0.03,0.22-0.09,0.17-0.19c-0.01-0.02-0.03,0.01-0.03,0.02c0.01,0.05-0.15,0.06-0.29,0.05 c-0.01-0.02-0.01-0.04-0.02-0.06c0.25-0.09,0.49-0.21,0.67-0.39c-0.01,0.11-0.04,0.21-0.09,0.3c-0.02,0.01-0.04,0.04-0.03,0.06 c0,0.01,0,0.02,0.01,0.02c0.02,0.02,0.04,0,0.06-0.01c0.11-0.12,0.17-0.33,0.21-0.49c0.01-0.02,0.01-0.05,0.01-0.08 c0.02-0.03,0.03-0.05,0.05-0.08c0.03,0.15,0.02,0.33-0.05,0.44c-0.01,0.01-0.02,0.03-0.02,0.04c0,0,0,0.01,0,0.01 c0,0.03,0.02,0.03,0.04,0.02c0.14-0.07,0.17-0.38,0.18-0.51c0.02-0.16-0.04-0.33-0.12-0.48c-0.01-0.03-0.03-0.07-0.05-0.1 c-0.01-0.01-0.01-0.02-0.02-0.03c-0.01-0.01-0.01-0.02-0.02-0.03c0,0,0,0,0,0C68.5,27.9,68.22,27.7,68,27.56 c-0.87-0.54-1.95-0.81-2.93-1.05c-0.55-0.14-1.12-0.23-1.68-0.3c0.43-0.06,0.87-0.05,1.3,0.03c0.02,0,0.08-0.05,0.05-0.07 c-0.32-0.19-0.82-0.26-1.26-0.19c0.11-0.09,0.19-0.18,0.21-0.27c0.01-0.03-0.04-0.01-0.05,0c-0.05,0.11-0.19,0.19-0.33,0.24 c0.11-0.12,0.19-0.27,0.2-0.44c0-0.04-0.05-0.01-0.05,0.02c-0.02,0.1-0.06,0.17-0.11,0.24c0-0.02,0.01-0.04,0-0.06 c-0.03-0.37-0.99-0.35-1.21-0.37l0,0c0.08-0.03,0.17-0.06,0.24-0.1c0.02-0.01,0.04-0.07,0-0.06c-0.06,0.02-0.13,0.01-0.2,0.03 c-0.04,0.01-0.07,0.02-0.1,0.03c0,0,0-0.01,0-0.01c0.02-0.09,0.01-0.18-0.01-0.27c0.05,0.02,0.09,0.04,0.14,0.06 c0.03,0.01,0.08,0.06,0.12,0.06l0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c0.03,0,0.07-0.07,0.04-0.08c-0.02-0.02-0.04-0.04-0.05-0.06 c-0.03-0.04-0.09-0.07-0.13-0.09c-0.06-0.04-0.13-0.08-0.2-0.12c-0.01-0.01-0.03-0.02-0.04-0.02c-0.01-0.01-0.01-0.02-0.02-0.03 c0.05,0.01,0.1,0.03,0.16,0.05c0.12,0.04,0.24,0.09,0.34,0.16c0.08,0.06,0.13,0.16,0.21,0.22c0.03,0.02,0.09-0.04,0.06-0.07 c-0.07-0.08-0.1-0.18-0.17-0.26c-0.08-0.1-0.24-0.15-0.35-0.2c-0.15-0.07-0.29-0.13-0.44-0.12c-0.08-0.09-0.16-0.17-0.23-0.23 c0,0,0,0,0,0c-0.07-0.34-0.3-0.67-0.54-0.81c-0.03-0.02-0.07,0.04-0.05,0.06c0.12,0.11,0.23,0.26,0.3,0.42 c-0.06-0.08-0.12-0.16-0.2-0.22c-0.02-0.02-0.05,0.03-0.04,0.05c0.07,0.07,0.12,0.15,0.16,0.23c-0.07-0.05-0.14-0.09-0.22-0.13 c-0.04-0.06-0.08-0.11-0.11-0.15c-0.24-0.35-0.62-0.55-1.03-0.56c-0.02,0-0.05,0.05-0.02,0.05c0.32,0.03,0.61,0.21,0.82,0.48 c-0.21-0.15-0.47-0.22-0.67-0.37c-0.02-0.02-0.06,0.03-0.04,0.05c0.04,0.04,0.08,0.07,0.12,0.11c-1.16-0.4-2.38-0.54-3.59-0.61 c-0.11-0.01-0.23-0.01-0.35-0.02c0.04-0.01,0.08-0.02,0.12-0.04c0.01-0.01,0.03-0.05,0.01-0.04c-0.09,0.02-0.21-0.02-0.32-0.04 c0.24-0.03,0.48-0.05,0.73-0.07c0.02,0,0.07-0.06,0.03-0.07c-0.39-0.09-0.78-0.08-1.16,0.01c-0.08,0.02-0.17,0.04-0.27,0.08 c0.28-0.22,0.66-0.33,0.97-0.39c0.03,0,0.07-0.07,0.03-0.07c-0.4,0.01-0.78,0.13-1.08,0.37c0.11-0.19,0.27-0.35,0.44-0.45 c0.02-0.01,0.05-0.08,0-0.07c-0.19,0.07-0.31,0.18-0.43,0.31c0.06-0.13,0.12-0.25,0.17-0.38c0.01-0.03-0.03-0.03-0.04,0 c-0.06,0.11-0.12,0.22-0.19,0.33c0-0.09-0.01-0.17-0.03-0.25c-0.03-0.09-0.06-0.2-0.12-0.27c-0.04-0.04-0.13-0.09-0.15-0.14 c-0.02-0.03-0.05,0.02-0.05,0.04c0.01,0.05,0.01,0.04,0.06,0.08c0.1,0.09,0.12,0.25,0.14,0.38c0,0.02,0,0.09,0,0.17 c-0.05-0.23-0.17-0.44-0.31-0.63c-0.02-0.02-0.06,0.03-0.05,0.05c0.07,0.13,0.16,0.33,0.21,0.53c-0.02-0.02-0.04-0.05-0.06-0.07 c-0.02-0.04-0.04-0.07-0.06-0.11c-0.05-0.12-0.13-0.22-0.22-0.31c-0.02-0.02-0.06,0.03-0.04,0.05c0.04,0.06,0.08,0.12,0.11,0.19 c-0.35-0.26-0.82-0.47-1.09-0.56c-0.05-0.06-0.1-0.12-0.14-0.16c-0.2-0.24-0.49-0.31-0.74-0.45c-0.02-0.01-0.05,0.04-0.03,0.05 c0.18,0.14,0.37,0.23,0.54,0.39c0.03,0.03,0.06,0.06,0.09,0.1c0,0-0.01,0-0.01,0c-0.04-0.05-0.09-0.09-0.14-0.12 c-0.19-0.13-0.39-0.23-0.61-0.32c-0.02-0.01-0.05,0.04-0.03,0.05c0.15,0.09,0.28,0.18,0.41,0.29c-0.57-0.16-1.15-0.31-1.74-0.37 c-0.12-0.01-0.25-0.03-0.39-0.04c0.2-0.06,0.42-0.09,0.62-0.15c0.02-0.01,0.06-0.08,0.02-0.07c-0.15,0.01-0.29,0.01-0.43,0.03 c0.15-0.06,0.3-0.11,0.44-0.18c0.02-0.01,0.05-0.07,0.01-0.06c-0.3,0.07-0.58,0.12-0.84,0.27c-0.01,0.01-0.02,0.01-0.03,0.02 c0.07-0.13,0.09-0.27,0.13-0.42c0.02-0.06-0.05-0.03-0.06,0c-0.06,0.14-0.09,0.28-0.18,0.4c0.04-0.15,0.05-0.31,0.04-0.46 c0-0.04-0.06,0.01-0.06,0.03c-0.01,0.06-0.02,0.13-0.03,0.2c-0.06-0.1-0.17-0.16-0.29-0.2c-0.07-0.03-0.15-0.04-0.23-0.06 c0.29-0.13,0.58-0.33,0.67-0.42c0.02-0.02,0.02-0.07-0.02-0.04c-0.08,0.07-0.3,0.2-0.53,0.29c0.01,0,0.01-0.01,0.02-0.01 c0.18-0.12,0.27-0.3,0.35-0.5c0.01-0.04-0.03-0.02-0.04,0c-0.09,0.14-0.17,0.27-0.32,0.36c-0.01,0.01-0.02,0.01-0.03,0.02 c0.03-0.04,0.05-0.09,0.07-0.13c0.05-0.12,0.18-0.46,0.05-0.56c-0.02-0.01-0.04,0.02-0.03,0.04c0.04,0.08,0,0.22-0.05,0.34 c0.01-0.26-0.09-0.52-0.34-0.73c-1.09-0.94-2.82-0.96-4.15-1.04c-0.2-0.01-0.41-0.02-0.61-0.03c-0.93-0.07-1.87-0.1-2.8-0.09 c0-0.01-0.01-0.02-0.02-0.02c-0.07-0.02-0.14-0.03-0.22-0.03c-0.13-0.06-0.24-0.14-0.31-0.29c-0.01-0.03-0.06,0.02-0.05,0.05 c0.03,0.08,0.08,0.16,0.13,0.23c-0.19-0.01-0.38-0.03-0.51-0.17c-0.02-0.02-0.06,0.03-0.05,0.06c0.05,0.06,0.11,0.12,0.19,0.16 c-0.05-0.01-0.1-0.01-0.14-0.02c-0.13-0.03-0.33-0.02-0.39-0.18c-0.01-0.02-0.05,0.01-0.05,0.03c0.02,0.1,0.1,0.17,0.18,0.21 c-0.75,0.03-1.55,0.12-2.2,0.43c-0.03,0.01-0.06,0.01-0.08,0.02c-0.01,0-0.02,0-0.04,0.01c0,0,0,0,0,0 c-0.15,0.04-0.48,0.11-0.57-0.03c-0.01-0.02-0.05,0.02-0.04,0.04c0.04,0.1,0.15,0.15,0.3,0.16c-0.11,0.04-0.23,0.05-0.33,0.01 c-0.02-0.01-0.06,0.04-0.03,0.05c0.05,0.02,0.11,0.04,0.18,0.04c-0.2,0.11-0.38,0.25-0.45,0.46c-0.23-0.02-0.45-0.13-0.5-0.39 c-0.01-0.04-0.05,0.01-0.05,0.03c0.01,0.17,0.11,0.32,0.24,0.43c-0.14-0.01-0.26-0.06-0.32-0.18c-0.01-0.02-0.05,0.02-0.04,0.04 c0.04,0.11,0.11,0.18,0.2,0.23c-0.06-0.01-0.12-0.01-0.18-0.03c-0.03-0.01-0.07,0.05-0.04,0.06c0.04,0.02,0.09,0.04,0.14,0.05 c-0.42,0.08-0.85,0.19-1.29,0.33c-0.47,0.15-1.17,0.37-1.53,0.73c-0.12,0.11-0.24,0.22-0.37,0.32c-0.03-0.01-0.06,0-0.09,0.01 c-0.09-0.02-0.21-0.06-0.19-0.16c0.01-0.02-0.01-0.02-0.02-0.01c0.01-0.05,0.02-0.1,0.03-0.14c0.01-0.04-0.04-0.02-0.05,0 c-0.06,0.15-0.12,0.32-0.1,0.49c-0.08-0.02-0.15-0.06-0.22-0.09c-0.15-0.06-0.22-0.18-0.33-0.29c-0.04-0.04-0.1,0.04-0.11,0.07 c-0.04,0.1,0.01,0.21,0.08,0.3c-0.18-0.11-0.38-0.17-0.59-0.16c-0.06,0-0.19,0.14-0.11,0.19c0.09,0.06,0.2,0.1,0.29,0.15 c0.01,0,0.01,0.01,0.02,0.01c-0.92,0.06-1.83,0.16-2.75,0.28c-0.02-0.01-0.04-0.02-0.06-0.03c-0.16-0.1-0.11-0.35-0.07-0.51 c0.01-0.04-0.04-0.01-0.05,0.01c-0.06,0.14-0.11,0.3-0.09,0.45c-0.15-0.06-0.23-0.16-0.33-0.28c-0.05-0.05-0.14,0.07-0.13,0.11 c0.01,0.04,0.02,0.08,0.04,0.11c-0.11-0.05-0.22-0.11-0.34-0.18c-0.06-0.03-0.14,0.05-0.13,0.11c0.02,0.08,0.06,0.14,0.12,0.19 c-0.13,0.01-0.26-0.01-0.39-0.08c-0.02-0.01-0.06,0.04-0.04,0.06c0.1,0.09,0.24,0.15,0.39,0.17c-0.02,0-0.04,0.01-0.06,0.01 c-0.71,0.11-1.57,0.18-2.35,0.39c-0.27-0.01-0.55,0.05-0.81,0.12c-0.09,0.02-0.69,0.21-0.63,0.37c-0.01-0.02-0.04,0.01-0.04,0.02 c0,0.01,0,0.01,0,0.02c-0.01,0.03,0.02,0.04,0.04,0.02c0.11-0.08,0.22-0.14,0.34-0.18c-0.23,0.12-0.6,0.36-0.55,0.6 c0.01,0.05,0.07-0.01,0.07-0.03c0.03-0.12,0.16-0.22,0.3-0.31c-0.11,0.13-0.2,0.32-0.17,0.48c-0.43,0.11-0.86,0.23-1.28,0.38 c-0.7,0.25-1.42,0.54-1.95,1.1c-0.04,0.04-0.07,0.08-0.09,0.12c-0.02-0.01-0.04-0.01-0.06-0.02c-0.1-0.03-0.29-0.09-0.31-0.22 c-0.01-0.04-0.05,0.01-0.05,0.03c-0.03,0.14,0.06,0.26,0.18,0.35c-0.05,0-0.1,0-0.15-0.01c-0.03-0.01-0.08-0.02-0.12-0.03 c-0.03-0.02-0.04-0.02-0.07-0.02c-0.07-0.03-0.14-0.07-0.16-0.14c-0.01-0.03-0.05,0.02-0.05,0.04c0,0.03,0.02,0.06,0.03,0.08 c-0.01,0-0.01,0-0.02-0.01c-0.12-0.04-0.19-0.13-0.29-0.2c-0.02-0.01-0.04,0.02-0.04,0.04c0.02,0.07,0.07,0.14,0.12,0.2 c0,0,0,0-0.01,0c-0.16-0.02-0.41-0.09-0.49-0.24c-0.01-0.02-0.03,0.01-0.03,0.02c-0.01,0.14,0.13,0.26,0.25,0.33 c-0.86,0.1-1.72,0.29-2.55,0.51c-0.4,0.11-0.78,0.23-1.15,0.37c-0.09,0.01-0.19,0.02-0.29,0c-0.13-0.02-0.37-0.11-0.36-0.28 c0-0.04-0.05-0.01-0.05,0.02c-0.03,0.14,0.02,0.25,0.12,0.33c-0.12-0.01-0.23-0.05-0.3-0.15c-0.01-0.02-0.04,0.02-0.04,0.04 c0.06,0.15,0.22,0.23,0.4,0.25c-0.03,0.01-0.05,0.02-0.08,0.03c-0.01,0-0.01,0-0.02,0c-0.04,0.02-0.08,0.04-0.13,0.06 c-0.11,0.05-0.23,0.11-0.34,0.16c-0.01,0-0.02-0.01-0.04,0c-0.07,0.03-0.14,0.06-0.21,0.09c-0.14,0.03-0.28,0.04-0.42-0.02 c-0.03-0.01-0.08,0.05-0.05,0.07c0.04,0.03,0.09,0.06,0.14,0.07c-0.18,0.05-0.36,0.06-0.54-0.03c-0.02-0.01-0.06,0.04-0.04,0.06 c0.09,0.1,0.22,0.14,0.35,0.14c-0.3,0.17-0.62,0.39-0.63,0.64c0,0,0,0,0,0.01c-0.02-0.01-0.03-0.02-0.05-0.03 c-0.13-0.1-0.25-0.23-0.33-0.37c-0.01-0.02-0.05,0.02-0.04,0.04c0.05,0.15,0.12,0.32,0.22,0.44c-0.04,0-0.08,0-0.12-0.01 c-0.12-0.02-0.31-0.09-0.36-0.22c-0.01-0.02-0.04,0.01-0.04,0.02c-0.03,0.14,0.11,0.25,0.22,0.31c0,0.01,0,0.02,0.01,0.03 c0.05,0.06,0.11,0.11,0.18,0.14c-0.03,0.01-0.06,0.02-0.09,0.02c-0.06,0.01-0.09-0.03-0.15-0.04c-0.04-0.01-0.1,0.06-0.07,0.1 c0.05,0.06,0.04,0.1,0.12,0.14c0.03,0.01,0.06,0.02,0.1,0.02c-0.11,0.09-0.22,0.16-0.36,0.15c-0.05,0-0.13,0.11-0.07,0.14 c0.11,0.05,0.23,0.02,0.34-0.02c-0.11,0.11-0.23,0.22-0.34,0.2c-0.05-0.01-0.16,0.1-0.1,0.14c0.07,0.05,0.15,0.06,0.24,0.03 c-0.22,0.17-0.48,0.32-0.69,0.13c-0.04-0.04-0.12,0.06-0.1,0.1c0.06,0.15,0.17,0.21,0.31,0.23c-0.05,0.04-0.1,0.08-0.16,0.11 c-0.14,0.1-0.29,0.23-0.38,0.37c-0.01,0.02-0.02,0.06,0,0.07c0,0,0.01,0,0.01,0.01c0.02,0.02,0.05,0.01,0.07,0 c0.09-0.06,0.18-0.12,0.28-0.17c-0.01,0.01-0.03,0.03-0.04,0.04c-0.09,0.09-0.17,0.18-0.24,0.28c-0.07,0.09-0.13,0.25-0.22,0.32 c-0.03,0.02-0.06,0.11-0.04,0.14c-0.07,0.07-0.13,0.14-0.19,0.2c0,0,0,0,0,0c-0.01,0.01-0.02,0.02-0.02,0.03 c-0.04,0.04-0.07,0.08-0.09,0.1c-0.22,0.27-0.45,0.71-0.36,1.08c0.02,0.1,0.15-0.01,0.15-0.07c0.03-0.27,0.2-0.52,0.37-0.72 c-0.02,0.05-0.05,0.1-0.07,0.16c-0.15,0.36-0.38,0.83-0.23,1.23c0.01,0.03,0.04,0.04,0.07,0.04c0.01,0,0.02,0,0.04,0 c-0.04,0.16-0.03,0.32,0.05,0.46c0.05,0.08,0.18-0.05,0.16-0.12c-0.01-0.19,0.07-0.36,0.18-0.52c0.01,0,0.01,0,0.02,0 c-0.07,0.13-0.13,0.31-0.07,0.39c0,0,0,0,0,0c0.04,0.05,0.12-0.05,0.13-0.08c0.05-0.12,0.12-0.23,0.19-0.33 c-0.01,0.01-0.02,0.03-0.03,0.04c-0.05,0.1-0.25,0.51-0.01,0.5c0.05,0,0.13-0.08,0.09-0.14c-0.03-0.05,0.08-0.18,0.16-0.27 c0.01,0.15,0.14,0.51,0.33,0.41c0.03-0.02,0.11-0.13,0.04-0.15c-0.02-0.01-0.03-0.1-0.02-0.2c0.08,0.03,0.2,0.05,0.34,0.06 c0.48,0.03,0.94-0.01,1.39-0.11c-0.13,0.1-0.26,0.21-0.4,0.32c-0.06,0.04-0.06,0.17,0.03,0.12c0.26-0.14,0.5-0.31,0.79-0.41 c0.05-0.02,0.11-0.03,0.16-0.04c-0.06,0.1-0.11,0.21-0.14,0.32c0,0,0,0,0,0c0,0,0,0,0,0.01c0,0.01,0,0.01-0.01,0.02c0,0,0,0,0,0 c-0.01,0.08,0.07,0.1,0.13,0.04c0.15-0.15,0.3-0.29,0.47-0.41c0.01,0,0.02-0.01,0.03-0.01c0,0.01,0,0.01,0,0.02 c-0.02,0.03-0.03,0.06,0,0.08c0.1,0.1,0.36-0.13,0.44-0.18c0.09-0.06,0.17-0.13,0.24-0.21c0,0,0,0,0.01,0 c-0.15,0.16-0.26,0.33-0.33,0.55c0,0.01-0.01,0.03,0,0.04c0,0,0.01,0.01,0.01,0.01c0.02,0.02,0.06,0,0.08-0.02 c0.11-0.11,0.22-0.2,0.34-0.29c0.01,0.02,0.02,0.04,0.04,0.05c0.33,0.08,0.75-0.2,1.04-0.34c0.1-0.05,0.2-0.1,0.3-0.16 c-0.09,0.17-0.15,0.36-0.12,0.53c0.02,0.11,0.16-0.01,0.16-0.08c0.02-0.2,0.2-0.39,0.36-0.53c-0.07,0.12-0.13,0.24-0.17,0.37 c-0.01,0.04,0.01,0.08,0.04,0.1c0.11,0.06,0.26,0.07,0.41,0.05c0,0,0,0,0,0c0,0,0,0.01,0,0.01c0.03,0.08,0.05,0.16,0.08,0.24 c0,0.01,0,0.01,0.01,0.02c0.03,0.08,0.06,0.16,0.09,0.23c0,0.01,0.01,0.01,0.01,0.02c0,0,0,0,0,0c0.16,0.35,0.37,0.66,0.73,0.85 c0.32,0.17,0.59,0.23,0.94,0.29c0.13,0.02,0.37,0.04,0.56,0.08c0.24,0.49,0.58,0.93,1.07,1.3c1.24,0.94,3.13,0.38,4.53,0.43 c0.92,0.03,1.83,0.18,2.75,0.27c0.35,0.03,0.71,0.06,1.06,0.08c0,0,0,0,0,0c0.01,0,0.02,0,0.03,0c0.15,0.01,0.31,0.02,0.46,0.03 c0.06,0,0.13,0.01,0.19,0.01c0.06,0,0.12,0.01,0.18,0.01c0.07,0.01,0.15,0.01,0.22,0.02c0.05,0,0.1,0.01,0.15,0.01 c0.12,0.01,0.25,0.02,0.37,0.04c0.86,0.09,1.72,0.26,2.52,0.59c0.86,0.35,1.64,0.91,2.4,1.45c0.64,0.46,1.3,0.9,1.89,1.42 c0.32,0.28,0.59,0.62,0.79,1c0.21,0.38,0.11,0.9,0.1,1.31c-0.02,0.81,0.04,1.55,0.32,2.31c0.23,0.64,0.58,1.24,0.55,1.85 c-0.11,0.31-0.23,0.59-0.36,0.89c-0.45,0.59-0.98,1.07-1.36,1.72c-0.38,0.65-0.6,1.44-0.72,2.19c-0.05,0.28-0.08,0.6-0.19,0.87 c-0.11,0.42-0.3,0.8-0.64,1.13c-0.02,0.02-0.04,0.04-0.06,0.06c0,0,0,0,0,0c0,0,0,0,0,0c-0.03,0.03-0.07,0.07-0.1,0.11 c0,0,0,0,0,0c-0.03,0.04-0.07,0.08-0.1,0.12c0,0,0,0,0,0c-0.03,0.04-0.07,0.08-0.1,0.12c0,0,0,0,0,0 c-0.03,0.04-0.06,0.08-0.1,0.13c0,0,0,0-0.01,0.01c-0.03,0.04-0.06,0.08-0.09,0.13c0,0-0.01,0.01-0.01,0.01 c-0.03,0.04-0.06,0.09-0.09,0.13c0,0.01-0.86,1.66-0.86,1.66c-0.03,0.04-0.05,0.08-0.08,0.13c0,0.01-0.01,0.02-0.01,0.02 c-0.03,0.04-0.05,0.08-0.08,0.12c-0.01,0.01-0.01,0.02-0.02,0.03c-0.02,0.04-0.05,0.08-0.07,0.12c-0.01,0.01-0.01,0.03-0.02,0.04 c-0.02,0.04-0.04,0.08-0.06,0.11c-0.01,0.01-0.02,0.03-0.02,0.05c-0.02,0.04-0.04,0.07-0.05,0.11c-0.01,0.02-0.02,0.04-0.03,0.06 c-0.02,0.03-0.03,0.07-0.05,0.1c-0.01,0.02-0.02,0.04-0.03,0.07c-0.01,0.03-0.03,0.06-0.04,0.09c-0.01,0.03-0.02,0.05-0.03,0.08 c-0.01,0.03-0.02,0.05-0.03,0.08c-0.01,0.03-0.02,0.06-0.04,0.09c-0.01,0.02-0.02,0.04-0.02,0.06c-0.02,0.05-0.04,0.1-0.05,0.15 c0.01,0,0.01,0,0.02-0.01c0,0,0.01,0,0.01,0c0.01,0,0.02,0,0.03,0c0,0,0.01,0,0.01,0c0.03,0,0.06,0,0.1-0.01c0,0,0.01,0,0.01,0 c0.02,0,0.04,0,0.06,0c0,0,0,0,0,0c0.16,0,0.38,0,0.56,0c0,0,0,0,0,0c0.02,0,0.03,0,0.04,0c0.05,0,0.1,0,0.14,0 c0.03,0,0.07,0,0.09,0c0.21,0,0.52,0.01,0.9,0.02c0,0,0,0,0,0c0.05,0,0.1,0,0.15,0c0,0,0,0,0,0c0.31,0.01,0.66,0.02,1.03,0.02 c0,0,0,0,0,0c0.01,0,0.01,0,0.02,0c0.12,0,0.25,0,0.37,0c0.03,0,0.06,0,0.08,0c0.13,0,0.26-0.01,0.38-0.01c0.01,0,0.01,0,0.02,0 c0.14-0.01,0.27-0.01,0.41-0.02c0.03,0,0.06,0,0.09-0.01c0.14-0.01,0.28-0.02,0.41-0.04c0.31-0.03,1.22-5.74,1.41-6.18 c0.03-0.06,0.06-0.12,0.09-0.18c0.04-0.09,0.08-0.18,0.14-0.26c0.15-0.26,0.32-0.5,0.51-0.73c0.95-1.19,1.49-2.35,1.33-3.94 c-0.1-0.98-0.17-1.84-0.04-2.83c0.1-0.72,0.33-1.48,0.97-1.85c0.85-0.5,1.98-0.6,2.91-0.84c0.36-0.09,0.72-0.17,1.08-0.26 c1.45-0.34,2.9-0.68,4.29-1.21c0.13-0.05,0.26-0.11,0.39-0.17c0.05-0.02,0.1-0.05,0.15-0.07c0.04-0.02,0.08-0.04,0.12-0.06 c0.05-0.02,0.09-0.05,0.14-0.07c0.04-0.02,0.08-0.05,0.12-0.07c0.04-0.02,0.09-0.05,0.13-0.08c0.04-0.02,0.08-0.05,0.12-0.07 c0.04-0.03,0.09-0.05,0.13-0.08c0.04-0.03,0.08-0.05,0.12-0.08c0.04-0.03,0.08-0.06,0.13-0.08c0.04-0.03,0.08-0.06,0.12-0.08 c0.04-0.03,0.08-0.06,0.12-0.09c0.04-0.03,0.08-0.06,0.12-0.09c0.04-0.03,0.08-0.06,0.12-0.09c0.04-0.03,0.08-0.06,0.11-0.09 c0.04-0.03,0.08-0.06,0.12-0.1c0.04-0.03,0.07-0.06,0.11-0.09c0.04-0.03,0.08-0.07,0.12-0.1c0.04-0.03,0.07-0.06,0.11-0.09 c0.04-0.04,0.08-0.07,0.12-0.11c0.03-0.03,0.07-0.06,0.1-0.09c0.04-0.04,0.08-0.08,0.12-0.11c0.03-0.03,0.06-0.06,0.1-0.09 c0.04-0.04,0.08-0.08,0.13-0.12c0.03-0.03,0.06-0.06,0.09-0.09c0.04-0.04,0.09-0.09,0.13-0.13c0.03-0.03,0.05-0.05,0.08-0.08 c0.05-0.05,0.1-0.1,0.15-0.15c0.02-0.02,0.04-0.04,0.06-0.06c0.07-0.07,0.14-0.14,0.21-0.21c0.09-0.09,0.18-0.19,0.27-0.29 c0.02-0.02,0.04-0.04,0.06-0.06c0.41-0.46,0.78-0.96,1.11-1.49c0.12-0.2,0.21-0.41,0.32-0.62c0.28-0.17,0.59-0.29,0.93-0.41 c0.05-0.02,0.1-0.07,0.15-0.14c0,0,0.01,0,0.01,0c0.61,0.02,1.22,0.08,1.83-0.01c0.13,0,0.27-0.01,0.4-0.02c0,0,0,0,0,0 c0.01,0,0.03,0,0.04-0.01c0.01,0,0.03,0,0.04-0.01c0.04-0.01,0.09-0.01,0.13-0.02c0.01,0,0.02,0,0.02-0.01 c0.04-0.01,0.07-0.02,0.11-0.03c0.01,0,0.02-0.01,0.04-0.01c0.04-0.01,0.08-0.03,0.13-0.05c0,0,0.01,0,0.01-0.01 c0.04-0.02,0.08-0.03,0.11-0.05c0.01-0.01,0.02-0.01,0.03-0.02c0.04-0.02,0.08-0.05,0.12-0.07c0.09-0.06,0.17-0.13,0.25-0.21 c0.01-0.01,0.02-0.01,0.03-0.02c0.09,0.04,0.19,0.04,0.31,0c0.03,0,0.06,0,0.09,0c0.02,0,0.04,0,0.06,0c0.03,0,0.05,0,0.08,0 c-0.04,0.1-0.07,0.19-0.09,0.29c-0.03,0.12,0.13,0.02,0.15-0.03c0.04-0.1,0.09-0.19,0.15-0.27c0.02,0,0.04,0,0.05,0 c0,0.11,0.01,0.22,0.05,0.33c0.04,0.1,0.17-0.05,0.17-0.1c0.01-0.1,0.03-0.18,0.06-0.27c0,0,0,0,0.01,0 c0.09,0.21,0.23,0.4,0.42,0.51c0.07,0.04,0.19-0.06,0.2-0.14c0.13,0.11,0.29,0.2,0.47,0.24c0.13,0.03,0.26-0.13,0.26-0.26 c0.11,0.08,0.23,0.14,0.37,0.18c0.04,0.01,0.08-0.02,0.1-0.05c0,0,0-0.01,0.01-0.01c0.02-0.03,0.04-0.07,0.03-0.1 c-0.01-0.02-0.02-0.03-0.02-0.05c0.25,0.08,0.59,0.06,0.82-0.01c0.01,0,0.02-0.01,0.03-0.01c0.1,0.08,0.21,0.16,0.27,0.27 c0.04,0.07,0.14-0.03,0.14-0.09c0.01-0.06,0-0.11-0.01-0.15c0.11,0.07,0.21,0.14,0.32,0.19l0,0c0.05,0.02,0.12-0.07,0.12-0.12 c0-0.01,0-0.02,0-0.02c0.15,0.08,0.33,0.21,0.43,0.33c0.05,0.07,0.18-0.09,0.15-0.15c-0.04-0.09-0.09-0.18-0.16-0.26 c0.05-0.01,0.11-0.01,0.16-0.02c0.03,0.07,0.06,0.14,0.11,0.2c0.05,0.07,0.11,0.14,0.18,0.2c0.07,0.06,0.15,0.06,0.23,0.07 c0.04,0.01,0.12-0.07,0.09-0.11c0.13,0.06,0.25,0.08,0.37,0.05c-0.01,0.09-0.03,0.19-0.07,0.25c-0.03,0.04,0.02,0.05,0.04,0.02 c0.07-0.09,0.12-0.21,0.15-0.33c0.04-0.02,0.07-0.05,0.1-0.08c0.01,0.06,0.02,0.11,0.03,0.17c0.01,0.09,0.11,0.01,0.13-0.03 c0.1-0.16,0.11-0.35,0.11-0.53c0-0.05,0-0.1,0-0.15c0,0,0-0.01,0-0.01c0.04,0.06,0.08,0.13,0.09,0.2 c0.02,0.11,0.15-0.02,0.15-0.09c0-0.08-0.01-0.17-0.04-0.25c0.05,0.04,0.1,0.08,0.14,0.13c0.05,0.05,0.07,0.11,0.1,0.17 c0,0,0,0.01,0,0.01l0.01,0.02c0.02,0.03,0.05-0.02,0.05-0.04c0-0.1,0.01-0.15-0.03-0.24c-0.04-0.07-0.09-0.14-0.14-0.2 c-0.01-0.02-0.02-0.03-0.04-0.05c0.08,0.01,0.15,0.03,0.21,0.04c0.09,0.02,0.24-0.18,0.13-0.22c-0.12-0.04-0.24-0.1-0.35-0.17 c0.06-0.02,0.13-0.04,0.19-0.07c0.05-0.03,0.14-0.18,0.03-0.18c-0.12,0-0.23-0.02-0.34-0.05c0.19-0.01,0.41-0.05,0.53-0.15 C69.94,30.44,69.94,30.38,69.9,30.4z M58.02,31.24c-0.09-0.27-0.25-0.49-0.47-0.65c0,0,0,0,0,0c0,0-0.01,0-0.01-0.01 c-0.03-0.02-0.06-0.04-0.09-0.06c-0.01,0-0.01-0.01-0.02-0.01c-0.04-0.02-0.07-0.04-0.11-0.06c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0,0-0.01,0c-0.03-0.01-0.06-0.03-0.09-0.04c0,0,0,0,0,0c0,0-0.01,0-0.01,0c0,0,0,0-0.01,0c0,0-0.01,0-0.01,0 c0.01-0.01,0.01-0.02,0.02-0.04c0.01-0.02,0.02-0.04,0.03-0.06c0.01-0.01,0.01-0.02,0.02-0.03c0,0.02,0,0.05,0.03,0.06 c0.25,0.14,0.54,0.03,0.79-0.09c0.02-0.01,0.04-0.03,0.07-0.04c0,0-0.01,0.01-0.01,0.01c-0.05,0.04-0.13,0.2-0.01,0.17 c0.25-0.06,0.42-0.25,0.59-0.44c-0.03,0.07-0.04,0.15-0.04,0.23c-0.01,0.01-0.03,0.02-0.04,0.03c-0.01,0.01-0.02,0.01-0.03,0.02 c-0.01,0.01-0.03,0.02-0.04,0.03c-0.01,0.01-0.01,0.01-0.02,0.01c0,0,0,0,0,0c-0.09,0.09-0.17,0.19-0.25,0.29 c-0.13,0.17-0.19,0.39-0.25,0.59c0,0,0,0,0,0c-0.01,0.02-0.01,0.04-0.02,0.06c-0.01,0.02-0.02,0.03-0.02,0.05 C58.03,31.26,58.03,31.25,58.02,31.24C58.02,31.24,58.02,31.24,58.02,31.24z M35.93,35.84c-0.18-0.1-0.38-0.18-0.51-0.36 c-0.04-0.05-0.06-0.11-0.09-0.16c-0.04-0.1-0.06-0.2-0.09-0.29c-0.01-0.03-0.02-0.06-0.03-0.08c-0.03-0.09-0.08-0.18-0.12-0.27 c-0.1-0.14-0.2-0.28-0.28-0.43c-0.05-0.09-0.1-0.16-0.15-0.23c-0.06-0.06-0.12-0.12-0.18-0.18c-0.06-0.05-0.12-0.09-0.19-0.13 c-0.12-0.07-0.23-0.14-0.31-0.26c-0.16-0.22-0.15-0.61-0.07-0.86c0.1-0.3,0.51-0.36,0.63-0.66c0.02-0.04,0.03-0.07,0.04-0.11 c0-0.01,0-0.02,0.01-0.02c0.01-0.04,0.02-0.07,0.02-0.1c0,0,0-0.01,0-0.01c0.01-0.03,0.01-0.06,0.01-0.1c0,0,0-0.01,0-0.01 c0-0.03,0-0.07,0-0.1c0,0,0-0.01,0-0.01c0-0.07-0.02-0.13-0.04-0.19c0,0,0,0,0-0.01c-0.02-0.06-0.05-0.13-0.08-0.19c0,0,0,0,0,0 c0,0,0,0,0,0c-0.03-0.07-0.07-0.13-0.12-0.19c0-0.07-0.01-0.14-0.03-0.2c-0.08-0.29-0.28-0.49-0.48-0.69 c-0.05-0.05-0.1-0.1-0.14-0.15c-0.06-0.06-0.11-0.13-0.17-0.2c0.03-0.02,0.06-0.06,0.06-0.08c0-0.01,0-0.02,0.01-0.04 c0.01,0.06,0.03,0.13,0.07,0.19c0.03,0.05,0.08,0.01,0.11-0.02c0.05-0.06,0.07-0.14,0.09-0.22c0.13,0.05,0.27,0.05,0.41,0.03 c0,0.01,0,0.01,0.01,0.02c0,0.01,0,0.02,0,0.03c-0.02,0.01-0.04,0.01-0.06,0.02c-0.06,0.01-0.2,0.17-0.09,0.2 c0.07,0.02,0.14,0.02,0.21,0.01c0.01,0.03,0.02,0.05,0.03,0.07c0,0.01,0.01,0.02,0.01,0.03c0.01,0.02,0.02,0.04,0.03,0.06 c0.01,0.01,0.01,0.02,0.02,0.03c0.01,0.01,0.02,0.03,0.03,0.04c0.01,0.01,0.01,0.02,0.02,0.02c0.01,0.01,0.02,0.02,0.03,0.04 c0.01,0.01,0.01,0.01,0.02,0.02c0.01,0.01,0.02,0.02,0.03,0.03c0.01,0.01,0.01,0.01,0.02,0.02c0.01,0.01,0.02,0.02,0.03,0.03 c0.01,0.01,0.02,0.01,0.02,0.02c0.01,0.01,0.02,0.01,0.04,0.02c0.01,0,0.02,0.01,0.02,0.01c0.01,0.01,0.03,0.01,0.04,0.02 c0,0,0.01,0,0.01,0c0,0,0,0,0,0c0.15,0.07,0.33,0.13,0.53,0.27c0.32,0.22,0.14,0.78,0.4,1.09c0.05,0.06,0.09,0.13,0.14,0.19 c0.03,0.08,0.05,0.16,0.08,0.24c0.41,1.21,1.37,2.11,1.06,3.49c-0.05,0.22-0.07,0.43-0.06,0.63c0,0,0,0,0,0c0,0,0,0,0,0 c0,0.02,0,0.05,0,0.07c0,0.02,0,0.04,0,0.07c0,0.02,0,0.05,0.01,0.07c0,0.02,0.01,0.04,0.01,0.07c0,0.02,0.01,0.04,0.01,0.07 c0,0.01,0,0.02,0.01,0.03C36.67,36.28,36.31,36.05,35.93,35.84z M34.05,35.08c-0.12-0.03-0.23-0.06-0.35-0.09 c-0.02-0.01-0.05-0.01-0.07-0.02c-0.02,0-0.03-0.01-0.05-0.01c-0.04-0.01-0.09-0.02-0.13-0.03c-0.29-0.05-0.58-0.09-0.87-0.13 c-0.59-0.06-1.18-0.09-1.77-0.12c-0.32-0.02-0.64-0.03-0.96-0.05c-0.62-0.04-1.24-0.11-1.86-0.16c-0.29-0.02-0.63,0.05-0.87-0.16 c-0.26-0.22-0.23-0.64-0.54-0.82c-0.19-0.12-0.43-0.15-0.65-0.21c-0.4-0.12-1.01-0.32-0.76-0.87c0.13-0.29,0.19-0.58,0.2-0.86 c0,0,0,0,0,0c0-0.02,0-0.03,0-0.05c0-0.05,0-0.1,0-0.14c0-0.02,0-0.05,0-0.07c0-0.05-0.01-0.09-0.01-0.14 c0-0.02-0.01-0.05-0.01-0.07c0-0.01,0-0.02,0-0.03c0.19,0.01,0.39-0.08,0.56-0.15c0.02-0.01,0.05-0.02,0.07-0.03 c-0.01,0.02-0.03,0.05-0.04,0.07c-0.02,0.05-0.06,0.14,0.02,0.17c0.15,0.05,0.32,0.01,0.5-0.07c-0.03,0.04-0.05,0.08-0.08,0.11 c-0.05,0.07-0.02,0.16,0.07,0.09c0.08-0.06,0.16-0.14,0.23-0.21c0.02,0.04,0.03,0.09,0.05,0.13c0.01,0.01,0.01,0.03,0.02,0.04 c0.02,0.05,0.04,0.09,0.06,0.13c0,0,0,0.01,0.01,0.01c0.03,0.06,0.06,0.12,0.09,0.18c0,0,0,0,0,0c0,0,0,0,0,0 c0.24,0.44,0.57,0.78,1.16,0.87c0.2,0.03,0.36,0.03,0.52,0.01c0.02,0,0.03,0,0.05-0.01c0.02,0,0.04-0.01,0.06-0.01 c0.03-0.01,0.05-0.01,0.08-0.02c0.02-0.01,0.04-0.01,0.06-0.02c0.02-0.01,0.05-0.02,0.07-0.03c0.01-0.01,0.03-0.01,0.04-0.02 c0.04-0.02,0.07-0.04,0.11-0.06c0.01-0.01,0.02-0.01,0.03-0.02c0.04-0.02,0.08-0.05,0.12-0.08c0.34-0.23,0.7-0.36,1.06-0.49 c0.17-0.02,0.35-0.04,0.5-0.05c0.11-0.01,0.21-0.02,0.32-0.03c0.04,0,0.08-0.01,0.11-0.01c0.07-0.01,0.15-0.01,0.22-0.01 c0.04,0,0.08,0,0.12-0.01c0.1,0,0.21-0.01,0.31-0.01c0,0,0.01,0,0.01,0c0,0,0,0,0,0c0.12,0,0.25,0,0.37,0.01 c0.5,0.02,1.32,0.1,1.08,0.84c-0.14,0.45-0.16,0.94-0.01,1.39c0.04,0.12,0.09,0.22,0.16,0.32c0,0.01,0.01,0.01,0.01,0.02 c0.05,0.08,0.11,0.16,0.17,0.24c0.01,0.01,0.01,0.01,0.02,0.02c0.03,0.04,0.06,0.07,0.1,0.11c0.06,0.06,0.13,0.13,0.21,0.2 c0.1,0.12,0.2,0.24,0.29,0.37c0.01,0.03,0.02,0.06,0.02,0.09C34.22,35.11,34.14,35.09,34.05,35.08 C34.05,35.08,34.05,35.08,34.05,35.08z M22.24,33.82c-0.4-0.32-0.68-0.74-0.92-1.19c-0.09-0.17-0.18-0.35-0.27-0.52 c-0.06-0.11-0.11-0.22-0.17-0.34c0,0,0-0.01-0.01-0.01c0.05-0.02,0.11-0.12,0.11-0.16c-0.01-0.12,0.04-0.24,0.11-0.35 c0.01,0.03,0.02,0.07,0.04,0.1c0.03,0.07,0.08,0.08,0.13,0.13c0.02,0.02,0.04,0.02,0.07,0.01c0,0,0.01,0,0.01,0 c0.06-0.03,0.14-0.11,0.11-0.19c0,0,0,0,0,0c0-0.01,0-0.02,0-0.03c-0.01-0.03-0.01-0.05-0.02-0.08c-0.01-0.06,0-0.12,0-0.18 c0.09-0.01,0.19-0.04,0.3-0.09c-0.03,0.05-0.05,0.1-0.06,0.15c-0.03,0.11,0.08,0.07,0.12,0.01c0.05-0.09,0.12-0.16,0.19-0.22 c-0.04,0.1-0.06,0.19-0.02,0.27c0,0,0,0,0,0c0.02,0.05,0.1-0.01,0.12-0.04c0.03-0.05,0.06-0.1,0.09-0.15 c-0.05,0.17-0.05,0.3,0.08,0.31c0.03,0,0.09-0.06,0.08-0.1c0.02-0.13,0.11-0.25,0.19-0.36c0.08,0.05,0.21,0.04,0.36-0.02 c0.01,0.02,0.02,0.03,0.03,0.05c-0.01,0.05-0.01,0.1,0.01,0.14c0.01,0.02,0.03,0.03,0.05,0.03c0.03,0,0.06-0.01,0.08-0.02 c0.1,0.09,0.21,0.16,0.32,0.21c0.11,0.06,0.3,0.05,0.43,0.09c0.04,0.01,0.08,0.03,0.12,0.04c0.01,0,0.01,0.01,0.02,0.01 c0.04,0.02,0.07,0.03,0.11,0.05c0.01,0,0.02,0.01,0.03,0.01c0.05,0.03,0.1,0.05,0.15,0.08c0.06,0.03,0.11,0.06,0.16,0.09 c0.21,0.13,0.22,0.38,0.28,0.6c-0.13,0.37-0.33,0.71-0.26,1.15c0.07,0.42,0.55,0.6,0.88,0.7c0.29,0.09,0.55,0.14,0.81,0.3 c-0.25-0.02-0.51,0.03-0.77,0.08c-0.27,0.01-0.54,0.03-0.81,0.04C23.7,34.46,22.91,34.36,22.24,33.82z M50.87,37.48 c-0.03,0.02-0.06,0.03-0.09,0.04c-0.05,0.02-0.1,0.05-0.16,0.07c-0.04,0.02-0.08,0.03-0.12,0.05c-0.04,0.02-0.09,0.03-0.13,0.05 c-0.04,0.02-0.09,0.03-0.13,0.05c-0.04,0.01-0.07,0.02-0.11,0.04c-0.05,0.02-0.1,0.03-0.15,0.05c-0.02,0.01-0.05,0.01-0.07,0.02 c-0.21,0.06-0.43,0.11-0.65,0.15c-0.12,0.02-0.25,0.04-0.38,0.06c-0.76,0.1-1.52,0.07-2.29,0.16c-0.67,0.07-1.27,0.25-1.91,0.42 c-0.17,0.04-0.33,0.1-0.48,0.17c0,0,0,0,0,0c0,0,0,0,0,0c-0.01,0.01-0.03,0.01-0.04,0.02c-0.04,0.02-0.08,0.04-0.12,0.05 c0.07-0.16,0.14-0.31,0.23-0.45c0.03-0.04,0.06-0.08,0.09-0.12c0.21-0.19,0.43-0.35,0.66-0.5c0.28-0.14,0.57-0.24,0.85-0.37 c0.52-0.25,1.04-0.44,1.55-0.73c0.06-0.03,0.11-0.07,0.15-0.11c0.06-0.04,0.13-0.08,0.18-0.12c0.15-0.12,0.27-0.28,0.42-0.41 c0,0,0.01-0.01,0.01-0.01c0.02-0.01,0.03-0.02,0.05-0.02c0.33-0.13,0.65-0.24,0.97-0.4c0.4-0.2,0.8-0.37,1.14-0.67 c0.03-0.02,0.05-0.05,0.07-0.07c-0.01,0.02,0,0.04,0.02,0.02c0.16-0.14,0.26-0.32,0.36-0.5c0.01-0.02,0.02-0.03,0.03-0.05 c0.18-0.26,0.37-0.26,0.59-0.41c0.62-0.43,0.89-0.93,0.86-1.6c0.2-0.57,0.27-1.18,0.27-1.8c0.08-0.21,0.17-0.42,0.27-0.62 c0.02-0.04,0.04-0.09,0.06-0.13c0.02-0.04,0.04-0.08,0.06-0.12c0,0,0,0,0,0c0,0.02,0,0.03,0.01,0.05c0,0.05,0.01,0.1,0.02,0.15 c0,0.01,0,0.02,0,0.03c0,0,0,0,0,0c0.01,0.04,0.01,0.09,0.02,0.13c0.04,0.29,0.01,0.55,0.1,0.83c0.07,0.22,0.36,0.37,0.51,0.51 c0.34,0.32,0.63,1.19,1.19,1.19c0.15,0,0.33-0.04,0.51-0.09c0,0,0,0,0,0c0.08-0.02,0.17-0.05,0.25-0.07 c0.03-0.01,0.06-0.02,0.09-0.02c0.01,0,0.02-0.01,0.04-0.01c0.03-0.01,0.07-0.02,0.1-0.02c0.01,0,0.02,0,0.02,0 c0.03-0.01,0.06-0.01,0.09-0.02c0.01,0,0.02,0,0.02,0c0.03-0.01,0.07-0.01,0.1-0.02c0.01,0,0.02,0,0.03,0 c0.03,0,0.07-0.01,0.1-0.01c0,0,0.01,0,0.01,0c0.03,0,0.06,0,0.1,0c0.01,0,0.01,0,0.02,0c0.03,0,0.07,0,0.1,0.01 c0.01,0,0.01,0,0.02,0c0.03,0,0.06,0.01,0.09,0.02c0,0,0.01,0,0.01,0c0.03,0.01,0.06,0.02,0.09,0.03c0.01,0,0.01,0.01,0.02,0.01 c0.03,0.01,0.06,0.03,0.08,0.05c0,0,0.01,0.01,0.01,0.01c0.03,0.02,0.05,0.04,0.07,0.06c0,0,0.01,0.01,0.01,0.01 c0.02,0.02,0.05,0.05,0.07,0.08c0,0.01,0.01,0.01,0.01,0.02c0.02,0.03,0.05,0.06,0.07,0.1c0.01,0.02,0.03,0.03,0.05,0.02 c0.01,0.06,0.03,0.13,0.04,0.19c-0.01,0.02-0.02,0.03-0.03,0.05c-0.12,0.18-0.25,0.35-0.34,0.54c-0.2,0.42-0.45,0.81-0.78,1.12 c-0.36,0.24-0.76,0.42-1.06,0.77c-0.27,0.31-0.45,0.65-0.79,0.89c-0.29,0.21-0.67,0.39-0.99,0.53c-0.33,0.14-0.69,0.11-1.03,0.18 c-0.32,0.06-0.6,0.22-0.88,0.37C51.04,37.4,50.95,37.44,50.87,37.48z M20.68,31.36c0.04-0.04,0.08-0.08,0.12-0.13 c-0.01,0.02-0.02,0.04-0.02,0.07c-0.02,0.06-0.03,0.13-0.03,0.19C20.72,31.44,20.7,31.4,20.68,31.36z M56.49,31.95 C56.49,31.95,56.49,31.95,56.49,31.95c-0.03-0.01-0.06-0.02-0.1-0.03c-0.01,0-0.02,0-0.02-0.01c-0.03-0.01-0.06-0.01-0.09-0.02 c-0.02,0-0.03,0-0.05-0.01c-0.02,0-0.04-0.01-0.07-0.01c-0.04,0-0.08,0-0.13,0c-0.32,0-0.62,0.13-0.93,0.19 c-0.35,0.07-0.72-0.64-0.88-0.87c-0.16-0.23-0.36-0.39-0.56-0.56c-0.2-0.16-0.23-0.42-0.28-0.66c0,0,0,0,0,0 c0-0.01-0.01-0.02-0.01-0.03c0-0.02-0.01-0.04-0.01-0.05c-0.01-0.04-0.02-0.07-0.03-0.1c-0.05-0.14-0.07-0.28-0.08-0.43 c0,0,0,0,0-0.01c0,0,0,0,0-0.01c0-0.05-0.01-0.09-0.01-0.14c0.01-0.01,0.02-0.03,0.03-0.04c0.01-0.01,0.02-0.03,0.03-0.04 c0.03-0.03,0.05-0.06,0.08-0.09c0.02-0.02,0.05-0.04,0.07-0.06c0.23-0.12,0.48-0.22,0.72-0.31c-0.31,0.21-0.59,0.45-0.85,0.73 c-0.05,0.05-0.07,0.13-0.03,0.19c0.12,0.16,0.45,0.09,0.83-0.05c-0.17,0.13-0.35,0.23-0.53,0.29c-0.04,0.01-0.11,0.14-0.03,0.13 c0.2-0.03,0.39-0.1,0.57-0.2c-0.06,0.24-0.03,0.49,0.15,0.62c0.07,0.05,0.18-0.07,0.16-0.14c-0.02-0.11-0.01-0.22,0.02-0.32 c0,0.06,0.01,0.12,0.04,0.18c0.04,0.08,0.14-0.03,0.16-0.07c0.01-0.03,0.02-0.07,0.04-0.1c0.09,0,0.18-0.02,0.27-0.04 c0,0.02-0.01,0.03-0.01,0.05c0,0.02-0.01,0.03-0.01,0.05c-0.01,0.04-0.01,0.07-0.02,0.11c0,0.02,0,0.03,0,0.05 c0,0.02,0,0.05,0,0.07c0,0.02,0,0.04,0,0.06c0,0.01,0,0.03,0,0.04c0,0,0,0,0,0c0,0.11,0.02,0.21,0.06,0.32 c0.19,0.59,0.75,0.6,1.25,0.54c0,0.1,0.01,0.19,0.02,0.28c0.02,0.15,0.14,0.28,0.23,0.39c0.04,0.05,0.08,0.1,0.11,0.15 C56.56,31.97,56.52,31.96,56.49,31.95C56.49,31.95,56.49,31.95,56.49,31.95z M37.33,32.65C37.33,32.65,37.33,32.65,37.33,32.65 c-0.01-0.04-0.03-0.08-0.04-0.12c0,0,0-0.01,0-0.01c-0.02-0.04-0.03-0.08-0.05-0.11c0,0,0,0,0,0c-0.02-0.03-0.03-0.06-0.05-0.09 c0-0.01-0.01-0.01-0.01-0.02c-0.02-0.03-0.04-0.06-0.06-0.08c-0.33-0.41-0.55-0.69-0.69-1.22c-0.05-0.19-0.13-0.38-0.21-0.57 c-0.02-0.18-0.04-0.35-0.06-0.52c0-0.02-0.01-0.06-0.02-0.12c0.17,0.01,0.35-0.03,0.53-0.1c-0.04,0.03-0.08,0.05-0.12,0.07 c-0.02,0-0.05,0.03-0.06,0.05c0,0,0,0.01,0,0.01c0,0.02,0.01,0.03,0.02,0.03c0.16-0.01,0.32-0.11,0.45-0.21 c-0.01,0.01-0.02,0.03-0.03,0.04c-0.03,0.02-0.03,0.09,0.02,0.06c0.06-0.04,0.1-0.08,0.14-0.14c0.02-0.02,0.04-0.04,0.06-0.06 c0.03,0.12,0.08,0.23,0.14,0.34c0,0.04,0,0.07,0,0.11c0,0.01,0,0.02,0,0.03c0,0.03,0,0.05,0,0.08c0,0.01,0,0.02,0,0.03 c0,0.02,0,0.05,0.01,0.07c0,0.01,0,0.02,0,0.03c0,0.02,0,0.05,0.01,0.07c0,0,0,0.01,0,0.02c0,0,0,0,0,0 c0.01,0.09,0.02,0.17,0.03,0.22c0.04,0.21,0.12,0.4,0.19,0.6c0,0.59,0.05,1.15-0.14,1.72C37.37,32.79,37.35,32.72,37.33,32.65 C37.33,32.65,37.33,32.65,37.33,32.65z M35.54,30.08c-0.06-0.04-0.12-0.07-0.19-0.1c-0.16-0.07-0.27-0.08-0.41-0.15 c0.03-0.08,0.06-0.16,0.11-0.22c0,0.06,0,0.11,0.03,0.16c0.02,0.04,0.07-0.02,0.07-0.04c0.01-0.09,0.04-0.17,0.07-0.25 c0-0.01,0.01-0.02,0.01-0.03c0,0,0,0.01,0,0.01c0,0.03,0.02,0.05,0.05,0.06c0.11,0.05,0.24,0.05,0.37,0.02c0,0,0,0,0,0.01 c-0.06,0.06-0.12,0.12-0.18,0.19c-0.03,0.03-0.01,0.08,0.03,0.04c0.05-0.04,0.1-0.08,0.16-0.12c0,0.04,0.01,0.07,0.01,0.11 c0,0.02,0,0.02,0,0.03c0.01,0.07,0.02,0.13,0.04,0.2c-0.01,0.03-0.01,0.06-0.01,0.09c0,0,0,0,0,0c0,0.03-0.01,0.06-0.01,0.1 C35.64,30.14,35.59,30.11,35.54,30.08C35.54,30.08,35.54,30.08,35.54,30.08C35.54,30.08,35.54,30.08,35.54,30.08z M34.8,29.72 c-0.01-0.02-0.02-0.05-0.03-0.07c0.02-0.01,0.03-0.02,0.05-0.02c0.02-0.01,0.03-0.02,0.05-0.03c-0.02,0.05-0.03,0.09-0.05,0.14 C34.82,29.74,34.81,29.73,34.8,29.72z M56.41,30.29C56.41,30.29,56.4,30.29,56.41,30.29C56.4,30.3,56.4,30.3,56.41,30.29 c-0.01,0.01-0.01,0.02-0.01,0.02c-0.24,0.02-0.5,0.03-0.64-0.09c-0.02-0.02-0.04-0.03-0.05-0.06c0,0,0,0,0,0 c-0.01-0.02-0.02-0.04-0.03-0.07c0,0,0-0.01,0-0.01c-0.01-0.02-0.01-0.05-0.02-0.08c0-0.01,0-0.01,0-0.02c0-0.04,0-0.07,0-0.12 c0-0.04,0.01-0.09,0.03-0.14c0.03-0.03,0.06-0.05,0.09-0.08c-0.04,0.08-0.06,0.17-0.07,0.25c-0.01,0.02-0.02,0.04-0.01,0.06 c0,0.03,0.01,0.05,0.03,0.06c0.06,0.05,0.14-0.05,0.17-0.1c0.04-0.1,0.12-0.19,0.2-0.27c-0.04,0.08-0.06,0.17-0.07,0.26 c0,0.1,0.12-0.01,0.14-0.05c0.04-0.11,0.12-0.2,0.21-0.27c-0.04,0.16-0.05,0.32-0.04,0.5c0.01,0.1,0.13-0.01,0.14-0.05 c0.08-0.2,0.14-0.4,0.27-0.57c-0.1,0.2-0.16,0.39-0.12,0.5C56.53,30.08,56.46,30.18,56.41,30.29z M51.4,31.72 c0.01,0.04,0.02,0.09,0.02,0.13c0,0.01,0,0.02,0,0.04c0,0.03,0.01,0.07,0.01,0.1c0,0.01,0,0.02,0,0.03c0,0.04,0,0.08,0,0.12 c0,0.01,0,0.02,0,0.04c0,0.03-0.01,0.06-0.01,0.09c0,0.01,0,0.03-0.01,0.04c-0.01,0.03-0.01,0.07-0.02,0.1 c0,0.02-0.01,0.03-0.01,0.05c-0.01,0.03-0.01,0.05-0.02,0.08c-0.01,0.02-0.01,0.04-0.02,0.05c-0.01,0.02-0.01,0.04-0.02,0.06 c-0.01,0.03-0.02,0.05-0.04,0.08c-0.01,0.02-0.02,0.04-0.03,0.06c-0.01,0.02-0.02,0.04-0.04,0.07c-0.01,0.01-0.01,0.02-0.02,0.03 c-0.01,0.02-0.03,0.05-0.04,0.07c0,0,0,0,0,0.01c-0.03,0.05-0.07,0.1-0.11,0.16c0,0,0,0,0,0c-0.02,0.03-0.04,0.05-0.06,0.08v0 c-0.32,0.38-0.77,0.7-1.22,0.96c0,0,0,0,0,0c-0.17,0.1-0.34,0.18-0.51,0.26c0,0,0,0,0,0c-0.16,0.08-0.32,0.14-0.47,0.2 c-0.01,0-0.02,0.01-0.03,0.01c-0.04,0.01-0.07,0.03-0.11,0.04c-0.01,0-0.02,0.01-0.03,0.01c-0.04,0.02-0.08,0.03-0.12,0.05 c-0.42,0.15-0.85,0.45-1.31,0.45c-0.48,0-0.65-0.41-0.74-0.84c-0.03-0.24-0.04-0.48-0.05-0.72c0.01-0.13,0.03-0.27,0.03-0.39 c0.13-0.15,0.25-0.3,0.36-0.46c0.07-0.1,0.14-0.22,0.19-0.33c0.03-0.03,0.06-0.07,0.1-0.1c0.4-0.4,0.89-0.58,1.25-1.05 c0.19-0.25,0.37-0.52,0.51-0.81c0,0,0,0,0,0c0,0,0,0,0,0c0.03-0.07,0.06-0.13,0.09-0.2c0.01-0.01,0.01-0.03,0.02-0.04 c0-0.01,0.01-0.01,0.01-0.02C48.98,30.2,49,30.17,49,30.16c0.03-0.08,0.06-0.16,0.1-0.24c0.34,0.07,0.72-0.05,1.08-0.23 c0,0,0,0.01,0,0.01c-0.03,0.04-0.06,0.06-0.09,0.07l0,0c-0.05,0.02-0.1,0.09-0.11,0.12c0,0,0,0,0,0 c-0.01,0.04,0.01,0.07,0.05,0.07c0.05,0,0.1-0.02,0.15-0.04c0.01,0.06,0.03,0.13,0.05,0.18c0.01,0.02,0.01,0.03,0.02,0.04 c0.02,0.04,0.03,0.08,0.05,0.12c0,0.01,0,0.01,0.01,0.02c0,0,0,0,0,0c0.13,0.27,0.34,0.49,0.56,0.73 c0.16,0.18,0.42,0.39,0.51,0.63c0,0,0,0,0,0C51.38,31.68,51.39,31.7,51.4,31.72z M41.23,38.62c-0.02,0.01-0.03,0.01-0.05,0.02 c-0.01,0-0.02,0.01-0.03,0.01c-0.02,0.01-0.04,0.01-0.05,0.01c-0.01,0-0.02,0-0.03,0.01c-0.03,0.01-0.06,0.01-0.09,0.01 c-0.08,0-0.17-0.01-0.25-0.03c-0.4-0.29-0.76-0.64-1.19-0.88c-0.27-0.15-0.54-0.31-0.79-0.49c-0.07-0.1-0.13-0.2-0.18-0.31 c-0.26-0.53-0.3-1.13,0.2-1.63c0.23-0.23,0.53-0.42,0.7-0.73c0.21-0.38,0.43-0.8,0.57-1.24c0.01-0.03,0.02-0.05,0.02-0.08 c0.06-0.22,0.11-0.44,0.12-0.66c0.03-0.63-0.36-1.14-0.71-1.61c-0.31-0.42-0.56-0.79-0.7-1.19c-0.01-0.04-0.03-0.08-0.04-0.12 c0-0.01-0.01-0.03-0.01-0.04c-0.01-0.04-0.02-0.08-0.03-0.12c0,0,0-0.01,0-0.01c0.01-0.01,0.01-0.03,0.01-0.04c0,0,0-0.01,0-0.01 c0-0.01,0-0.01-0.01-0.01c-0.01-0.02-0.02-0.04-0.02-0.06c0-0.01,0-0.02-0.01-0.03c0-0.01-0.01-0.03-0.01-0.04 c0-0.01,0-0.01,0-0.02c0.03,0,0.07,0,0.11-0.02c0.05-0.02,0.1-0.05,0.14-0.07c-0.01,0.12,0,0.26,0.08,0.34 c0.03,0.03,0.07-0.03,0.07-0.06l0,0c-0.01-0.09,0-0.19,0.01-0.28c0.07,0.12,0.17,0.23,0.27,0.21c0.02,0,0.08-0.07,0.04-0.08 c-0.06-0.01-0.11-0.08-0.15-0.16c0,0,0,0.01,0.01,0.01c0.11,0.12,0.48,0.42,0.62,0.21c0.02-0.03,0.01-0.07-0.03-0.06 c-0.04,0.01-0.19-0.14-0.22-0.17c-0.03-0.02-0.06-0.05-0.09-0.07c0.11,0.07,0.23,0.14,0.35,0.2c0,0.09,0.01,0.17,0.01,0.24 c0,0.11,0,0.22,0,0.33c0,0,0,0,0,0l0,0c0.01,0.6,0.1,1.16,0.44,1.69c0.26,0.41,0.58,0.83,0.92,1.2c0.07,0.18,0.13,0.38,0.2,0.58 c0.09,0.28,0.32,0.41,0.53,0.58c0.08,0.06,0.13,0.14,0.18,0.22c0.08,0.26,0.19,0.54,0.33,0.78c0.04,0.08,0.09,0.16,0.14,0.23 c0.12,0.29,0.24,0.58,0.31,0.87c0.1,0.45,0.04,0.65-0.31,1c-0.22,0.22-0.45,0.44-0.65,0.68c-0.21,0.26-0.39,0.54-0.59,0.81 c-0.01,0.02-0.03,0.03-0.04,0.05c-0.02,0.01-0.05,0.02-0.07,0.03C41.25,38.61,41.24,38.61,41.23,38.62z M37.66,35.66 c0-0.18,0.01-0.38,0.06-0.58c0.11-0.56,0.13-0.98-0.03-1.48c0.22-0.49,0.56-1.06,0.58-1.61c0.01-0.5-0.11-1.01-0.29-1.47 c-0.06-0.16-0.12-0.31-0.16-0.46c-0.01-0.02-0.01-0.04-0.02-0.06c-0.02-0.07-0.04-0.14-0.05-0.21c0-0.01,0-0.02-0.01-0.03 c-0.02-0.08-0.03-0.16-0.04-0.24c0-0.04-0.01-0.07-0.01-0.11c0.08,0,0.17-0.07,0.23-0.11c0.01-0.01,0.03-0.02,0.04-0.03 c-0.06,0.09-0.12,0.19-0.2,0.24c-0.03,0.02-0.06,0.1,0,0.08c0.1-0.03,0.18-0.11,0.25-0.18c0,0.02,0.01,0.04,0.01,0.06 c0.01,0.08,0.02,0.15,0.03,0.23c0,0.01,0,0.01,0,0.02c0.01,0.07,0.03,0.14,0.05,0.21c0,0.01,0,0.01,0,0.02c0,0,0,0,0,0 c0.32,1.21,1.4,2.37,0.89,3.64c-0.3,0.76-0.96,1.32-1.32,2.05C37.67,35.65,37.67,35.65,37.66,35.66z M46.79,30.63 c-0.16,0.28-0.36,0.52-0.48,0.82c-0.05,0.13-0.05,0.3-0.06,0.44c-0.02,0.26-0.12,0.43-0.25,0.6c-0.31-0.2-0.73-0.29-1.04-0.31 c-0.01,0-0.02,0-0.03,0c0.28-0.36,0.45-0.77,0.4-1.29c-0.02-0.21-0.11-0.41-0.19-0.61c0-0.15,0-0.29-0.01-0.43 c0-0.02,0-0.03,0-0.05c0-0.02,0-0.04,0-0.06c0.1-0.05,0.2-0.12,0.27-0.16c0.04-0.02,0.07-0.05,0.11-0.08 c-0.03,0.07-0.06,0.13-0.09,0.17c-0.02,0.03-0.02,0.09,0.03,0.06c0.09-0.05,0.15-0.14,0.2-0.23c0.07,0.09,0.12,0.17,0.21,0.23 c0.03,0.02,0.08-0.04,0.07-0.07c-0.04-0.08-0.06-0.16-0.09-0.23c0.24,0.07,0.48,0.12,0.72,0.14c-0.27,0.16-0.58,0.31-0.88,0.32 c-0.05,0-0.13,0.11-0.07,0.14c0.34,0.13,0.78-0.05,1.09-0.2c0.05-0.02,0.1-0.05,0.15-0.08c0,0.01,0.01,0.02,0.02,0.02 c-0.01,0.02-0.03,0.03-0.04,0.05c-0.08,0.08-0.2,0.3-0.33,0.27c-0.03-0.01-0.11,0.07-0.07,0.1c0.14,0.08,0.31-0.07,0.42-0.16 c0.03-0.03,0.07-0.06,0.11-0.09c0,0,0,0.01,0,0.01c0,0.02,0.01,0.05,0.01,0.07c-0.02,0.09-0.04,0.18-0.06,0.27 C46.9,30.4,46.85,30.51,46.79,30.63z M45.86,35.56C45.86,35.56,45.86,35.56,45.86,35.56c-0.26,0.1-0.55,0.19-0.79,0.32 c-0.74,0.41-0.97,1.35-1.72,1.69c-0.22,0.1-0.42,0.22-0.61,0.36c0,0,0.01-0.01,0.01-0.01c0.35-0.53,0.69-1.07,0.95-1.66 c0.13-0.31,0.17-0.59,0.12-0.88c0.07-0.37,0.22-0.72,0.51-0.91c0.06-0.03,0.13-0.06,0.21-0.09c0.05-0.02,0.1-0.03,0.15-0.05 c0.05-0.01,0.11-0.01,0.17-0.01c0.21,0,0.49-0.11,0.7-0.24c-0.01,0.17-0.03,0.35-0.03,0.5c0.01,0.25,0.19,0.43,0.31,0.64 c0.02,0.06,0.06,0.12,0.07,0.19c0.01,0.04,0.01,0.09,0.01,0.13C45.89,35.55,45.87,35.56,45.86,35.56z M42.83,33.17 C42.83,33.17,42.83,33.17,42.83,33.17c-0.03-0.04-0.06-0.08-0.08-0.12c-0.03-0.04-0.06-0.08-0.1-0.13 c-0.16-0.2-0.33-0.31-0.54-0.44c-0.24-0.15-0.32-0.67-0.44-0.92c-0.28-0.58-0.87-1.02-0.98-1.68c0.01-0.05,0.03-0.09,0.04-0.14 c0.03,0.01,0.07-0.04,0.08-0.08h0c0,0,0,0,0,0c0,0,0-0.01,0-0.01c0-0.05,0-0.09-0.01-0.14c0.02-0.01,0.03-0.03,0.05-0.05 c0,0,0,0,0,0c0,0.06,0,0.12,0.02,0.17c0.01,0.04,0.04,0.1,0.03,0.14c-0.01,0.05,0.05,0.02,0.06,0c0.03-0.06,0.04-0.14,0.04-0.21 c0.08,0.08,0.17,0.14,0.24,0.19c0.07,0.05,0.33,0.26,0.42,0.14c0.02-0.02,0.02-0.08-0.02-0.05c0,0-0.01-0.01-0.02-0.02 c0.1,0.02,0.2,0.03,0.3,0.01c0,0.02,0,0.04-0.01,0.05c0,0,0,0.01,0,0.01c-0.01,0.1-0.02,0.19-0.02,0.29c0,0,0,0,0,0c0,0,0,0,0,0 c-0.02,0.26-0.02,0.52,0.01,0.79c0.06,0.54,0.27,1.11,0.62,1.54c0,0,0.01,0.01,0.01,0.01c0.02,0.03,0.05,0.06,0.07,0.09 c0,0,0.01,0.01,0.01,0.01c0.04,0.05,0.09,0.09,0.14,0.14c0.01,0.01,0.02,0.02,0.03,0.03c0.02,0.02,0.04,0.03,0.05,0.04 c0.02,0.02,0.04,0.03,0.06,0.05c0.02,0.01,0.03,0.02,0.05,0.03c0.02,0.02,0.05,0.03,0.08,0.05c0.01,0.01,0.03,0.02,0.04,0.03 c0.04,0.02,0.08,0.05,0.12,0.07c0.03,0.01,0.06,0.02,0.08,0.03c-0.13,0.04-0.25,0.09-0.36,0.16 C42.87,33.22,42.85,33.2,42.83,33.17C42.83,33.17,42.83,33.17,42.83,33.17z M43.41,34.43c-0.01-0.01-0.01-0.03-0.02-0.05 c-0.01-0.03-0.03-0.06-0.04-0.09c-0.01-0.03-0.02-0.05-0.03-0.08c-0.01-0.02-0.02-0.04-0.02-0.06c-0.02-0.05-0.03-0.1-0.04-0.15 c-0.04-0.19,0.07-0.37,0.22-0.53c0.19-0.07,0.37-0.14,0.55-0.25c0.02-0.01,0.03-0.02,0.05-0.03c0.42-0.01,0.84-0.03,1.21,0.2 c0.01,0,0.01,0.01,0.02,0.01c-0.08,0.05-0.16,0.09-0.24,0.13c-0.48,0.22-1.08,0.29-1.42,0.77c-0.06,0.09-0.11,0.18-0.16,0.27 c0-0.01-0.01-0.01-0.01-0.02c0,0,0,0,0,0C43.46,34.51,43.44,34.47,43.41,34.43z M43.87,32.11c-0.56-0.09-0.8-0.68-1.04-1.14 c-0.14-0.27-0.22-0.56-0.27-0.87c-0.01-0.08-0.02-0.16-0.03-0.23c0-0.02,0-0.04,0-0.06c0-0.05-0.01-0.11-0.01-0.17 c0.01-0.02,0.02-0.03,0.02-0.05c0,0,0-0.01,0-0.01c0-0.01-0.01-0.02-0.02-0.02c0-0.02,0-0.04,0-0.05c0.13,0.04,0.28,0.06,0.4,0.08 c0.02,0,0.07-0.04,0.04-0.06c-0.09-0.07-0.2-0.11-0.3-0.15c0.22,0.04,0.45,0.07,0.69,0.08c0.04,0,0.09,0,0.14,0.01 c0.25,0.17,0.57,0.18,0.87,0.15c0.01,0.13,0.03,0.26,0.04,0.39l0,0c0.02,0.15,0.03,0.31,0.05,0.46c0.05,0.49,0.13,1.13-0.02,1.65 c-0.01,0.01-0.02,0.02-0.02,0.02C44.22,32.15,44.05,32.14,43.87,32.11z M41.93,29.58c0,0.01,0,0.02,0,0.03 c0,0.03-0.01,0.07-0.01,0.1c-0.07-0.04-0.15-0.07-0.22-0.1C41.77,29.61,41.85,29.6,41.93,29.58z M45.12,29.56 c0.02-0.01,0.04-0.01,0.05-0.02c-0.02,0.01-0.03,0.03-0.05,0.04C45.12,29.58,45.12,29.57,45.12,29.56z M47.56,31.01 C47.56,31.01,47.56,31.01,47.56,31.01c0.01-0.28,0.05-0.55,0.08-0.83c0-0.02,0-0.04,0.01-0.07c0-0.03,0.01-0.06,0.01-0.08 c0-0.03,0.01-0.07,0.01-0.1c0,0,0,0,0-0.01c0.23,0,0.45-0.04,0.67-0.1c0,0.01,0,0.01-0.01,0.02c0,0.01,0,0.01-0.01,0.02 c-0.01,0.04-0.03,0.08-0.04,0.12c0,0.01,0,0.01,0,0.02c-0.02,0.09-0.04,0.19-0.07,0.29c-0.03,0.13-0.07,0.25-0.14,0.36 c-0.14,0.21-0.34,0.29-0.51,0.42C47.55,31.05,47.56,31.03,47.56,31.01z M50.71,29.45c0,0.02,0,0.03,0,0.05 C50.71,29.48,50.71,29.47,50.71,29.45C50.71,29.45,50.71,29.45,50.71,29.45z M24.73,30.92c0,0.03,0.01,0.05,0.01,0.08c0,0,0,0,0,0 c0,0.01-0.01,0.02-0.01,0.03c-0.03-0.02-0.06-0.04-0.09-0.06 M52.03,29.73c-0.06,0.36-0.12,0.72-0.18,1.08 c-0.02-0.01-0.04-0.03-0.06-0.04c-0.13-0.16-0.28-0.3-0.4-0.42c-0.19-0.19-0.38-0.35-0.54-0.57c0.05-0.01,0.12-0.1,0.12-0.14 c0.01-0.17,0.07-0.31,0.14-0.44c0,0.11,0.03,0.22,0.09,0.31c0.05,0.09,0.17-0.05,0.16-0.12c-0.02-0.19,0.03-0.35,0.1-0.52 c0.02,0.01,0.03,0.02,0.05,0.03c0.17,0.05,0.4-0.05,0.61-0.2c0,0,0,0,0,0c-0.01,0.04-0.02,0.07-0.02,0.11 c0,0.02-0.01,0.05-0.01,0.07c-0.01,0.04-0.01,0.07-0.02,0.11c0,0.03-0.01,0.05-0.01,0.08c0,0.03-0.01,0.07-0.01,0.1 c0,0.03,0,0.06-0.01,0.09c0,0.03,0,0.06-0.01,0.09c0,0.03,0,0.07,0,0.1c0,0.03,0,0.05,0,0.08c0,0.04,0,0.09,0,0.13 c0,0.01,0,0.02,0,0.04c0,0,0,0,0,0C52.03,29.7,52.03,29.71,52.03,29.73z M52.47,28.82c0.01-0.05,0.02-0.1,0.03-0.16 c0.07,0,0.16-0.02,0.26-0.05c-0.1,0.11-0.22,0.26-0.27,0.41C52.48,28.95,52.47,28.88,52.47,28.82z M59.14,29.82 c-0.01,0.05-0.02,0.1-0.02,0.16c-0.04,0.02-0.09,0.03-0.13,0.05C59.04,29.95,59.09,29.89,59.14,29.82z M30.21,30.85 c-0.27,0.02-0.53,0-0.78-0.07c-0.01-0.02-0.02-0.05-0.03-0.07c-0.01-0.01-0.01-0.03-0.02-0.04c-0.01-0.02-0.01-0.03-0.02-0.05 c0-0.01-0.01-0.03-0.01-0.04c0-0.01,0-0.02-0.01-0.03c0.02,0.02,0.03,0.03,0.05,0.05c0.03,0.03,0.09,0.08,0.11,0.12 c0.04,0.07,0.13-0.04,0.14-0.08c0.01-0.04,0.01-0.07,0-0.11c0.09,0.04,0.19,0.08,0.29,0.09c0.06,0.01,0.19-0.12,0.12-0.17 c-0.02-0.01-0.03-0.02-0.04-0.04c0.13,0.02,0.26,0.03,0.37,0.04c0.25,0.03,0.69,0.09,0.84-0.19c0.04-0.08,0.04-0.16,0.01-0.26 c0.11,0.01,0.22,0,0.3-0.03c0.03-0.01,0.13-0.12,0.05-0.14c-0.04-0.01-0.06-0.03-0.09-0.05c-0.01-0.01-0.02-0.01-0.03-0.01 c0.08-0.02,0.16-0.04,0.2-0.05c0.06-0.01,0.18-0.17,0.07-0.18c-0.15-0.01-0.3-0.01-0.45,0c-0.03,0-0.06,0-0.08,0 c0.02-0.01,0.03-0.03,0.04-0.04c0,0,0,0,0,0c0,0,0,0,0,0c0.03-0.04,0.05-0.09,0.06-0.14c0.01,0,0.02-0.01,0.03-0.01 c0.1,0.02,0.2,0.04,0.29,0.06c0.07,0.01,0.18-0.1,0.15-0.18c0.02-0.01,0.03-0.03,0.05-0.04c0.03,0.01,0.07,0.01,0.1,0.02 c0.06,0.01,0.14-0.08,0.12-0.14c-0.01-0.01-0.01-0.03-0.02-0.04c0.04,0.02,0.09,0.04,0.14,0.06c-0.03,0.08-0.02,0.16-0.02,0.24 c0,0.1,0.13,0.01,0.15-0.03c0.01-0.02,0.02-0.04,0.02-0.06c0,0,0.01-0.01,0.02-0.03c0.01-0.03,0.03-0.06,0.05-0.08 c0.01,0,0.03,0,0.04,0c0.01,0,0.03,0,0.04,0c-0.01,0.01-0.01,0.03-0.02,0.04c-0.03,0.1,0.07,0.1,0.12,0.04 c0.03-0.04,0.06-0.07,0.1-0.09c0,0,0.01,0,0.01,0c0,0.01,0.01,0.03,0.01,0.04c0,0.01,0,0.02,0,0.03c-0.06,0.12-0.1,0.27,0,0.37 c0.03,0.03,0.07,0.01,0.1-0.03c0.01,0.03,0.02,0.05,0.03,0.08c0.02,0.04,0.04,0.08,0.06,0.12c0.01,0.01,0.02,0.03,0.03,0.04 c0.01,0.01,0.02,0.03,0.03,0.04c0,0,0,0,0,0c0.18,0.28,0.45,0.53,0.68,0.73c0.04,0.04,0.08,0.07,0.12,0.11c0,0.01,0,0.01,0,0.01 c0.09,0.1,0.18,0.24,0.25,0.38c0,0,0,0,0,0c-0.3-0.3-0.82-0.39-1.22-0.39C31.88,30.64,31.06,30.78,30.21,30.85z M52.53,29.66 c-0.01-0.11-0.01-0.22-0.02-0.33c0,0,0,0,0,0c0.06,0.04,0.15-0.06,0.17-0.12c0.03-0.09,0.09-0.18,0.17-0.26 c-0.02,0.07-0.03,0.13-0.03,0.2c0,0,0,0,0,0c0,0.02,0,0.03,0.01,0.05c0,0,0,0,0,0c-0.11,0.21-0.19,0.44-0.28,0.69 c0-0.02,0-0.05,0-0.07c0,0,0,0,0,0C52.54,29.77,52.54,29.72,52.53,29.66z M62.39,30.69c0.02,0,0.03,0.01,0.05,0.01 c-0.04,0.08-0.09,0.15-0.13,0.22c0,0-0.01,0-0.01,0c-0.02,0-0.04-0.01-0.07-0.01C62.28,30.86,62.33,30.78,62.39,30.69z  M27.39,31.52C27.39,31.52,27.39,31.52,27.39,31.52c-0.02-0.02-0.04-0.04-0.06-0.05c-0.04-0.04-0.08-0.09-0.11-0.14 c-0.02-0.03-0.05-0.06-0.07-0.1c-0.02-0.03-0.04-0.05-0.06-0.08c-0.01-0.01-0.02-0.03-0.02-0.04c0.19-0.06,0.38-0.2,0.54-0.29 c-0.05,0.06-0.1,0.12-0.15,0.18c-0.02,0.02-0.07,0.12,0,0.11c0.09-0.01,0.14-0.06,0.21-0.12c0.14-0.15,0.29-0.28,0.43-0.42 c0.04-0.04,0.08-0.09,0.13-0.14c-0.03,0.11-0.03,0.22-0.04,0.33c0,0.09,0.12-0.01,0.14-0.05c0.01-0.02,0.02-0.05,0.02-0.07 c0,0.01,0,0.01,0.01,0.02c0,0.01,0.01,0.02,0.01,0.03c0.01,0.02,0.02,0.05,0.02,0.07c0,0,0,0.01,0,0.01 c0.01,0.02,0.01,0.04,0.02,0.06c0,0,0,0.01,0,0.01c0,0,0,0.01,0.01,0.01c0,0,0,0,0,0.01c0.01,0.04,0.03,0.07,0.05,0.11 c0,0.01,0.01,0.02,0.01,0.03c0.08,0.15,0.18,0.28,0.32,0.39c0.03,0.03,0.07,0.05,0.1,0.07c0.01,0.01,0.02,0.01,0.04,0.02 c0.02,0.01,0.05,0.03,0.07,0.04c0.01,0.01,0.03,0.01,0.04,0.02c0.03,0.01,0.06,0.03,0.1,0.04c0.05,0.02,0.1,0.03,0.15,0.04 c-0.15,0.1-0.31,0.19-0.48,0.24C28.39,31.97,27.75,31.84,27.39,31.52z M33.52,29.55c-0.01-0.01-0.02-0.02-0.03-0.04 c0-0.02,0-0.04,0-0.05c0.02-0.03,0.05-0.06,0.07-0.09C33.54,29.44,33.52,29.49,33.52,29.55z M57.38,30.13c0,0.01,0,0.01,0,0.02 c-0.01,0-0.02,0.01-0.03,0.02C57.36,30.16,57.37,30.15,57.38,30.13z M62.13,30.62c0.01,0,0.02,0.01,0.03,0.01 c-0.03,0.09-0.05,0.17-0.08,0.26c-0.03,0-0.06-0.01-0.09-0.01c-0.01,0-0.02,0-0.02,0C62.02,30.8,62.08,30.71,62.13,30.62z  M59.73,30.5C59.73,30.5,59.73,30.5,59.73,30.5c0.02-0.02,0.04-0.03,0.05-0.05c0.04-0.04,0.08-0.08,0.12-0.12 c0.01-0.01,0.02-0.03,0.03-0.04c0,0,0,0,0,0.01c0.03,0.09,0.13,0.15,0.15,0.24c0,0,0,0,0,0c0,0.03,0.04,0.04,0.08,0.01 c0.11-0.08,0.11-0.23,0.11-0.36c0-0.05,0-0.1,0-0.14c0.26,0.27,0.56,0.45,0.88,0.31c0.02-0.01,0.05-0.02,0.07-0.04 c0.02,0.04,0.05,0.08,0.07,0.12c0.07,0.13,0.19,0.26,0.33,0.17c0.05-0.03,0.11-0.16,0.04-0.17c-0.01-0.02-0.03-0.04-0.04-0.07 c0.07,0.05,0.15,0.1,0.23,0.14c-0.02,0.11-0.05,0.23-0.1,0.34c-0.07-0.01-0.14-0.02-0.21-0.03c0,0,0,0,0,0 c-0.63-0.09-1.3-0.17-1.89,0.02h0c0,0,0,0,0,0c-0.04,0.01-0.08,0.03-0.12,0.04c-0.01,0.01-0.03,0.01-0.04,0.02 c-0.03,0.01-0.06,0.03-0.09,0.04c-0.03,0.01-0.05,0.03-0.07,0.04c-0.02,0.01-0.05,0.02-0.07,0.04c-0.05,0.03-0.1,0.06-0.14,0.09 c-0.03,0.02-0.06,0.05-0.09,0.07c-0.08,0.06-0.17,0.13-0.24,0.2c0.02-0.04,0.05-0.08,0.07-0.13C59.14,31,59.45,30.77,59.73,30.5z  M61.19,31.58c-0.15,0.02-0.3,0.04-0.46,0.05c-0.1-0.01-0.2-0.01-0.3-0.02C60.69,31.6,60.94,31.59,61.19,31.58z M19.97,32.87 c-0.28-0.08-0.5-0.22-0.69-0.4c-0.05-0.05-0.09-0.09-0.13-0.14c-0.02-0.02-0.03-0.04-0.05-0.06c-0.03-0.03-0.05-0.07-0.08-0.1 c-0.02-0.02-0.03-0.05-0.05-0.07c-0.02-0.04-0.05-0.07-0.07-0.11c-0.01-0.02-0.03-0.04-0.04-0.06c-0.03-0.06-0.07-0.11-0.1-0.17 c0,0,0,0,0,0c0-0.01-0.01-0.01-0.01-0.02c0.05-0.01,0.1-0.03,0.15-0.05c-0.02,0.03-0.02,0.06,0.02,0.07 c0.33,0.1,0.61-0.08,0.9-0.23c0.04-0.02,0.08-0.04,0.12-0.07c-0.05,0.06-0.1,0.12-0.16,0.18c-0.06,0.07-0.02,0.16,0.07,0.1 c0.16-0.12,0.29-0.25,0.45-0.37c0,0,0,0.01,0,0.01c0,0,0,0.01,0,0.01c-0.04,0.04-0.08,0.08-0.13,0.12 c-0.04,0.03-0.09,0.14-0.01,0.14c0.05,0,0.11-0.01,0.16-0.03c0.07,0.48,0.16,0.94,0.3,1.37C20.41,32.96,20.18,32.94,19.97,32.87z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.97,50.84c0.09,0.13,0.36,0.54,0.57,1.1c0,0,0.31,0.91,0.04,1.15c0,0-0.1,0.1-0.23,0.02c0,0-0.08-0.08-0.07-0.13 c0,0,0.03-0.09,0.1-0.07c0,0,0.15,0.02,0.17-0.17c0,0-0.05-0.65-0.3-1.16"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M38.25,46.74c0.06,0.06,0.36,0.41,0.53,0.45l0.46,0.06c0,0,0.18-0.01,0.27-0.04c0.03-0.06,0.03-0.15,0.04-0.2 c0.02-0.07,0.04-0.14,0.09-0.17c0.05-0.03,0.2-0.03,0.22,0.04c0.02,0.07-0.09,0.15-0.11,0.21c0.03,0.08-0.08,0.32-0.08,0.32 c-0.07,0.16-0.17,0.15-0.17,0.15c-0.06,0-0.69,0.19-0.69,0.19c-0.07,0.02-0.2,0.1-0.2,0.1c-0.05,0.04-0.16-0.02-0.16-0.02 c-0.04-0.02-0.43-0.03-0.47-0.01"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.05,51.19l-0.3-0.67c0,0-0.27-0.61-0.11-1.25l0.12-0.42c0,0,0.13-0.42,0.29-0.63c0,0,0.3-0.38,0.38-0.55 c0,0,0.3-0.54,0.55-0.85c0,0,0.22-0.31,0.34-0.53c-0.01-0.11-0.01-0.41,0.22-0.63l0.08-0.05c0.04-0.08,0.09-0.18,0.18-0.26 c0.06-0.14,0.3-0.68,0.5-0.92c0.01-0.02,0.01-0.05,0-0.09c-0.01-0.06-0.04-0.1-0.01-0.17c0.04-0.11,0.12-0.07,0.19-0.01 c0.1-0.08,0.34-0.25,0.51-0.15c0,0,0.1,0.06,0.21,0.05c0,0,0.15-0.04,0.14,0.19c0.05,0.09,0.03,0.19,0.01,0.24 c0,0.06-0.01,0.17-0.1,0.24c0,0-0.16,0.15-0.26,0.37c0,0-0.17,0.44-0.27,0.62c0.05,0.07,0.33,0.48,0.5,0.53l0.48,0.11 c0,0,0.19,0.01,0.28-0.01c0-0.06,0.04-0.15,0.06-0.2c0.03-0.07,0.06-0.15,0.11-0.17c0.05-0.03,0.18-0.02,0.19,0.06 c0.01,0.07-0.04,0.18-0.06,0.24c0.03,0.09-0.16,0.31-0.16,0.31c-0.09,0.16-0.19,0.14-0.19,0.14c-0.06,0-0.75,0.12-0.75,0.12 c-0.08,0.01-0.22,0.08-0.22,0.08c-0.06,0.04-0.17-0.03-0.17-0.03c-0.04-0.02-0.14,0-0.19,0.01c-0.05,0.27-0.08,0.27-0.14,0.4 c0,0.06-0.23,0.63-0.23,0.61c-0.22,0.48-1.04,1.38-1.2,1.5c0.06,0.11,0.27,0.5,0.43,1.05c0,0,0.14,0.37,0.28,0.39 c0,0,0.12,0,0.21-0.02c0.03-0.14,0.07-0.31,0.18-0.3c0.1,0.01,0.12,0.15,0.08,0.26c0.01,0.09-0.06,0.23-0.09,0.27 c-0.05,0.05-0.1,0.08-0.15,0.1l-0.08,0.05c-0.15,0.07-0.45,0-0.45,0c-0.11-0.01-0.15-0.16-0.15-0.16 c-0.08-0.19-0.34-0.42-0.44-0.5c-0.01,0.14-0.03,0.62-0.06,0.85c0,0-0.05,0.46,0.07,0.7l0.31,0.64c0,0,0.13,0.2,0.1,0.3 c0,0-0.03,0.08-0.08,0.06c-0.06,0.04-0.13-0.08-0.14-0.16c-0.03-0.03-0.07-0.09-0.1-0.14c-0.05-0.07-0.1-0.15-0.1-0.15"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st629",
    d: "M25.77,62.08h-0.53l-1.5-3.73h0.46l1.31,3.3l1.31-3.3h0.44L25.77,62.08z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st629",
    d: "M31.17,62.08h-0.46l-0.42-1.04h-1.85l-0.42,1.04h-0.44l1.53-3.73h0.53L31.17,62.08z M28.61,60.63h1.52 l-0.76-1.86L28.61,60.63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st629",
    d: "M33.81,58.29c0.16,0,0.32,0.02,0.47,0.05c0.15,0.04,0.29,0.09,0.42,0.15c0.13,0.07,0.25,0.15,0.36,0.24 c0.11,0.1,0.2,0.2,0.27,0.32l-0.36,0.24c-0.06-0.09-0.13-0.18-0.22-0.25c-0.08-0.07-0.17-0.14-0.27-0.19 c-0.1-0.05-0.21-0.09-0.32-0.12c-0.11-0.03-0.23-0.04-0.35-0.04c-0.21,0-0.4,0.04-0.58,0.11c-0.18,0.07-0.34,0.18-0.47,0.31 c-0.13,0.13-0.24,0.29-0.31,0.48c-0.08,0.19-0.11,0.39-0.11,0.61c0,0.22,0.04,0.43,0.11,0.61c0.08,0.19,0.18,0.34,0.31,0.48 c0.13,0.13,0.29,0.23,0.47,0.31c0.18,0.07,0.37,0.11,0.58,0.11c0.25,0,0.47-0.05,0.67-0.16c0.2-0.1,0.36-0.25,0.49-0.44 l0.35,0.26c-0.08,0.12-0.17,0.22-0.28,0.31c-0.11,0.09-0.22,0.17-0.35,0.24c-0.13,0.07-0.27,0.12-0.42,0.15s-0.3,0.05-0.46,0.05 c-0.28,0-0.53-0.05-0.77-0.14c-0.24-0.09-0.44-0.23-0.61-0.4c-0.17-0.17-0.31-0.37-0.4-0.61c-0.1-0.23-0.15-0.49-0.15-0.77 c0-0.28,0.05-0.54,0.15-0.77c0.1-0.23,0.23-0.44,0.4-0.61c0.17-0.17,0.37-0.3,0.61-0.4C33.27,58.34,33.53,58.29,33.81,58.29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st629",
    d: "M37,60h2.26v-1.65h0.43v3.73h-0.43V60.4H37v1.68h-0.43v-3.73H37V60z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st629",
    d: "M43.78,62.08h-2.62v-3.73h2.6v0.4h-2.17V60h2.1v0.4h-2.1v1.28h2.19V62.08z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st629",
    d: "M47.73,62.08h-2.59v-3.73h0.43v3.32h2.16V62.08z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st629",
    d: "M51.36,62.08h-2.59v-3.73h0.43v3.32h2.16V62.08z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st629",
    d: "M52.84,62.08h-0.43v-3.73h0.43V62.08z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st629",
    d: "M57.46,62.08H57l-0.42-1.04h-1.85l-0.42,1.04h-0.44l1.53-3.73h0.53L57.46,62.08z M54.9,60.63h1.52 l-0.76-1.86L54.9,60.63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st629",
    d: "M26.15,63.67c0.21,0,0.4,0.02,0.56,0.07c0.16,0.05,0.3,0.11,0.41,0.2c0.11,0.09,0.19,0.2,0.25,0.33 c0.06,0.13,0.09,0.28,0.09,0.45c0,0.16-0.03,0.31-0.09,0.44c-0.06,0.13-0.15,0.24-0.26,0.33c-0.11,0.09-0.25,0.16-0.41,0.21 c-0.16,0.05-0.34,0.07-0.54,0.07H26.1l1.34,1.62h-0.53l-1.31-1.62h-0.47v1.62h-0.43v-3.73H26.15z M25.12,64.08v1.32h1.03 c0.29,0,0.5-0.06,0.65-0.17c0.14-0.11,0.22-0.28,0.22-0.5c0-0.22-0.07-0.38-0.22-0.49c-0.15-0.11-0.36-0.16-0.64-0.16H25.12z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st629",
    d: "M31.32,67.4H28.7v-3.73h2.6v0.4h-2.17v1.25h2.1v0.4h-2.1V67h2.19V67.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st629",
    d: "M35.12,64.38c-0.15-0.1-0.32-0.19-0.51-0.25c-0.19-0.07-0.39-0.1-0.62-0.1c-0.14,0-0.27,0.02-0.39,0.05 c-0.12,0.03-0.22,0.08-0.3,0.13c-0.09,0.06-0.15,0.13-0.2,0.21c-0.05,0.08-0.07,0.18-0.07,0.28c0,0.17,0.07,0.31,0.21,0.41 c0.14,0.1,0.36,0.16,0.65,0.2l0.35,0.04c0.15,0.02,0.3,0.05,0.44,0.09c0.14,0.04,0.26,0.1,0.37,0.18 c0.11,0.08,0.19,0.17,0.26,0.29c0.06,0.12,0.1,0.25,0.1,0.42c0,0.18-0.04,0.35-0.12,0.49c-0.08,0.14-0.18,0.26-0.32,0.35 c-0.13,0.09-0.29,0.17-0.47,0.21c-0.18,0.05-0.37,0.07-0.57,0.07c-0.13,0-0.27-0.01-0.41-0.03c-0.14-0.02-0.27-0.06-0.4-0.1 c-0.13-0.04-0.25-0.09-0.36-0.15c-0.11-0.06-0.21-0.12-0.3-0.2l0.23-0.34c0.06,0.06,0.14,0.11,0.23,0.16 c0.09,0.05,0.19,0.09,0.3,0.13c0.11,0.04,0.22,0.07,0.34,0.09c0.12,0.02,0.24,0.03,0.36,0.03c0.14,0,0.28-0.01,0.4-0.04 c0.13-0.03,0.24-0.07,0.33-0.13c0.09-0.06,0.17-0.13,0.22-0.21c0.05-0.08,0.08-0.18,0.08-0.29c0-0.18-0.08-0.32-0.23-0.42 c-0.15-0.1-0.38-0.16-0.67-0.19l-0.38-0.04c-0.16-0.02-0.31-0.05-0.44-0.1c-0.13-0.05-0.25-0.11-0.35-0.19 c-0.1-0.08-0.17-0.18-0.23-0.29c-0.06-0.12-0.08-0.25-0.08-0.4c0-0.18,0.04-0.33,0.11-0.47c0.07-0.14,0.17-0.25,0.3-0.35 s0.28-0.17,0.45-0.21c0.17-0.05,0.35-0.07,0.55-0.07c0.14,0,0.28,0.01,0.4,0.03c0.13,0.02,0.24,0.05,0.35,0.08 c0.11,0.04,0.21,0.08,0.31,0.13c0.1,0.05,0.19,0.1,0.27,0.17L35.12,64.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st629",
    d: "M39.29,67.4h-2.62v-3.73h2.6v0.4H37.1v1.25h2.1v0.4h-2.1V67h2.19V67.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st629",
    d: "M43.81,67.4h-0.46l-0.42-1.04h-1.85l-0.42,1.04h-0.44l1.53-3.73h0.53L43.81,67.4z M41.25,65.96h1.52 l-0.76-1.86L41.25,65.96z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st629",
    d: "M46.3,63.67c0.21,0,0.4,0.02,0.56,0.07c0.16,0.05,0.3,0.11,0.41,0.2c0.11,0.09,0.19,0.2,0.25,0.33 s0.09,0.28,0.09,0.45c0,0.16-0.03,0.31-0.09,0.44c-0.06,0.13-0.15,0.24-0.26,0.33c-0.11,0.09-0.25,0.16-0.41,0.21 c-0.16,0.05-0.34,0.07-0.54,0.07h-0.06l1.34,1.62h-0.53l-1.31-1.62h-0.47v1.62h-0.43v-3.73H46.3z M45.27,64.08v1.32h1.03 c0.29,0,0.5-0.06,0.65-0.17c0.14-0.11,0.22-0.28,0.22-0.5c0-0.22-0.07-0.38-0.22-0.49c-0.15-0.11-0.36-0.16-0.64-0.16H45.27z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st629",
    d: "M50.55,63.62c0.16,0,0.32,0.02,0.47,0.05c0.15,0.04,0.29,0.09,0.42,0.15c0.13,0.07,0.25,0.15,0.36,0.24 c0.11,0.1,0.2,0.2,0.27,0.32l-0.36,0.24c-0.06-0.09-0.13-0.18-0.22-0.25c-0.08-0.07-0.17-0.14-0.27-0.19 c-0.1-0.05-0.21-0.09-0.32-0.12c-0.11-0.03-0.23-0.04-0.35-0.04c-0.21,0-0.4,0.04-0.58,0.11c-0.18,0.07-0.34,0.18-0.47,0.31 c-0.13,0.13-0.24,0.29-0.31,0.48c-0.08,0.19-0.11,0.39-0.11,0.61s0.04,0.43,0.11,0.61c0.08,0.19,0.18,0.34,0.31,0.48 c0.13,0.13,0.29,0.23,0.47,0.31c0.18,0.07,0.37,0.11,0.58,0.11c0.25,0,0.47-0.05,0.67-0.16s0.36-0.25,0.49-0.44l0.35,0.26 c-0.08,0.12-0.17,0.22-0.28,0.31c-0.11,0.09-0.22,0.17-0.35,0.24c-0.13,0.07-0.27,0.12-0.42,0.15s-0.3,0.05-0.46,0.05 c-0.28,0-0.53-0.05-0.77-0.14c-0.24-0.09-0.44-0.23-0.61-0.4c-0.17-0.17-0.31-0.37-0.4-0.61c-0.1-0.23-0.15-0.49-0.15-0.77 c0-0.28,0.05-0.54,0.15-0.77c0.1-0.23,0.23-0.44,0.4-0.61c0.17-0.17,0.37-0.3,0.61-0.4C50.02,63.67,50.28,63.62,50.55,63.62z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st629",
    d: "M53.75,65.32H56v-1.65h0.43v3.73H56v-1.68h-2.26v1.68h-0.43v-3.73h0.43V65.32z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st630",
    d: "M40.56,76.02c-19.82,0-35.95-16.13-35.95-35.95c0-19.82,16.13-35.95,35.95-35.95 c19.82,0,35.95,16.13,35.95,35.95C76.52,59.89,60.39,76.02,40.56,76.02z M40.56,5C21.23,5,5.5,20.73,5.5,40.07 s15.73,35.06,35.06,35.06S75.63,59.4,75.63,40.07S59.9,5,40.56,5z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.47,17.48c0.48-0.02,0.96-0.02,1.44,0c0.03-0.06,0.09-0.09,0.16-0.1c0.06-0.01,0.13-0.01,0.19-0.02 c0.21-0.04,0.34-0.25,0.46-0.42c0.34-0.48,0.85-0.84,1.42-1c-0.01,0.05-0.05,0.09-0.1,0.1c-0.02,0.05-0.03,0.09-0.05,0.14 c-0.04,0.03-0.08,0.06-0.13,0.09c0.02,0.01,0.03,0.02,0.05,0.03c-0.04,0.06-0.1,0.1-0.17,0.11c0.01,0.02,0.02,0.03,0.03,0.05 c-0.05,0.02-0.09,0.05-0.14,0.07c0.01,0.01,0.02,0.03,0.04,0.04c-0.13,0.06-0.22,0.18-0.31,0.29c-0.21,0.28-0.41,0.55-0.62,0.83 c0.02,0.07,0.1,0.12,0.17,0.13c0.07,0.02,0.15,0,0.23-0.01c0.09-0.01,0.18-0.03,0.27-0.04c0.02,0.03,0.03,0.06,0.03,0.1 c0,0.03-0.02,0.07-0.05,0.08c0.04,0.02,0.01,0.1-0.04,0.09c0.05,0.04,0.01,0.13-0.05,0.13c0.04,0.05,0.02,0.13-0.03,0.18 c-0.05,0.05-0.11,0.07-0.17,0.09c-0.02,0.05-0.08,0.09-0.14,0.08c-0.1,0.09-0.24,0.13-0.37,0.1c-0.06,0.07-0.18,0.05-0.24-0.02 c-0.06-0.07-0.07-0.17-0.05-0.25c0.02-0.09,0.07-0.16,0.12-0.24c-0.1-0.11-0.21-0.22-0.31-0.33c-0.02-0.02-0.03-0.04-0.06-0.04 c-0.04-0.01-0.08,0.02-0.09,0.06c-0.02,0.04-0.01,0.08-0.01,0.12c-0.01-0.06-0.03-0.13-0.04-0.19c-0.44-0.25-1.03-0.03-1.49-0.26 c0.02,0,0.04,0,0.06-0.01"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.91,16.51l-1.3-0.08c-0.04,0-0.07,0-0.11,0.01c-0.12,0.04-0.14,0.19-0.13,0.3c-0.04-0.14-0.09-0.28-0.08-0.43 c0.01-0.15,0.09-0.3,0.23-0.38c0.07-0.03,0.14-0.05,0.2-0.1c0.09-0.09,0.05-0.23-0.03-0.32c-0.25-0.28-0.74-0.23-1.09-0.4 c-0.31-0.16-0.47-0.5-0.4-0.83c0.03,0.02,0.06,0.04,0.09,0.06c0-0.04,0.04-0.08,0.08-0.08c0.04,0,0.08,0.04,0.07,0.08 c0.08-0.04,0.19,0.02,0.18,0.1l0.11-0.02c0.03,0.02,0.03,0.06,0.01,0.09c0.04,0,0.08-0.01,0.12-0.01c0.09,0.02,0.17,0.05,0.24,0.1 c0.24,0.01,0.39,0.25,0.61,0.32c0.17,0.05,0.38,0,0.55,0.05c0.28,0.09,0.39,0.43,0.68,0.5c0.09,0.02,0.22,0.03,0.23,0.12 c0,0.03-0.01,0.06,0,0.09c0.01,0.06,0.09,0.08,0.15,0.08c0.06,0,0.13-0.03,0.19-0.02c0.12,0.01,0.2,0.12,0.27,0.21 c0.17,0.21,0.4,0.38,0.66,0.49c0.08,0.04,0.17,0.06,0.26,0.09c0.06,0,0.09,0.07,0.04,0.11c0.08-0.02,0.17,0.03,0.19,0.1 c0.06-0.03,0.12,0.06,0.07,0.1c0.06-0.03,0.14-0.01,0.17,0.05c0.09,0.05,0.18,0.11,0.27,0.16l-0.1,0.02 c0.03,0.02,0.05,0.05,0.08,0.07c-0.05,0.05-0.12,0.07-0.19,0.05c0.04,0,0.09,0.02,0.11,0.05c-0.12,0.08-0.29,0.05-0.43,0.02 c-0.64-0.16-1.28-0.33-1.84-0.64c-0.1-0.06-0.1-0.06-0.21-0.1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.6e1dc47b4f000f72d0a733966800de9f.svg";
export { ForwardRef as ReactComponent };